// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../omega/css/fonts/fontawesome-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../omega/css/fonts/fontawesome-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../omega/css/fonts/fontawesome-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../omega/css/fonts/fontawesome-webfont.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../omega/css/fonts/fontawesome-webfont.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.omega-form-group {
    max-width: 550px;
    padding: 20px 25px 25px;
}
.omega-button.approve {
    border-color: #238d45;
    background-color: #167e38;
    color: #fff;
}
.omega-button.approve:focus {
    border-color: #1a6533;
    box-shadow: 0 0 8px #2caa55;
}
.omega-button.approve:hover:not([disabled]) {
    border-color: #1a6533;
    background-color: #228141;
}
.omega-button.reject {
    border-color: #b41212;
    background-color: #c51818;
    color: #fff;
}
.omega-button.reject:focus {
    border-color: #981718;
    box-shadow: 0 0 8px #ee3a3b;
}
.omega-button.reject:hover:not([disabled]) {
    border-color: #970809;
    background-color: #d00c0d;
}
.omega-button.primary {
    border: 1px #2d6da3;
    background-color: #0070b7;
    color: #fff;
}
.omega-button.primary:focus {
    border-color: #204d73;
    box-shadow: 0 0 8px 0 #337ab7;
}
.omega-button.primary:hover:not([disabled]) {
    border-color: #204d73;
    background-color: #285f8f;
}
.omega-button.secondary {
    border: 1px solid #337ab7;
    background-color: #fff;
    color: #337ab7;
}
.omega-button.secondary:focus {
    box-shadow: 0 0 6px 0 #66afe9;
}
.omega-button.secondary:hover:not([disabled]) {
    border-color: #204d73;
    color: #204d73;
}
.omega-button.secondary:disabled {
    color: #888;
}
.omega-button.icon {
    padding: 10px 8px;
    border: 1px solid transparent;
    background-color: #fff;
    color: #0070b7;
}
.omega-button.icon i {
    line-height: 16px;
}
.omega-button.icon i + .omega-button-label {
    margin-left: 0.5ex;
}
.omega-button.icon:not(.labelled) {
    min-width: 1px;
    padding: 10px 12px;
    margin-right: 0;
    margin-left: 0;
}
.omega-button.icon:focus,
.omega-button.icon:hover:not(:disabled) {
    background-color: #e6f0fa;
}
.omega-button:disabled.has-errors {
    padding: 0;
    background: none;
    opacity: 1;
}
.omega-button.has-errors > .omega-button-label {
    display: inline-block;
    padding: 10px 20px;
    margin: 0;
    background-color: #337ab7;
    font-size: 1em;
    line-height: 16px;
    opacity: 0.65;
}
.omega-button.has-errors > i {
    display: inline-block;
    width: 35px;
    padding: 10px 0;
    margin: 0;
    background-color: #337ab7;
    font-size: 1em;
    line-height: 16px;
    text-align: center;
}
.omega-button {
    min-width: 90px;
    padding: 10px 20px;
    margin: 8px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    font-size: 1em;
    font-weight: 400;
    line-height: 16px;
    outline: none;
}
.omega-button[disabled] {
    opacity: 0.65;
}
.omega-button:enabled {
    cursor: pointer;
}
.omega-button.small {
    min-width: 0;
    padding: 10px;
    margin: 10px 2px;
    line-height: 8px;
}
.omega-button-label {
    text-align: center;
}
.omega-checkbox {
    position: absolute;
    opacity: 0;
}
.omega-checkbox-label {
    position: relative;
    padding: 3px;
    cursor: pointer;
    font-weight: 400;
    vertical-align: bottom;
}
.omega-checkbox-label:hover {
    background: rgb(228, 222, 222);
}
.omega-checkbox-label::before {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-left: 5px;
    border: 1px solid rgb(216, 210, 210);
    background: white;
    border-radius: 3px;
    content: '';
    vertical-align: text-top;
}
.omega-single-select-override .omega-checkbox-label::before,
.omega-single-select-override .omega-checkbox-label::after {
    display: none;
}
.omega-checkbox:focus + .omega-checkbox-label::before {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
}
.omega-single-select-override .omega-checkbox:focus + .omega-checkbox-label::before {
    box-shadow: none;
}
.omega-checkbox:checked + .omega-checkbox-label::before {
    background: #4389cb;
}
.omega-single-select-override .omega-checkbox:checked + .omega-checkbox-label {
    background: #ece8e5;
}
.omega-checkbox:disabled + .omega-checkbox-label {
    color: #b8b8b8;
    cursor: auto;
}
.omega-checkbox:disabled + .omega-checkbox-label::before {
    background: #ddd;
    box-shadow: none;
}
.omega-checkbox:checked + .omega-checkbox-label::after {
    position: absolute;
    top: 15px;
    left: 10px;
    width: 2px;
    height: 2px;
    background: white;
    box-shadow:
        2px 0 0 white,
        4px 0 0 white,
        4px -2px 0 white,
        4px -4px 0 white,
        4px -6px 0 white,
        4px -8px 0 white;
    content: '';
    transform: rotate(45deg);
}
.omega-form-field {
    position: relative;
    display: flex;
    max-width: 800px;
    flex-flow: row wrap;
    margin: 15px 0;
}
.omega-form-label-box {
    min-width: 200px;
}
.omega-form-label-box > label::after {
    content: ':';
}
.omega-form-input-box {
    position: relative;
    display: block;
    min-width: 250px;
    flex: 3 1;
}
.omega-form-field input:not([type='checkbox']):not([type='radio']) {
    width: 100%;
    height: 32px;
    padding: 3px 12px;
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 3px;
    font-size: 13px;
    line-height: 18px;
}
.omega-form-field input:focus {
    border: 1px solid #66afe9;
    box-shadow: 0 2px 4px 0 rgba(102, 175, 233, 0.6);
}
.omega-form-field input:disabled,
.omega-form-field select:disabled,
.omega-form-field button:disabled {
    opacity: 0.6;
}
.omega-form-field [aria-invalid='true'] {
    border-color: #cc1010;
    background-color: rgba(204, 16, 16, 0.03);
}
.omega-form-field .omega-multiple-select[aria-invalid='true'] .omega-multiple-select-button {
    border: 1px solid #cc1010;
    background-color: rgba(204, 16, 16, 0.03);
}
.omega-required-field-indicator {
    color: #ee3a3b;
}
.omega-form-input-box .has-annotation,
.omega-form-input-box .has-lookup {
    display: flex;
}
.omega-form-input-box .has-lookup input {
    width: 265px;
}
.omega-form-input-box .has-annotation input {
    width: 240px;
}
.omega-form-input-box .has-lookup input,
.omega-form-input-box .has-annotation input {
    border-right: none;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.omega-form-input-annotation {
    width: 60px;
    margin: 0;
    border: 1px solid #ccc;
    background-color: #eee;
    border-radius: 0 3px 3px 0;
    font-size: 13px;
    font-weight: 400px;
    line-height: 30px;
    text-align: center;
    vertical-align: middle;
}
.omega-form-search-button {
    width: 35px;
    margin: 0;
    border: 1px solid #ccc;
    background-color: #eee;
    border-radius: 0 3px 3px 0;
    font-size: 13px;
    text-align: center;
    vertical-align: middle;
}
.omega-select {
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    margin-bottom: 3px;
    border: 1px solid rgb(199, 199, 199);
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    background: var(--omega-dropdown-arrow) right 4px center no-repeat #fff;
    background-size: 12px 12px;
    border-radius: 5px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    font-size: 14px;
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
}
.omega-select-wrapper[role='listbox'] {
    position: relative;
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    margin: 0 auto;
    border: 1px solid rgb(199, 199, 199);
    background-color: #fff;
    border-radius: 3px;
    cursor: pointer;
}
.omega-select-wrapper::after {
    position: absolute;
    top: 50%;
    right: 1rem;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-width: 6px 6px 0;
    border-style: solid;
    border-color: #4b4742 transparent;
    content: '';
}
.omega-select-wrapper[aria-disabled='true'] {
    opacity: 0.65;
}
.omega-select-wrapper .omega-select-drop-list {
    position: absolute;
    z-index: 3;
    top: 100%;
    right: 0;
    left: 0;
    display: none;
    max-height: 195px;
    padding: 0;
    margin-top: 0;
    background: #fff;
    border-radius: 0 0 3px 3px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
    list-style: none;
    overflow-y: scroll;
    pointer-events: none;
}
.omega-select-wrapper .omega-select-drop-list li {
    display: block;
    height: 28px;
    padding: 5px;
    border-radius: 0 0 3px 3px;
    color: #181818;
    text-decoration: none;
}
.omega-select-wrapper span {
    display: block;
    width: 100%;
    text-align: left;
}
.omega-select-wrapper .omega-select-drop-list li[aria-selected='true'] {
    background-color: #ece8e5;
}
.omega-select-wrapper .omega-select-drop-list li:hover {
    background-color: #ece8e5;
}
.omega-select-wrapper.active::after {
    border-width: 0 6px 6px;
}
.omega-select-wrapper.active .omega-select-drop-list {
    display: block;
    margin-top: 1px;
    border-right: 1px solid rgb(214, 209, 209);
    border-bottom: 1px solid rgb(214, 209, 209);
    border-left: 1px solid rgb(214, 209, 209);
    opacity: 1;
    pointer-events: auto;
}
.omega-form-field .omega-date-range-from-to {
    display: flex;
    align-items: baseline;
    clear: both;
}
.omega-form-field .omega-date-range-from-to input {
    width: auto;
    flex: 10 1;
    align-content: space-between;
    margin: 0;
}
.omega-form-field .omega-date-range-to-label {
    flex: 2 1;
    margin: 0 5px;
    text-align: right;
}
.omega-form-field .omega-amount-range-from-to {
    display: flex;
    align-items: baseline;
    clear: both;
}
.omega-form-field .omega-amount-range-from-to input {
    width: auto;
    flex: 10 1;
    align-content: space-between;
}
.omega-form-field .omega-amount-range-to-label {
    flex: 2 1;
    margin: 0 5px;
    text-align: right;
}
.omega-amount-range .omega-select {
    text-transform: capitalize;
}
.omega-toggle {
    width: 50px;
    height: 28px;
    background-color: #ccc;
    border-radius: 14px;
}
.omega-toggle-indicator {
    display: block;
    width: 24px;
    height: 24px;
    background-color: white;
    border-radius: 12px;
    transform: translate(2px, 2px);
    transition: transform 0.2s;
}
.omega-toggle:not(:disabled):hover {
    cursor: pointer;
}
.omega-toggle:focus {
    outline: none;
}
.omega-toggle-checkbox:focus + .omega-toggle,
.omega-toggle:focus {
    box-shadow: 0 1px 4px 0;
    outline: none;
}
.omega-toggle-checkbox:focus + .omega-toggle > .omega-toggle-indicator {
    box-shadow: 0 1px 4px 0;
}
.omega-toggle-checkbox:disabled + .omega-toggle {
    opacity: 0.6;
    pointer-events: none;
}
.omega-toggle-checkbox:checked + .omega-toggle {
    background-color: var(--omega-primary);
}
.omega-toggle-checkbox:checked + .omega-toggle > .omega-toggle-indicator {
    transform: translate(24px, 2px);
}
.omega-form-input-box [aria-expanded='false'] [role='listbox'] {
    display: none;
}
.omega-form-input-box [role='option'] {
    display: block;
    overflow: auto;
    cursor: pointer;
}
.omega-multiple-select[aria-expanded='true'] {
    position: relative;
    height: 32px;
    background-color: white;
    border-radius: 3px 3px 0 0;
}
.omega-multiple-select-button {
    text-overflow: ellipsis;
    position: relative;
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    margin: 0 auto;
    border: 1px solid rgb(199, 199, 199);
    background-color: #fff;
    border-radius: 3px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    text-align: left;
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
}
.omega-multiple-select-button::after {
    position: absolute;
    top: 50%;
    right: 1rem;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-width: 6px 6px 0;
    border-style: solid;
    border-color: #4b4742 transparent;
    content: '';
}
.omega-multiple-select[aria-expanded='true'] .omega-multiple-select-button {
    display: none;
    border: none;
    box-shadow: none;
}
.omega-multiple-select[aria-expanded='false'] > :not(.omega-multiple-select-button) {
    display: none;
}
.omega-multiple-select-search-wrapper {
    position: relative;
    top: 0;
    width: 100%;
}
.omega-multiple-select-select-all-label.omega-checkbox-label {
    border-bottom: 1px solid gainsboro;
}
.omega-multiple-select-no-results {
    height: 32px;
    line-height: 32px;
    text-align: center;
}
.omega-multiple-select-search {
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
}
.omega-multiple-select-search-icon {
    position: absolute;
    top: 8px;
    right: 12px;
    color: #888;
    font-size: 14px;
}
.omega-multiple-select-list[role='listbox'] {
    position: absolute;
    z-index: 3;
    top: 33px;
    left: 0;
    width: 100%;
    max-height: 192px;
    padding: 0;
    margin: 0;
    border: 0;
    border-right: 1px solid rgb(214, 209, 209);
    border-bottom: 1px solid rgb(214, 209, 209);
    border-left: 1px solid rgb(214, 209, 209);
    background-color: white;
    border-radius: 0 0 3px 3px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
    list-style: none;
    opacity: 0.99;
    overflow-y: scroll;
}
.omega-multiple-select-list-option:focus {
    border: 1px solid #66afe9;
    box-shadow: 0 2px 4px 0 rgba(102, 175, 233, 0.6);
}
.omega-form-input-box .omega-multiple-select [aria-selected='true'] {
    background: rgb(228, 222, 222);
}
.omega-multiple-select .omega-checkbox-label {
    width: 100%;
}
.omega-multiple-select-list label {
    margin: 0;
    padding: 5px 0 5px 0;
}
.omega-single-select-override .omega-multiple-select-list label {
    padding-left: 5px;
}
.omega-multiple-select-required {
    border: 1px solid red;
    background-color: rgba(204, 16, 16, 0.03);
}
.omega-multiple-select-error {
    border: 1px solid #c10f00;
    background-color: rgba(204, 16, 16, 0.03);
    box-shadow: 0 0 0 1px rgb(193, 15, 0, 0.2);
    transition: all 200ms cubic-bezier(0, 0, 0.29, 0.75);
}
.omega-autocomplete[aria-expanded='true'] {
    position: relative;
    height: 32px;
    background-color: white;
    border-radius: 3px 3px 0 0;
}
.omega-autocomplete-button {
    position: relative;
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    margin: 0 auto;
    border: 1px solid rgb(199, 199, 199);
    background-color: #fff;
    border-radius: 3px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    text-align: left;
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
}
.omega-autocomplete-button::after {
    position: absolute;
    top: 50%;
    right: 1rem;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-width: 6px 6px 0;
    border-style: solid;
    border-color: #4b4742 transparent;
    content: '';
}
.omega-autocomplete li {
    display: block;
    height: 28px;
    padding: 5px;
    border-radius: 0 0 3px 3px;
    color: #181818;
    text-decoration: none;
}
.omega-autocomplete li:hover {
    background-color: #ece8e5;
}
.omega-autocomplete[aria-expanded='true'] .omega-autocomplete-button {
    display: none;
    border: none;
    box-shadow: none;
}
.omega-autocomplete[aria-expanded='false'] > :not(.omega-autocomplete-button) {
    display: none;
}
.omega-autocomplete-search-wrapper {
    position: relative;
    top: 0;
    width: 100%;
}
.omega-autocomplete-select-all-label.omega-checkbox-label {
    border-bottom: 1px solid gainsboro;
}
.omega-autocomplete-no-results {
    text-align: center;
}
.omega-autocomplete-search {
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
}
.omega-autocomplete-search-icon {
    position: absolute;
    top: 8px;
    right: 12px;
    color: #888;
    font-size: 14px;
}
.omega-autocomplete-list[role='listbox'] {
    position: absolute;
    z-index: 3;
    top: 33px;
    left: 0;
    width: 100%;
    min-width: 200px;
    max-height: 192px;
    padding: 0;
    margin: 0;
    border: 0;
    border-right: 1px solid rgb(214, 209, 209);
    border-bottom: 1px solid rgb(214, 209, 209);
    border-left: 1px solid rgb(214, 209, 209);
    background-color: white;
    border-radius: 0 0 3px 3px;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
    list-style: none;
    opacity: 0.99;
    overflow-y: scroll;
}
.omega-autocomplete-list-option:focus {
    border: 1px solid #66afe9;
    box-shadow: 0 2px 4px 0 rgba(102, 175, 233, 0.6);
}
.omega-form-input-box .omega-autocomplete [aria-selected='true'] {
    background: rgb(228, 222, 222);
}
.omega-autocomplete .omega-checkbox-label {
    width: 100%;
}
.omega-autocomplete-list label {
    margin: 0;
    padding: 5px 0 5px 0;
}
.omega-autocomplete-required {
    border: 1px solid red;
    background-color: rgba(204, 16, 16, 0.03);
}
.omega-datepicker {
    position: absolute;
    display: inline-block;

    --datepicker-day-button-size: 30px;
    --datepicker-month-button-width: 75px;
    --datepicker-month-button-height: 45px;
}
.omega-datepicker.is-open {
    z-index: 3;
    width: 280px;
    padding: 0px 10px 10px 10px;
    border: 1px solid var(--omega-input-default-border);
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}
[aria-expanded='false'] .omega-datepicker-calendar,
.omega-datepicker-calendar[aria-expanded='false'] {
    display: none;
}
.omega-datepicker-descriptor {
    position: absolute;
    top: 0;
    left: 10px;
    line-height: 32px;
}
.omega-datepicker-input {
    height: 32px;
    padding: 6px 10px;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 3px;
    min-width: 120px;
}
.omega-datepicker .omega-datepicker-main-input {
    cursor: pointer;
    width: 280px;
    position: relative;
    margin: 0 auto;
}
.omega-datepicker .omega-datepicker-main-input::after {
    position: absolute;
    top: 50%;
    right: 5px;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-width: 6px 6px 0;
    border-style: solid;
    border-color: #4b4742 transparent;
    content: '';
}
.omega-datepicker .omega-datepicker-main-input[disabled='true'] {
    opacity: 0.65;
    cursor: default;
}
.omega-datepicker .omega-datepicker-main-input-type {
    white-space: nowrap;
}
.omega-datepicker .omega-datepicker-main-input-display {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
}
.omega-datepicker .omega-datepicker-main-input-value {
    margin-right: 10px;
    color: rgb(109, 107, 107);
    white-space: nowrap;
}
.omega-datepicker.is-open .omega-datepicker-toggle-button {
    display: none;
    background-color: #fff;
}
.omega-datepicker.is-open .omega-datepicker-main-input {
    display: none;
}
.omega-form-field .omega-datepicker:not(.is-open) input {
    width: 280px;
    padding-right: 24px;
    text-align: center;
}
.omega-form-field .omega-datepicker.is-open input {
    margin: 5px;
    padding: 0 10px;
    font-size: 12px;
    text-align: left;
    /* temp: better way to align and size inputs */
    width: 95%;
}
.omega-datepicker-hint-text {
    display: block;
    text-align: center;
    visibility: hidden;
}
.omega-datepicker.is-open .omega-datepicker-hint-text {
    visibility: visible;
}
.omega-datepicker-calendar-header {
    font-weight: 600;
}
.omega-datepicker-calendar-label {
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    text-align: center;
}
.omega-datepicker-calendar-label:hover {
    color: var(--omega-primary);
    cursor: pointer;
}
.omega-datepicker th {
    color: rgb(179, 179, 179);
    font-size: 11px;
    font-weight: 400;
    text-align: center;
}
.omega-datepicker-calendar {
    position: relative;
    height: 100px;
}
.omega-datepicker-month-selection {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
}
.omega-datepicker-last-month-button,
.omega-datepicker-next-month-button {
    width: 20px;
    height: 20px;
    padding: 5px;
    border: none;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    background: var(--omega-dropdown-arrow) right 4px center no-repeat #fff;
    background-color: transparent;
    background-size: 12px 12px;
}
.omega-datepicker-last-month-button {
    margin-right: 10px;
    transform: rotate(90deg);
}
.omega-datepicker-next-month-button {
    transform: rotate(-90deg);
}
.omega-datepicker td {
    padding: 0;
}
.omega-datepicker-day {
    width: 30px;
    width: var(--datepicker-day-button-size);
    height: var(--datepicker-day-button-size);
    margin: 0 4px;
    border: none;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    background-color: transparent;
    line-height: var(--datepicker-day-button-size);
    text-align: center;
}
.omega-datepicker-day:hover {
    border: 1px solid var(--omega-primary);
    border-radius: 5px;
}
.omega-datepicker-day-cell {
    position: relative;
}
.omega-datepicker-day-cell.is-selected button,
.omega-datepicker-day-cell.is-selection-start button,
.omega-datepicker-day-cell.is-selection-end button {
    background-color: var(--omega-primary);
    border-radius: 7px;
    color: var(--omega-primary-foreground);
}
.omega-datepicker-day-cell.is-selection-middle {
    background-color: var(--omega-calendar-selection-color);
    color: var(--omega-primary);
}
.omega-datepicker-day-cell.is-selection-start::before,
.omega-datepicker-day-cell.is-selection-end::before {
    position: absolute;
    z-index: -1;
    right: 0;
    display: block;
    width: 20px;
    height: 30px;
    background-color: var(--omega-calendar-selection-color);
    content: '';
}
.omega-datepicker-day-cell.is-selection-start.is-selection-end::before {
    display: none;
}
.omega-datepicker-day-cell.is-selection-start::before {
    right: 0;
}
.omega-datepicker-day-cell.is-selection-end::before {
    left: 0;
}
.omega-datepicker-last-month,
.omega-datepicker-next-month {
    color: var(--omega-grayed-out);
}
.omega-datepicker:not(.is-open) .omega-datepicker-list {
    display: none;
}
.omega-datepicker-list {
    padding: 0;
    margin: 0 -10px -10px;
    list-style: none;
}
.omega-datepicker-list > li {
    padding: 5px 10px 5px 10px;
    border-top: 1px solid #eaeaea;
}
.omega-datepicker-calendar input {
    width: 280px;
    padding: 0 10px;
    font-size: 12px;
    text-align: right;
}
.omega-datepicker-range-input-group {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
}
.omega-datepicker-calendar .omega-datepicker-range-input-group input {
    width: calc(50% - 3px);
    border-radius: 4px;
    text-align: left;
}
.omega-datepicker-calendar:not(.is-range) .omega-datepicker-range-input-group {
    display: none;
}
.omega-datepicker-calendar.is-range .omega-datepicker-calendar-input {
    display: none;
}
.omega-datepicker-option {
    cursor: pointer;
    outline: none;
}
.omega-datepicker-option.is-active {
    font-weight: 600;
}
.omega-datepicker-option.has-padding {
    padding-bottom: 285px;
}
.omega-datepicker .omega-datepicker-specific-date-container {
    position: absolute;
    top: 50px;
    height: 100px;
}
.omega-datepicker .omega-datepicker-date-range-container {
    position: absolute;
    top: 75px;
    height: 100px;
}
.omega-datepicker .omega-datepicker-calendar-table {
    position: absolute;
    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);
    z-index: -10;
    opacity: 0;
}
.omega-datepicker .omega-datepicker-calendar-table.is-open {
    overflow-y: hidden;
    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);
    z-index: 5;
    opacity: 1;
}
.omega-datepicker .omega-datepicker-month-list {
    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);
    z-index: -10;
    opacity: 0;
}
.omega-datepicker .omega-datepicker-month-list.is-open {
    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);
    z-index: 5;
    opacity: 1;
}
.omega-datepicker-month {
    width: 40px;
    width: var(--datepicker-month-button-width);
    height: var(--datepicker-month-button-height);
    margin: 0 4px;
    border: none;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    background-color: transparent;
    line-height: var(--datepicker-month-button-height);
    text-align: center;
    text-transform: uppercase;
}
.omega-datepicker-month:hover {
    border: 1px solid var(--omega-primary);
    border-radius: 5px;
}
.omega-datepicker-month-cell {
    position: relative;
}
.omega-datepicker-month-cell.is-selected button,
.omega-datepicker-month-cell.is-selection-start button,
.omega-datepicker-month-cell.is-selection-end button {
    background-color: var(--omega-primary);
    border-radius: 7px;
    color: var(--omega-primary-foreground);
}
.omega-datepicker-year-list {
    position: absolute;
    overflow-y: scroll;
    list-style-type: none;
    top: 80px;
    height: 205px;
    right: 0;
    left: 0;
    overflow-x: hidden;
    padding: 0;
    margin: 0;
    background: white;
    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);
    opacity: 0;
    z-index: -10;
}
.omega-datepicker-year-list.is-open {
    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);
    opacity: 1;
    z-index: 5;
}
.omega-datepicker-year-list-item {
    cursor: pointer;
    text-align: center;
    font-size: medium;
    padding: 5px 0px;
}
.omega-datepicker-year-list-item.is-selected {
    font-weight: 600;
    font-size: x-large;
}
.omega-datepicker-year-list-item:hover {
    background-color: var(--omega-calendar-selection-color);
}
.omega-form-field input.address-street {
    width: 300px;
    margin-bottom: 2px;
}
.omega-form-field input.address-city {
    width: 140px;
}
.omega-form-field input.address-state {
    width: 50px;
    margin: 0 10px;
}
.omega-form-field input.address-zip {
    width: 90px;
}
.omega-table-filters {
    position: sticky;
    top: 45px;
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    border-top: 1px #ccc;
    background-color: #f1f8fd;
}
.omega-table-filter-wrapper {
    display: flex;
    flex: 500px 20 1;
    flex-wrap: wrap;
}
.omega-table-filter {
    width: 300px;
    margin: 0;
}
.omega-table-button-wrapper {
    display: flex;
    flex: 110px 1 1;
    flex-flow: column wrap;
    align-self: center;
    padding-top: 18px;
    margin: 10px;
    direction: rtl;
}
.omega-table-button-wrapper omega-button-legacy button {
    width: 100%;
}
.omega-table-filters .omega-form-field {
    flex-flow: column;
    margin: 10px;
}
.omega-table-filters .omega-form-field label {
    color: #656a81;
    font-size: 14px;
    font-weight: 400;
}
.omega-table-filters .omega-form-field label::after {
    content: '';
}
@media only screen and (max-width: 900px) {
    .omega-table-button-wrapper {
        padding-top: 0;
    }
}
.omega-field-parts {
    display: inline-block;
}
.omega-form-field .omega-form-field {
    margin: 10px 0;
}
.omega-table-form {
    padding: 0;
    margin: 0;
    border: 0;
}
omega-table-legacy details {
    display: none;
}
omega-table-legacy {
    position: relative;
    display: block;

    /* padding: 0 0 31px; */
}
omega-table-legacy .sticky-header {
    position: sticky;
    top: -1px;
    height: 31px;
    padding: 5px;
    margin: 0 -1px -31px;
    background-color: white;
    font-weight: bold;
    text-align: left;
}
omega-table-legacy .omega-table-title {
    z-index: -1; /* to slide behind the sticky control bar */
    top: 45px;
    padding: 10px 20px;
    margin: 0;
    background-color: white;
    font-size: 18px;
    font-weight: 600;
}
omega-table-legacy table {
    width: 100%;
    margin: 0;
    border-collapse: collapse;
    font-size: 13px;
}
omega-table-legacy .table-footer {
    position: sticky;
    top: 0;
    bottom: -1px;
    display: flex;
    width: 100%;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background-color: #f0f0f0;
}
.omega-table-empty-state {
    display: flex;
    height: 50vh;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.omega-table-empty-state span {
    font-size: 18px;
}
omega-filter-control {
    display: block;
    padding: 5px;
}
.advanced-filters {
    padding: 0;
    margin: 0;
    list-style: none;
}
.advanced-filters input {
    display: block;
}
.advanced-filters li input {
    display: inline-block;
}
.omega-table details {
    margin: 10px;
}
.omega-table summary h3 {
    display: inline-block;
    cursor: pointer;
}
.date-filter input {
    display: inline-block;
    clear: none;
}
.advanced-filters .radio-list {
    padding: 0;
    margin: 0;
    list-style: none;
}
.advanced-filters .radio-list li {
    padding: 5px;
}
.omega-table-controls {
    display: flex;
    min-height: 45px;
    align-items: center;
    padding: 0 18px;
}
.omega-table-filters.omega-table-controls-panel {
    z-index: 3;
    max-height: 0;
    padding: 0 10px;
    transition: max-height 0.1s ease-out;
}
.omega-table-filters-hidden {
    overflow: hidden;
}
.omega-table-controls span {
    padding-left: 5px;
    color: #318ec6;
    font-size: 14px;
    font-weight: 500;
}
.omega-table .omega-table-controls {
    position: sticky;
    z-index: 1;
    top: 0;
    width: 100%;
    padding: 5px 0 5px 18px;
    border: none;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    background-color: #f9f9f9;
    transition: 0.4s;
}
.omega-table-controls-filter-btn {
    cursor: pointer;
}
.omega-table.omega-table-has-caption .omega-table-controls {
    top: 20px; /* To leave room for the slide-from-behind sticky header */
}
.omega-table .quick-filter {
    width: 400px;
}
.omega-table-table th,
.omega-table-table thead td {
    position: sticky;
    z-index: 1;
    height: 45px;
    padding: 0 10px;
    border-width: 0;
    border-style: solid;
    font-size: 14px;
    background-color: #e6e6e6;
    box-shadow: inset 0 -1px 0 #ccc;
    color: #464646;
    font-weight: 400;
    text-align: left;
    white-space: nowrap;
}
.omega-table.omega-table-has-caption th,
.omega-table.omega-table-has-caption thead td {
    top: 64px; /* to make space for the sticky control bar and slide from behind header */
}
.omega-table th.sortable {
    cursor: pointer;
}
.omega-table th.sortable[aria-sort='ascending']::after {
    content: '\\f0de';
}
.omega-table th.sortable[aria-sort='descending']::after {
    content: '\\f0dd';
}
.omega-table th.sortable::after {
    display: inline-block;
    width: 1em;
    height: 1em;
    margin-left: 2px;
    background-size: 1em 1em;
    content: '\\f0dc';
    font-family: FontAwesome;
    opacity: 0.5;
    vertical-align: top;
}
.omega-table-sort-button {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    cursor: pointer;
    opacity: 0.01;
}
.omega-table-table tr:nth-of-type(2n) {
    background-color: #fafbfc;
    border-top: 1px solid #e6eaee;
    border-bottom: 1px solid #e6eaee;
}
omega-table-legacy .select-column {
    width: 30px;
    text-align: center;
}
.omega-table-table td {
    padding: 15px 10px;
    line-height: 16px;
    font-size: 13px;
    color: #3c3c3c;
}
.pagination-message {
    font-weight: bold;
}
.pagination-nav {
    display: flex;
    padding: 0;
    margin: 0;
}
.pagination-controls {
    display: flex;
}
.pagination-nav ol {
    display: inline-block;
    padding: 0;
    margin: 0;
}
.pagination-nav li {
    display: inline-block;
    margin: 0;
    list-style: none;
}
.omega-table .pagination-nav a {
    display: block;
    min-width: 20px;
    padding: 0 10px;
    border: 1px solid #ddd;
    border-right-width: 0;
    background-color: white;
    color: #337ab7;
    cursor: pointer;
    line-height: 30px;
    text-align: center;
    text-decoration: none;
}
.pagination-nav a:hover {
    border-color: #ddd;
    background-color: #eee;
    color: #22527b;
}
.pagination-nav li {
    font-weight: bold;
}
.pagination-nav .omega-disabled {
    font-weight: normal;
    opacity: 0.5;
}
.omega-table .pagination-nav [aria-disabled='true'] {
    color: inherit;
    cursor: default;
    pointer-events: none;
}
.omega-table .pagination-nav [aria-current='page'] {
    background-color: #337ab7;
    color: #fff;
    cursor: default;
    pointer-events: none;
}
.pagination-nav li:first-child a {
    border-bottom-left-radius: 3px;
    border-top-left-radius: 5px;
}
.pagination-nav li:last-child a {
    border-right-width: 1px;
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
}
.table-footer select {
    height: 30px;
    margin: 0 10px;
}
.omega-table th.numeric,
.omega-table td.numeric {
    text-align: right;
}
.omega-table th.date,
.omega-table td.date {
    text-align: center;
}
.omega-table th.time,
.omega-table td.time {
    text-align: center;
}
.omega-table th.dateTime,
.omega-table td.dateTime {
    text-align: center;
}
.omega-table th.userIdentification,
.omega-table td.userIdentification {
    text-align: left;
}
.omega-table th.userType,
.omega-table td.userType {
    text-align: center;
}
.omega-table th.enum,
.omega-table td.enum {
    text-align: center;
}
.omega-table .negative {
    color: #c51012;
}
.omega-table table {
    overflow-x: auto;
}
.omega-table .radio-list {
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
}
.omega-table .radio-list li > * {
    display: inline-block;
}
.omega-table :not(form).ng-invalid {
    border: 1px solid #cc1010;
    background-color: rgba(204, 16, 16, 0.03);
    border-radius: 3px;
}
.omega-table :not(form).ng-pristine {
    border: 1px solid rgb(199, 199, 199);
    background-color: #fff;
    border-radius: 3px;
}
.omega-table .error-indicator {
    display: none;
}
.omega-table tr.has-errors .error-indicator {
    display: inline;
}
.omega-table a {
    text-decoration: underline;
}
.omega-is-loading {
    opacity: 0.7;
    transition: opacity 0.3s;
}
:root {
    /* theme colors */
    --omega-primary-darken-100: var(--brand-color-dark, #0e5daa);
    --omega-primary: var(--brand-color, #0065cf);
    --omega-primary-lighten-100: var(--brand-color-light, #508cdd);
    --omega-primary-lighten-200: #8ab3e8;
    --omega-primary-lighten-300: #c4d8f4;
    --omega-primary--focus: #ddebfb;
    --omega-secondary: #515c66;
    --omega-secondary-lighten-100: #7c858c;
    --omega-secondary-lighten-200: #a8adb2;
    --omega-secondary-lighten-300: #d3d6d9;
    --omega-secondary-lighten-400: #edf0f3;
    --omega-success-darken-100: #348640;
    --omega-success: #22883f;
    --omega-success-lighten-100: #6ec174;
    --omega-success-lighten-200: #a0d5a2;
    --omega-success-lighten-300: #cfebd1;
    --omega-warning-darken-200: #b36200;
    --omega-warning-darken-100: #d47b25;
    --omega-warning: #ed943e;
    --omega-warning-lighten-100: #f1af72;
    --omega-warning-lighten-200: #f7c8a3;
    --omega-warning-lighten-300: #fae4d0;
    --omega-error-darken-100: #9d0e0e;
    --omega-error: #c00000;
    --omega-error-lighten-100: #d65b4a;
    --omega-error-lighten-200: #ecada4;
    --omega-error-lighten-300: #f7d7d2;
    --omega-accent: #6758f3;
    --omega-accent-lighten-100: #8b81f7;
    --omega-accent-lighten-200: #b2acfa;
    --omega-accent-lighten-300: #dad6fd;
    --omega-info-darken-200: #4f4f4f;
    --omega-info-darken-100: #696969;
    --omega-info: #828282;
    --omega-info-lighten-100: #a2a2a2;
    --omega-info-lighten-200: #c1c1c1;
    --omega-info-lighten-300: #e0e0e0;
    /* buttons */
    --omega-button-primary-box-shadow: var(--brand-color-darker, #337ab7);
    --omega-button-secondary-box-shadow: var(--brand-color-darker, #337ab7);
    --omega-button-secondary-darken-100: #f2f6fa;
    --omega-button-approve-box-shadow: #55bb72;
    --omega-button-success-box-shadow: #55bb72;
    --omega-button-reject-box-shadow: #ee3a3b;
    --omega-button-icon-border: transparent;
    --omega-button-icon-box-shadow: transparent;
    --omega-button-icon-color: var(--omega-primary);
    --omega-button-icon-darken-100: #bfd8f3;
    --omega-button-icon-hover: var(--brand-color-lighter, #d9e8f8);
    --omega-button-disabled-background: #828282;
    --omega-button-disabled-secondary-color: #6d7883;
    --omega-button-disabled-secondary-border-color: #87929d;
    --omega-button-disabled-secondary-box-shadow: #b9b9b9;
    --omega-button-exclamation-triangle-color: #ffc121;
    --omega-button-exclamation-triangle-danger-color: #ee3a3b;
    --omega-button-exclamation-triangle-warning-color: #f06f19;
    /* element colors */
    --omega-page-background: #ededed;
    --omega-primary-foreground: #fff;
    --omega-table-row-color: #f5f5f5;
    --omega-divider-color: #dddddd;
    --omega-calendar-selection-color: #cddeeb;
    --omega-white: #fff;
    --omega-white-100: #f5f5f5;
    --omega-white-150: #e9e9e9;
    --omega-light-grey: #ccc;
    --omega-grayed-out: #999;
    --omega-dark-grey: #4c4d4e;
    /* font family */
    --omega-font: Roboto, sans-serif;
    /* font colors */
    --omega-text-default: #3e3f42;
    --omega-text-secondary: #6b6c6f;
    --omega-text-tertiary: #949494;
    --omega-text-success: #34aa44;
    --omega-text-header: #545454;
    --omega-text-error: #b30606;
    --omega-text-time-sensitive: #0ba6aa;
    --omega-text-help: #696969;
    --omega-text-inverted: #fcfcfc;
    /* font sizes */
    --omega-h1: 24px;
    --omega-h2: 20px;
    --omega-h3: 18px;
    --omega-h4: 16px;
    --omega-h5: 14px;
    --omega-label: 14px;
    --omega-p: 13px;
    --omega-input: 13px;
    --omega-small: 12px;
    --omega-hint: 11px;
    /* font weights */
    --omega-bold: 700;
    --omega-semi-bold: 500;
    --omega-medium: 400;
    --omega-regular: 300;
    --omega-light: 100;
    /* inputs */
    --omega-input-success-border: #34aa44;
    --omega-input-error-border: #bf0000;
    --omega-input-active-border: #15b1eb;
    --omega-input-default-border: #dfe1e8;
    --omega-input-hover-border: #c8d8de;
    --omega-input-border-radius: 3px;
    --omega-input-disabled-border: #e6e8ec;
    --omega-input-disabled-background: #f9f9f9;
    /* accents */
    --omega-dialog-overlay: rgba(9, 17, 9, 0.75);
    --omega-dialog-shadow: 0px 0px 8px 0px #333;
    --omega-default-shadow: 0px 0px 5px 3px rgba(150, 150, 150, 0.75);
    --omega-primary-shadow: 0px 0px 3px 2px rgba(84, 102, 206, 0.5);
    --omega-menu-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.25);
    /* borders */
    --omega-default-border: 1px solid #dddddd;
    --omega-primary-border: 1px solid rgba(0, 101, 207, 0.5);
    --omega-success-border: 1px solid rgba(2, 161, 46, 0.5);
    --omega-warning-border: 1px solid rgba(255, 101, 1, 0.5);
    --omega-error-border: 1px solid rgba(191, 0, 0, 0.5);
    --omega-time-sensitive-border: 1px solid rgba(0, 180, 185, 0.5);
    --omega-help-border: 1px solid rgba(105, 105, 105, 0.5);
    /* images */
    --omega-dropdown-arrow: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    /* transitions */
    --omega-zoom-in: all 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045);
    --omega-zoom-out: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    /* margins */
    --omega-input-margin: 8px;
    /* omega-label */
    --omega-label-color: var(--omega-text-default);
    /* omega-field */
    --omega-field-color: var(--omega-text-default);
    --omega-field-font-weight: var(--omega-text-semi-bold);
    /* omega-dialog */
    --omega-dialog-header-font-size: 16px;
}
dialog::backdrop {
    background: rgba(0, 0, 0, 0.5);
}
.omega-dialog {
    position: absolute;
    top: 5%;
    min-width: 600px;
    max-width: 900px;
    padding: 0;
    border: none;
    border-radius: 3px;
    box-shadow: 0 3px 6px 0;
    color: var(--omega-base-font-color);
}
.omega-dialog-title {
    flex: 1 1;
    padding: 15px;
    margin: 0;
    border-bottom: 1px solid var(--omega-divider-color);
    font-size: 18px;
}
.omega-dialog-body {
    padding: 15px;
}
.omega-dialog omega-button-bar {
    display: block;
    width: 100%;
    flex: 1 1;
    border-top: 1px solid var(--omega-divider-color);
    text-align: left;
}
.omega-lookup-filter {
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    font-size: 13px;
    line-height: 20px;
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
}
.omega-lookup-filter-container {
    position: relative;
}
.omega-lookup-filter-icon {
    position: absolute;
    top: 8px;
    right: 12px;
    color: #aaa;
}
.omega-lookup-list {
    overflow: auto;
    max-height: calc(100vh - 220px);
    padding: 0;
    margin: 10px 0;
    background: none;
    list-style: none;
}
.omega-lookup-list > li {
    position: relative;
    overflow: auto;
    padding: 15px;
    margin: 5px;
    border: 2px solid #eee;
    border-radius: 5px;
    cursor: pointer;
}
.omega-account-lookup-account-name {
    display: block;
    margin-bottom: 5px;
    color: var(--omega-brand-color);
    font-size: 18px;
    text-decoration: none;
}
.omega-account-lookup-account-type {
    padding-right: 10px;
    border-right: 1px solid #999;
    color: #9b9b9b;
    font-size: 13px;
    text-transform: uppercase;
}
.omega-account-lookup-account-number {
    padding-left: 5px;
    margin: 0;
    font-size: 13px;
}
.omega-account-lookup-account-balance {
    position: absolute;
    top: 50%;
    right: 20px;
    font-size: 20px;
    transform: translateY(-50%);
}
.omega-lookup-list-count {
    padding: 0 5px;
    font-size: 13px;
    font-weight: bold;
}
[role='listbox'] .omega-account-name {
    display: block;
    max-width: 200px;
    padding-right: 15px;
    float: left;
    font-weight: bold;
}
[role='listbox'] .omega-account-number {
    display: block;
    clear: both;
    float: left;
}
[role='listbox'] .omega-account-balance {
    display: block;
    float: right;
}
.omega-ach-company-lookup-list > li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.group-1 {
    max-width: 300px;
    margin-right: 50px;
}
.group-2 {
    min-width: 200px;
    height: auto;
    margin: auto 0;
}
.omega-lookup-ach-company-name {
    display: block;
    margin-bottom: 5px;
    color: var(--omega-primary);
    font-size: 18px;
}
.omega-lookup-ach-company-id {
    display: block;
    margin-bottom: 5px;
    color: var(--omega-text-secondary);
    font-size: 18px;
    text-align: right;
}
.omega-lookup-ach-company-description {
    display: inline-block;
    padding: 0 10px 0 0;
    margin: 0 10px 8px 0;
    border-right: 1px solid var(--omega-text-secondary);
    color: var(--omega-text-secondary);
}
.omega-lookup-ach-company-sec-code-list {
    display: inline;
    padding: 0;
    margin: 0;
    color: var(--omega-text-secondary);
    list-style: none;
}
.omega-lookup-ach-company-account-type-list {
    display: inline;
    padding: 0 0 0 10px;
    margin: 0 0 0 10px;
    border-left: 1px solid var(--omega-text-secondary);
    color: var(--omega-text-secondary);
    list-style: none;
    text-align: right;
}
.omega-lookup-ach-company-sec-code-list > li,
.omega-lookup-ach-company-account-type-list > li {
    display: inline;
}
.omega-lookup-ach-company-sec-code-list > li {
    padding: 3px 5px;
    margin: 0 0 0 10px;
    background-color: #ddd;
    border-radius: 10px;
}
.omega-lookup-ach-company-account-type-list > li:not(:last-child)::after {
    content: ', ';
}
.omega-lookup-ach-company-discretionary-data {
    display: inline-block;
    color: var(--omega-text-secondary);
}
.omega-lookup-ach-company-batch-balance-requirements {
    display: inline;
    color: var(--omega-text-secondary);
    text-align: right;
}
.omega-alert {
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid black;
    border-left-width: 5px;
}
.omega-alert-close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: none;
    border: none;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    background: none;
    font-weight: bold;
}
.omega-alert-icon {
    display: block;
    width: 50px;
    font-size: 24px;
}
.omega-alert p {
    padding: 0;
    margin: 0;
}
.omega-alert-info {
    border-color: #337ab7;
}
.omega-alert-info .omega-alert-icon {
    color: #337ab7;
}
.omega-alert-success {
    border-color: #2caa55;
}
.omega-alert-success .omega-alert-icon {
    color: #2caa55;
}
.omega-alert-warning {
    border-color: #ff6501;
}
.omega-alert-warning .omega-alert-icon {
    color: #ff6501;
}
.omega-alert-error {
    border-color: #ec3a3b;
}
.omega-alert-error .omega-alert-icon {
    color: #ec3a3b;
}
.omega-alert-header {
    font-size: 18px;
}
.omega-alert-aggressive {
    position: fixed;
    z-index: 1100;
    top: calc(35%);
    left: calc(50% - 87.5px);
    width: 400px;
    height: 175px;
    padding: 15px;
    background-color: white;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.18);
    color: #3c3c3c;
    font-size: 13px;
    text-align: center;
}
.omega-alert-aggressive-success {
    border: 1px solid #2caa55;
}
.omega-alert-aggressive-error {
    border: 1px solid #ec3a3b;
}
.omega-alert-aggressive-success-text {
    color: #2caa55;
}
.omega-alert-aggressive-error-text {
    color: #ec3a3b;
}
.omega-alert-aggressive-success-icon {
    color: #2caa55;
}
.omega-alert-aggressive-warning-icon {
    color: #ff6501;
}
.omega-alert-aggressive-error-icon {
    color: #ec3a3b;
}
.close-aggressive-alert-button {
    margin-top: -15px;
    margin-left: 369px;
}
.omega-close-alert-button {
    color: darkgrey;
}
i.fa.fa-times.omega-close-alert-button {
    font-size: 1em;
}
.omega-download-bar {
    z-index: 2;
    top: 0;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    align-items: center;
}
.omega-download-bar-button-group {
    display: flex;
    justify-content: flex-end;
}
.download-bar-item {
    display: inline-block;
    font-size: 16px;
    height: 55px;
}
.download-bar-item button {
    width: 44px;
    height: 44px;
}
.omega-download-bar-menu {
    position: relative;
}
.omega-download-dropdown {
    position: absolute;
    top: 46px;
    z-index: 5;
    min-width: 50px;
    padding: 0;
    border: 1px solid #e9e9e9;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
    list-style: none;
}
.omega-download-dropdown li {
    min-width: 50px;
    padding: 10px 25px;
    text-align: center;
    color: #0070b7;
    cursor: pointer;
}
.omega-download-dropdown li:hover {
    background-color: #f5f5f5;
}
.omega-download-dropdown a {
    text-decoration: none;
}
.omega-download-bar-actions {
    display: inline;
}
.omega-download-bar-actions i {
    position: absolute;
    margin-top: 18px;
    margin-left: 182px;
    color: darkgrey;
}
.omega-download-save-button {
    height: 25px;
    margin-right: 5px;
    border: 1px solid #337ab7;
    background-color: #337ab7;
    border-radius: 3px;
    color: #fff;
}
.omega-download-cancel-button {
    height: 25px;
    margin-right: 28px;
    border: 1px solid #d3d3d3;
    background-color: white;
    border-radius: 3px;
    color: dimgrey;
}
.omega-save-report {
    overflow: hidden;
    width: 200px;
    height: 25px;
    padding: 8px;
    margin-right: 5px;
    border: 1px solid #337ab7;
    border-radius: 3px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.omega-download-bar.open.dropdown-menu.omega-dropdown {
    margin-left: 190px;
}
button[disabled].omega-download-save-button {
    cursor: not-allowed;
    opacity: 65%;
}
.omega-download-bar-page-title {
    padding-left: 10px;
    font-size: 16px;
    font-weight: 400;
    color: rgb(129, 127, 127);
}
.omega-download-bar-report-title {
    padding-left: 18px;
    font-size: 17px;
    font-weight: 600;
}
.omega_container_droppable {
    position: relative !important; /* was being overridden to static */
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    background: #f2f2f2;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    margin: 20px 0;
    padding: 5px;
    min-height: 60px;
}
.omega_tile_draggable {
    position: relative;
    display: block;
    margin: 5px;
    width: 225px;
    height: 45px;
    padding: 5px;
    background-color: #fcfcfc;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    cursor: move;
}
.omega_tile_fixed_position {
    width: 275px;
}
.omega_tile_draggable:before,
.omega_tile_draggable:after {
    box-sizing: border-box;
    transition:
        background-color 400ms ease-out,
        border-color 400ms ease-out,
        color 400ms ease-out;
}
.omega_tile_draggable.active {
    background: #eee;
    border: 1px dashed #a6a6a6;
}
.omega_tile_draggable[data-type='payment information']:not(.active) {
    border-left: 6px solid #19c466;
}
.omega_tile_draggable[data-type='beneficiary information']:not(.active) {
    border-left: 6px solid #00bde9;
}
.omega_tile_draggable[data-type='domestic intermediary']:not(.active) {
    border-left: 6px solid #a5a5a5;
}
.omega_tile_draggable[data-type='filler']:not(.active) {
    background:
        linear-gradient(#fff, #fff) padding-box,
        repeating-linear-gradient(45deg, #ffffff, #ffffff 2px, #ffffff 2px, #6e6e6e 4px) border-box;
    border-left: 6px solid transparent;
}
.omega_tile_draggable.omega_tile_default {
    border-left: 6px solid rgb(104, 93, 93);
}
.omega_tile_draggable.dragging {
    background: #e6eaee;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.7);
    opacity: 0.925;
}
.omega_tile_draggable.dragging .tile_order {
    display: none;
}
.omega_tile_draggable.active .tile_order {
    display: none;
}
.tile_position_count_input {
    position: absolute;
    top: 0;
    left: 218px;
    width: 50px;
    height: 43px;
    border: none;
    border-left: 1px solid #d6d6d6;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    padding-left: 10px;
}
.tile_position_button {
    padding: 0;
    border: none;
    background: none;
    padding: 5px;
    margin: 5px;
    position: absolute;
    right: 3px;
}
.tile_position_button::after {
    position: absolute;
    width: 0;
    right: 1px;
    top: 3px;
    height: 0;
    border-style: solid;
    border-color: #4b4742 transparent;
    content: '';
}
.tile_position_button[disabled='true']::after {
    border-color: rgb(189, 183, 183) transparent;
}
.tile_position_button.add_button {
    top: 3px;
}
.tile_position_button.add_button::after {
    border-width: 0 4px 4px;
}
.tile_position_button.subtract_button {
    top: 22px;
}
.tile_position_button.subtract_button::after {
    border-width: 4px 4px 0;
}
.tile_position_count_input::-webkit-inner-spin-button,
.tile_position_count_input::-webkit-outer-spin-button {
    -webkit-appearance: none;
            appearance: none;
}
.tile_order {
    position: absolute;
    top: 8px;
    font-weight: 300;
    font-size: 12px;
}
.omega_tile_delimited .tile_order {
    right: 5px;
}
.omega_tile_fixed_position .tile_order {
    right: 60px;
}
.omega_tile_draggable[data-active='false'] .tile_order {
    display: none;
}
.tile_title {
    font-size: 14px;
    font-weight: 600;
    margin: 3px 0 0 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.tile_title span {
    font-weight: 400;
}
.tile_subtitle {
    width: 200px;
    font-size: 11px;
    margin: 0 0 0 3px;
    color: grey;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.tile_remove_button {
    position: absolute;
    top: 25px;
    right: 0;
    font-weight: 300;
    color: rgb(146, 141, 141);
    font-size: 13px;
    border: none;
    display: none;
}
.omega_tile_draggable .tile_remove_button.show {
    display: block;
}
.omega_tile_draggable.dragging .tile_remove_button {
    opacity: 0;
}
.omega_tile_draggable.active .tile_remove_button {
    opacity: 0;
}
.omega_tile_fixed_position .tile_remove_button {
    right: 55px;
}
.omega-icon-column {
    text-align: center;
}
.omega-icon-column i {
    cursor: pointer;
    font-size: 20px;
    min-width: 44px;
}
.omega-popover {
    min-width: 400px;
}
.omega-popover-template-label {
    min-width: 100px;
    float: left;
}
.omega-popover-template-data {
    float: right;
}
.omega-file-format-container {
    background: #f1f0f0;
    padding: 1px 0 1px 0;
    border-radius: 4px;
    margin-bottom: 60px;
}
.omega-file-format-container label {
    font-weight: 400;
}
.omega-file-format-input-row {
    margin: 15px 0;
}
.omega-file-format-input {
    display: block;
}
.omega-file-format-input-invalid {
    border: 1px solid #c10f00 !important;
    background-color: rgba(204, 16, 16, 0.03) !important;
    box-shadow: 0 0 0 1px rgb(193, 15, 0, 0.2) !important;
    transition: all 200ms cubic-bezier(0, 0, 0.29, 0.75) !important;
}
.omega-input-invalid-text {
    color: #c10f00;
}
.omega-file-format-input-wrapper {
    height: 60px;
    width: 225px;
    margin: 15px 5px;
    align-items: center;
}
.omega-file-format-container section {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin: 10px;
    padding: 10px;
}
.omega-file-format-title-section {
    min-height: 72px;
}
.omega-file-format-title-section h2 {
    margin: 0;
}
.omega-file-format-section-header p {
    display: inline-block;
    font-size: 16px;
    text-transform: capitalize;
    font-weight: 400;
}
.omega-file-format-navigation {
    position: relative;
    bottom: -10px;
    display: flex;
}
.omega-file-format-navigation label {
    padding: 5px;
    margin: 3px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 125px;
}
/* TABS */
.omega-tabs {
    display: flex;
}
.omega-tab {
    text-align: center;
    font-weight: 600;
    padding: 5px;
    margin: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #0070b7;
}
.omega-tab .page-tab {
    max-width: 100px;
}
.omega-tab.active-tab {
    border-bottom: 2px solid #0070b7;
}
.omega-tab-content {
    display: none;
}
.omega-tab-content.show-tab-content {
    display: block;
    border-top: 1px solid #d4d2d2;
}
/* TOOLTIP */
.omega-file-format-icon {
    font-size: 16px;
    color: #929090;
    margin-left: 5px;
    margin-top: 8px;
}
.omega-tooltip {
    position: relative;
    white-space: nowrap;
    height: 32px;
    min-width: 25px;
}
.omega-tooltip:after {
    text-align: left;
    white-space: normal;
}
.omega-tooltip:focus {
    outline: none;
}
.omega-tooltip::before,
.omega-tooltip::after {
    left: 50%;
    opacity: 0;
    position: absolute;
    z-index: -100;
}
.omega-tooltip:hover::before,
.omega-tooltip:focus::before,
.omega-tooltip:hover::after,
.omega-tooltip:focus::after {
    opacity: 1;
    transform: scale(1) translateY(0);
    z-index: 100;
}
.omega-tooltip::before {
    border-style: solid;
    border-width: 1em 0.75em 0 0.75em;
    border-color: #3e474f transparent transparent transparent;
    bottom: 140%;
    content: '';
    margin-left: -0.5em;
    transition:
        all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26),
        opacity 0.65s 0.5s;
    transform: scale(0.6) translateY(-90%);
}
.omega-tooltip:hover::before,
.omega-tooltip:focus::before {
    transition: all 0.65s cubic-bezier(0.84, -0.18, 0.65, 1.13) 0.2s;
}
.omega-tooltip::after {
    background: #3e474f;
    border-radius: 0.25em;
    bottom: 180%;
    color: #edeff0;
    content: attr(data-message);
    margin-left: -8.75em;
    padding: 1em;
    transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;
    transform: scale(0.6) translateY(50%);
    width: 17.5em;
}
.omega-tooltip:hover::after,
.omega-tooltip:focus::after {
    transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26);
}
.omega-file-format-name-section {
    display: flex;
    flex-wrap: wrap;
    min-height: 100px;
    align-items: center;
}
.omega-file-format-name-section span {
    margin-left: 30px;
    margin-top: 20px;
}
.omega-file-format-options-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.omega-file-format-input {
    width: 85% !important;
}
/* RADIOS */
.omega-radio-group {
    width: 225px;
}
.omega-radio-wrapper {
    display: inline-block;
}
.omega-radio-wrapper * {
    cursor: pointer;
}
.omega-radio-wrapper [type='radio']:checked,
.omega-radio-wrapper [type='radio']:not(:checked) {
    position: absolute;
    left: -9999px;
}
.omega-radio-wrapper [type='radio']:checked + label,
.omega-radio-wrapper [type='radio']:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #666;
}
.omega-radio-wrapper [type='radio']:checked + label:before,
.omega-radio-wrapper [type='radio']:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid #ddd;
    border-radius: 100%;
    background: #fff;
}
.omega-radio-wrapper [type='radio']:checked + label:after,
.omega-radio-wrapper [type='radio']:not(:checked) + label:after {
    content: '';
    width: 12px;
    height: 12px;
    background: var(--omega-primary);
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 100%;
    transition: all 0.2s ease;
}
.omega-radio-wrapper [type='radio']:not(:checked) + label:after {
    opacity: 0;
    transform: scale(0);
}
.omega-radio-wrapper [type='radio']:checked + label:after {
    opacity: 1;
    transform: scale(1);
}
.omega-file-format-select {
    position: relative;
    width: 100%;
    height: 32px;
    padding: 6px 10px;
    margin-bottom: 3px;
    border: 1px solid rgb(199, 199, 199);
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    background: var(--omega-dropdown-arrow) right 4px center no-repeat #fff;
    background-size: 12px 12px;
    border-radius: 3px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
}
.omega-file-format-select::after {
    position: absolute;
    top: 50%;
    right: 1rem;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-width: 6px 6px 0;
    border-style: solid;
    border-color: #4b4742 transparent;
    content: '';
}
.omega-file-format-column-order-section-header {
    display: flex;
    justify-content: space-between;
}
.omega-file-format-column-order-section-title {
    font-size: 16px;
}
.omega-file-format-column-glossary {
    position: relative;
}
.omega-file-format-column-glossary button {
    font-size: 14px;
    color: var(--omega-primary);
    border: none;
    background: none;
    padding: 0;
}
#glossary-divider {
    border-right: 1px solid rgb(197, 190, 190);
    margin: 0 5px;
    height: 20px;
}
/* LEGEND */
.omega-file-format-legend {
    position: relative;
    display: inline-block;
    cursor: pointer;
    height: 25px;
}
.omega-file-format-legend:focus {
    outline: none;
}
.omega-file-format-legend-detail {
    position: absolute;
    bottom: -15px;
    right: -115px;
    width: 200px;
    background: #fff;
    border: 1px solid rgba(0, 101, 207, 0.5);
    box-shadow: 0 0 10px 0 rgba(57, 57, 57, 0.5);
    border-radius: 4px;
    padding: 5px 11px 15px 11px;
    opacity: 0;
    z-index: -10;
    transform: translate(-50%, -50%) rotateX(-180deg);
    transition: all 0.25s cubic-bezier(0.6, -0.28, 0.735, 0.045);
}
.omega-file-format-legend-detail.show {
    opacity: 1;
    z-index: 100;
    transform: translate(-50%, -50%) rotateX(0deg);
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.omega-file-format-legend-detail-header {
    display: flex;
    justify-content: flex-end;
    color: rgb(168, 157, 157);
    font-size: 14px;
    margin-bottom: 3px;
}
.swatch {
    position: relative;
    display: inline-block;
    height: 11px;
    width: 11px;
    border-radius: 50%;
}
.payment-information-swatch {
    background-color: #19c466;
}
.beneficiary-information-swatch {
    background-color: #00bde9;
}
.domestic-intermediary-swatch {
    background-color: #a5a5a5;
}
.omega-file-format-legend .domestic-intermediary-swatch {
    top: 12px;
    right: 22px;
}
.omega-action-bar {
    position: fixed;
    left: 200px; /* only for the demo bc of nav sidebar - should remove this from here and stick in example*/
    bottom: 0;
    height: 55px;
    width: 100%;
    background: white;
    border-top: 1px solid #e0e0e0;
}
/* GLOSSARY (MODAL) */
.omega-modal {
    position: fixed;
    box-shadow: 0px 0px 8px 0px #333;
    text-align: left;
    background: #fff;
    padding: 5px 20px;
}
.omega-modal-background {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(9, 17, 9, 0.75);
    opacity: 0;
    z-index: -1;
    height: 100%;
    width: 100%;
    transition: all 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045);
}
.omega-modal-background.show {
    display: block;
    opacity: 1;
    z-index: 10;
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.omega-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.omega-modal-header-title {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #5a5b5a;
    font-weight: 600;
}
.omega-modal-header omega-button {
    flex-shrink: 2;
}
#omega-file-format-glossary {
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: all 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045);
    height: 400px;
    width: 525px;
    border-radius: 4px;
}
#omega-file-format-glossary.show {
    z-index: 11;
    transform: translate(-50%, -50%) scale(1);
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
#omega-file-format-glossary ul {
    list-style: none;
    padding: 0 10px;
}
#omega-file-format-glossary li {
    margin-top: 5px;
}
@font-face {
    font-family: FontAwesome;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('svg');
    font-weight: 400;
    font-style: normal;
}
.visually-hidden {
    position: absolute !important;
    overflow: hidden;
    width: 1px;
    height: 1px;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
}
.experimental {
    display: inline-block;
    outline: 2px dashed maroon !important;
}
.experimental .experimental {
    outline: none !important;
}
@media print {
    .omega-filter-print {
        display: none;
        height: 0;
    }
}
*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
/* ! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: var(--divider-primary); /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: "Roboto", ui-sans-serif, system-ui, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
    width: 100% !important;
}
.container {
    width: 100%;
}
@media (min-width: 600px) {
    .\\!container {
        max-width: 600px !important;
    }
    .container {
        max-width: 600px;
    }
}
@media (min-width: 768px) {
    .\\!container {
        max-width: 768px !important;
    }
    .container {
        max-width: 768px;
    }
}
@media (min-width: 992px) {
    .\\!container {
        max-width: 992px !important;
    }
    .container {
        max-width: 992px;
    }
}
.pointer-events-none {
    pointer-events: none;
}
.pointer-events-auto {
    pointer-events: auto;
}
.\\!visible {
    visibility: visible !important;
}
.visible {
    visibility: visible;
}
.invisible {
    visibility: hidden;
}
.collapse {
    visibility: collapse;
}
.static {
    position: static;
}
.fixed {
    position: fixed;
}
.absolute {
    position: absolute;
}
.relative {
    position: relative;
}
.sticky {
    position: sticky;
}
.inset-0 {
    inset: 0px;
}
.inset-x-0 {
    left: 0px;
    right: 0px;
}
.-end-2 {
    inset-inline-end: -0.5rem;
}
.-top-2 {
    top: -0.5rem;
}
.-top-px {
    top: -1px;
}
.bottom-0 {
    bottom: 0px;
}
.bottom-8 {
    bottom: 2rem;
}
.bottom-\\[0px\\] {
    bottom: 0px;
}
.bottom-\\[10\\.0rem\\] {
    bottom: 10.0rem;
}
.bottom-\\[4\\.5rem\\] {
    bottom: 4.5rem;
}
.bottom-\\[7\\.2rem\\] {
    bottom: 7.2rem;
}
.bottom-\\[72px\\] {
    bottom: 72px;
}
.left-0 {
    left: 0px;
}
.left-1\\/2 {
    left: 50%;
}
.left-2 {
    left: 0.5rem;
}
.left-2\\/4 {
    left: 50%;
}
.left-\\[40\\%\\] {
    left: 40%;
}
.right-0 {
    right: 0px;
}
.right-1\\/2 {
    right: 50%;
}
.right-2 {
    right: 0.5rem;
}
.right-3\\.5 {
    right: 0.875rem;
}
.top-0 {
    top: 0px;
}
.top-0\\.5 {
    top: 0.125rem;
}
.top-1\\/2 {
    top: 50%;
}
.top-2 {
    top: 0.5rem;
}
.top-2\\.5 {
    top: 0.625rem;
}
.top-\\[-55\\%\\] {
    top: -55%;
}
.top-\\[12vh\\] {
    top: 12vh;
}
.top-\\[40px\\] {
    top: 40px;
}
.z-10 {
    z-index: 10;
}
.z-20 {
    z-index: 20;
}
.z-40 {
    z-index: 40;
}
.z-50 {
    z-index: 50;
}
.z-\\[101\\] {
    z-index: 101;
}
.col-span-2 {
    grid-column: span 2 / span 2;
}
.-m-\\[2px\\] {
    margin: -2px;
}
.m-0 {
    margin: 0px;
}
.m-1 {
    margin: 0.25rem;
}
.m-2 {
    margin: 0.5rem;
}
.m-4 {
    margin: 1rem;
}
.m-6 {
    margin: 1.5rem;
}
.m-8 {
    margin: 2rem;
}
.-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
}
.mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
}
.mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}
.mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
}
.mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
}
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.mx-px {
    margin-left: 1px;
    margin-right: 1px;
}
.my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.my-14 {
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
}
.my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.my-2\\.5 {
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
}
.my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
}
.my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}
.my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
}
.my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
}
.my-\\[2px\\] {
    margin-top: 2px;
    margin-bottom: 2px;
}
.my-px {
    margin-top: 1px;
    margin-bottom: 1px;
}
.-mb-\\[124px\\] {
    margin-bottom: -124px;
}
.-ml-1 {
    margin-left: -0.25rem;
}
.-ml-4 {
    margin-left: -1rem;
}
.-mr-1 {
    margin-right: -0.25rem;
}
.-mt-1 {
    margin-top: -0.25rem;
}
.-mt-6 {
    margin-top: -1.5rem;
}
.mb-0 {
    margin-bottom: 0px;
}
.mb-0\\.5 {
    margin-bottom: 0.125rem;
}
.mb-1 {
    margin-bottom: 0.25rem;
}
.mb-10 {
    margin-bottom: 2.5rem;
}
.mb-12 {
    margin-bottom: 3rem;
}
.mb-2 {
    margin-bottom: 0.5rem;
}
.mb-3 {
    margin-bottom: 0.75rem;
}
.mb-36 {
    margin-bottom: 9rem;
}
.mb-4 {
    margin-bottom: 1rem;
}
.mb-5 {
    margin-bottom: 1.25rem;
}
.mb-6 {
    margin-bottom: 1.5rem;
}
.mb-60 {
    margin-bottom: 15rem;
}
.mb-7 {
    margin-bottom: 1.75rem;
}
.mb-8 {
    margin-bottom: 2rem;
}
.mb-\\[\\.125rem\\] {
    margin-bottom: .125rem;
}
.mb-\\[8px\\] {
    margin-bottom: 8px;
}
.mb-auto {
    margin-bottom: auto;
}
.ml-1 {
    margin-left: 0.25rem;
}
.ml-10 {
    margin-left: 2.5rem;
}
.ml-2 {
    margin-left: 0.5rem;
}
.ml-2\\.5 {
    margin-left: 0.625rem;
}
.ml-3 {
    margin-left: 0.75rem;
}
.ml-4 {
    margin-left: 1rem;
}
.ml-64 {
    margin-left: 16rem;
}
.ml-\\[3px\\] {
    margin-left: 3px;
}
.ml-auto {
    margin-left: auto;
}
.ml-px {
    margin-left: 1px;
}
.mr-0 {
    margin-right: 0px;
}
.mr-1 {
    margin-right: 0.25rem;
}
.mr-1\\.5 {
    margin-right: 0.375rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.mr-3 {
    margin-right: 0.75rem;
}
.mr-4 {
    margin-right: 1rem;
}
.mr-8 {
    margin-right: 2rem;
}
.mr-\\[2px\\] {
    margin-right: 2px;
}
.mr-auto {
    margin-right: auto;
}
.mt-0 {
    margin-top: 0px;
}
.mt-1 {
    margin-top: 0.25rem;
}
.mt-10 {
    margin-top: 2.5rem;
}
.mt-12 {
    margin-top: 3rem;
}
.mt-2 {
    margin-top: 0.5rem;
}
.mt-2\\.5 {
    margin-top: 0.625rem;
}
.mt-3 {
    margin-top: 0.75rem;
}
.mt-4 {
    margin-top: 1rem;
}
.mt-5 {
    margin-top: 1.25rem;
}
.mt-6 {
    margin-top: 1.5rem;
}
.mt-7 {
    margin-top: 1.75rem;
}
.mt-8 {
    margin-top: 2rem;
}
.mt-\\[-10px\\] {
    margin-top: -10px;
}
.mt-\\[2px\\] {
    margin-top: 2px;
}
.mt-\\[8px\\] {
    margin-top: 8px;
}
.mt-px {
    margin-top: 1px;
}
.block {
    display: block;
}
.inline-block {
    display: inline-block;
}
.inline {
    display: inline;
}
.flex {
    display: flex;
}
.inline-flex {
    display: inline-flex;
}
.table {
    display: table;
}
.\\!grid {
    display: grid !important;
}
.grid {
    display: grid;
}
.hidden {
    display: none;
}
.size-12 {
    width: 3rem;
    height: 3rem;
}
.size-9 {
    width: 2.25rem;
    height: 2.25rem;
}
.h-10 {
    height: 2.5rem;
}
.h-12 {
    height: 3rem;
}
.h-14 {
    height: 3.5rem;
}
.h-16 {
    height: 4rem;
}
.h-2 {
    height: 0.5rem;
}
.h-2\\/3 {
    height: 66.666667%;
}
.h-20 {
    height: 5rem;
}
.h-3 {
    height: 0.75rem;
}
.h-4 {
    height: 1rem;
}
.h-4\\/5 {
    height: 80%;
}
.h-5 {
    height: 1.25rem;
}
.h-6 {
    height: 1.5rem;
}
.h-7 {
    height: 1.75rem;
}
.h-8 {
    height: 2rem;
}
.h-80 {
    height: 20rem;
}
.h-9 {
    height: 2.25rem;
}
.h-\\[--header-height\\] {
    height: var(--header-height);
}
.h-\\[--navbar-height\\] {
    height: var(--navbar-height);
}
.h-\\[--sticky-header-height\\] {
    height: var(--sticky-header-height);
}
.h-\\[20px\\] {
    height: 20px;
}
.h-\\[235px\\] {
    height: 235px;
}
.h-\\[25px\\] {
    height: 25px;
}
.h-\\[285px\\] {
    height: 285px;
}
.h-\\[300px\\] {
    height: 300px;
}
.h-\\[355px\\] {
    height: 355px;
}
.h-\\[40px\\] {
    height: 40px;
}
.h-\\[45px\\] {
    height: 45px;
}
.h-\\[50\\%\\] {
    height: 50%;
}
.h-\\[55px\\] {
    height: 55px;
}
.h-\\[60px\\] {
    height: 60px;
}
.h-\\[70vh\\] {
    height: 70vh;
}
.h-\\[72px\\] {
    height: 72px;
}
.h-\\[80px\\] {
    height: 80px;
}
.h-\\[90vh\\] {
    height: 90vh;
}
.h-\\[92\\%\\] {
    height: 92%;
}
.h-auto {
    height: auto;
}
.h-dvh {
    height: 100dvh;
}
.h-fit {
    height: -moz-fit-content;
    height: fit-content;
}
.h-full {
    height: 100%;
}
.h-max {
    height: -moz-max-content;
    height: max-content;
}
.h-px {
    height: 1px;
}
.h-screen {
    height: 100vh;
}
.max-h-0 {
    max-height: 0px;
}
.max-h-36 {
    max-height: 9rem;
}
.max-h-\\[265px\\] {
    max-height: 265px;
}
.max-h-\\[550px\\] {
    max-height: 550px;
}
.max-h-full {
    max-height: 100%;
}
.max-h-screen {
    max-height: 100vh;
}
.min-h-0 {
    min-height: 0px;
}
.min-h-14 {
    min-height: 3.5rem;
}
.min-h-2 {
    min-height: 0.5rem;
}
.min-h-3 {
    min-height: 0.75rem;
}
.min-h-\\[26px\\] {
    min-height: 26px;
}
.min-h-\\[300px\\] {
    min-height: 300px;
}
.min-h-\\[70vh\\] {
    min-height: 70vh;
}
.w-1\\/2 {
    width: 50%;
}
.w-1\\/3 {
    width: 33.333333%;
}
.w-10 {
    width: 2.5rem;
}
.w-11\\/12 {
    width: 91.666667%;
}
.w-12 {
    width: 3rem;
}
.w-14 {
    width: 3.5rem;
}
.w-16 {
    width: 4rem;
}
.w-2 {
    width: 0.5rem;
}
.w-20 {
    width: 5rem;
}
.w-28 {
    width: 7rem;
}
.w-3 {
    width: 0.75rem;
}
.w-4 {
    width: 1rem;
}
.w-4\\/5 {
    width: 80%;
}
.w-48 {
    width: 12rem;
}
.w-5 {
    width: 1.25rem;
}
.w-6 {
    width: 1.5rem;
}
.w-64 {
    width: 16rem;
}
.w-7 {
    width: 1.75rem;
}
.w-8 {
    width: 2rem;
}
.w-9 {
    width: 2.25rem;
}
.w-\\[192px\\] {
    width: 192px;
}
.w-\\[200px\\] {
    width: 200px;
}
.w-\\[20px\\] {
    width: 20px;
}
.w-\\[25px\\] {
    width: 25px;
}
.w-\\[32px\\] {
    width: 32px;
}
.w-\\[33\\%\\] {
    width: 33%;
}
.w-\\[358px\\] {
    width: 358px;
}
.w-\\[372px\\] {
    width: 372px;
}
.w-\\[400px\\] {
    width: 400px;
}
.w-\\[500px\\] {
    width: 500px;
}
.w-\\[650px\\] {
    width: 650px;
}
.w-\\[67\\%\\] {
    width: 67%;
}
.w-\\[86px\\] {
    width: 86px;
}
.w-\\[fit-content\\] {
    width: -moz-fit-content;
    width: fit-content;
}
.w-auto {
    width: auto;
}
.w-full {
    width: 100%;
}
.w-px {
    width: 1px;
}
.w-screen {
    width: 100vw;
}
.min-w-0 {
    min-width: 0px;
}
.min-w-2 {
    min-width: 0.5rem;
}
.min-w-24 {
    min-width: 6rem;
}
.min-w-28 {
    min-width: 7rem;
}
.min-w-4 {
    min-width: 1rem;
}
.min-w-6 {
    min-width: 1.5rem;
}
.min-w-8 {
    min-width: 2rem;
}
.min-w-9 {
    min-width: 2.25rem;
}
.min-w-96 {
    min-width: 24rem;
}
.min-w-\\[25vw\\] {
    min-width: 25vw;
}
.min-w-\\[350px\\] {
    min-width: 350px;
}
.min-w-\\[50\\%\\] {
    min-width: 50%;
}
.min-w-\\[90\\%\\] {
    min-width: 90%;
}
.max-w-2xl {
    max-width: 42rem;
}
.max-w-40 {
    max-width: 10rem;
}
.max-w-\\[100px\\] {
    max-width: 100px;
}
.max-w-\\[130px\\] {
    max-width: 130px;
}
.max-w-\\[140px\\] {
    max-width: 140px;
}
.max-w-\\[150px\\] {
    max-width: 150px;
}
.max-w-\\[160px\\] {
    max-width: 160px;
}
.max-w-\\[200px\\] {
    max-width: 200px;
}
.max-w-\\[300px\\] {
    max-width: 300px;
}
.max-w-\\[400px\\] {
    max-width: 400px;
}
.max-w-\\[448px\\] {
    max-width: 448px;
}
.max-w-\\[500px\\] {
    max-width: 500px;
}
.max-w-\\[50vw\\] {
    max-width: 50vw;
}
.max-w-\\[60\\%\\] {
    max-width: 60%;
}
.max-w-\\[600px\\] {
    max-width: 600px;
}
.max-w-\\[650px\\] {
    max-width: 650px;
}
.max-w-\\[700px\\] {
    max-width: 700px;
}
.max-w-\\[75\\%\\] {
    max-width: 75%;
}
.max-w-\\[80\\%\\] {
    max-width: 80%;
}
.max-w-\\[800px\\] {
    max-width: 800px;
}
.max-w-\\[85\\%\\] {
    max-width: 85%;
}
.max-w-fit {
    max-width: -moz-fit-content;
    max-width: fit-content;
}
.max-w-full {
    max-width: 100%;
}
.max-w-lg {
    max-width: 32rem;
}
.max-w-md {
    max-width: 28rem;
}
.max-w-sm {
    max-width: 24rem;
}
.flex-1 {
    flex: 1 1 0%;
}
.flex-auto {
    flex: 1 1 auto;
}
.flex-none {
    flex: none;
}
.flex-shrink {
    flex-shrink: 1;
}
.flex-shrink-0 {
    flex-shrink: 0;
}
.shrink {
    flex-shrink: 1;
}
.flex-grow {
    flex-grow: 1;
}
.grow {
    flex-grow: 1;
}
.basis-full {
    flex-basis: 100%;
}
.border-collapse {
    border-collapse: collapse;
}
.origin-center {
    transform-origin: center;
}
.-translate-x-0 {
    --tw-translate-x: -0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-20 {
    --tw-translate-x: -5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
    --tw-translate-x: -100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
    --tw-translate-y: -100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\/4 {
    --tw-translate-x: 50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
    --tw-translate-x: 100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite;
}
.cursor-default {
    cursor: default;
}
.cursor-not-allowed {
    cursor: not-allowed;
}
.cursor-pointer {
    cursor: pointer;
}
.select-none {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}
.resize {
    resize: both;
}
.list-inside {
    list-style-position: inside;
}
.list-disc {
    list-style-type: disc;
}
.appearance-none {
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-\\[0fr\\] {
    grid-template-columns: 0fr;
}
.grid-cols-\\[1fr\\] {
    grid-template-columns: 1fr;
}
.grid-cols-\\[auto_1fr\\] {
    grid-template-columns: auto 1fr;
}
.grid-cols-\\[auto_auto\\] {
    grid-template-columns: auto auto;
}
.grid-cols-\\[max-content_1fr\\] {
    grid-template-columns: max-content 1fr;
}
.flex-row {
    flex-direction: row;
}
.flex-row-reverse {
    flex-direction: row-reverse;
}
.flex-col {
    flex-direction: column;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex-nowrap {
    flex-wrap: nowrap;
}
.place-content-center {
    place-content: center;
}
.content-center {
    align-content: center;
}
.items-start {
    align-items: flex-start;
}
.items-end {
    align-items: flex-end;
}
.items-center {
    align-items: center;
}
.items-baseline {
    align-items: baseline;
}
.justify-start {
    justify-content: flex-start;
}
.justify-end {
    justify-content: flex-end;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.justify-around {
    justify-content: space-around;
}
.justify-items-start {
    justify-items: start;
}
.justify-items-end {
    justify-items: end;
}
.justify-items-center {
    justify-items: center;
}
.gap-0\\.5 {
    gap: 0.125rem;
}
.gap-1 {
    gap: 0.25rem;
}
.gap-10 {
    gap: 2.5rem;
}
.gap-2 {
    gap: 0.5rem;
}
.gap-3 {
    gap: 0.75rem;
}
.gap-4 {
    gap: 1rem;
}
.gap-5 {
    gap: 1.25rem;
}
.gap-6 {
    gap: 1.5rem;
}
.gap-8 {
    gap: 2rem;
}
.gap-\\[\\.825rem\\] {
    gap: .825rem;
}
.gap-\\[6px\\] {
    gap: 6px;
}
.gap-x-1 {
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
}
.gap-x-10 {
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
}
.gap-x-2 {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
}
.gap-x-3 {
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
}
.gap-x-32 {
    -moz-column-gap: 8rem;
         column-gap: 8rem;
}
.gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
}
.gap-y-10 {
    row-gap: 2.5rem;
}
.gap-y-2 {
    row-gap: 0.5rem;
}
.gap-y-5 {
    row-gap: 1.25rem;
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[--border-color\\] > :not([hidden]) ~ :not([hidden]) {
    border-color: var(--border-color);
}
.self-start {
    align-self: flex-start;
}
.self-end {
    align-self: flex-end;
}
.self-center {
    align-self: center;
}
.justify-self-center {
    justify-self: center;
}
.overflow-auto {
    overflow: auto;
}
.overflow-hidden {
    overflow: hidden;
}
.overflow-clip {
    overflow: clip;
}
.overflow-scroll {
    overflow: scroll;
}
.overflow-x-auto {
    overflow-x: auto;
}
.overflow-y-auto {
    overflow-y: auto;
}
.text-ellipsis {
    text-overflow: ellipsis;
}
.whitespace-normal {
    white-space: normal;
}
.whitespace-nowrap {
    white-space: nowrap;
}
.text-wrap {
    text-wrap: wrap;
}
.text-nowrap {
    text-wrap: nowrap;
}
.text-balance {
    text-wrap: balance;
}
.break-words {
    overflow-wrap: break-word;
}
.break-all {
    word-break: break-all;
}
.rounded {
    border-radius: 0.25rem;
}
.rounded-full {
    border-radius: 9999px;
}
.rounded-lg {
    border-radius: 0.5rem;
}
.rounded-md {
    border-radius: 0.375rem;
}
.rounded-none {
    border-radius: 0px;
}
.rounded-sm {
    border-radius: 0.125rem;
}
.rounded-xl {
    border-radius: 0.75rem;
}
.rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}
.rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
.rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
}
.rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
}
.rounded-tl-md {
    border-top-left-radius: 0.375rem;
}
.rounded-tl-xl {
    border-top-left-radius: 0.75rem;
}
.rounded-tr-xl {
    border-top-right-radius: 0.75rem;
}
.border {
    border-width: 1px;
}
.border-0 {
    border-width: 0px;
}
.border-2 {
    border-width: 2px;
}
.border-4 {
    border-width: 4px;
}
.border-x {
    border-left-width: 1px;
    border-right-width: 1px;
}
.border-y {
    border-top-width: 1px;
    border-bottom-width: 1px;
}
.border-b {
    border-bottom-width: 1px;
}
.border-b-4 {
    border-bottom-width: 4px;
}
.border-l {
    border-left-width: 1px;
}
.border-l-4 {
    border-left-width: 4px;
}
.border-l-\\[3px\\] {
    border-left-width: 3px;
}
.border-r {
    border-right-width: 1px;
}
.border-t {
    border-top-width: 1px;
}
.border-t-2 {
    border-top-width: 2px;
}
.border-t-4 {
    border-top-width: 4px;
}
.border-t-8 {
    border-top-width: 8px;
}
.border-solid {
    border-style: solid;
}
.border-dashed {
    border-style: dashed;
}
.border-dotted {
    border-style: dotted;
}
.border-none {
    border-style: none;
}
.\\!border-\\[--active-item-border\\] {
    border-color: var(--active-item-border) !important;
}
.border-\\[\\#BADCFB\\] {
    --tw-border-opacity: 1;
    border-color: rgb(186 220 251 / var(--tw-border-opacity, 1));
}
.border-\\[--active-item-border\\] {
    border-color: var(--active-item-border);
}
.border-\\[--badge-border\\] {
    border-color: var(--badge-border);
}
.border-\\[--border-color\\] {
    border-color: var(--border-color);
}
.border-\\[--brand-100\\] {
    border-color: var(--brand-100);
}
.border-\\[--brand-primary-50-percent\\] {
    border-color: var(--brand-primary-50-percent);
}
.border-\\[--button-border\\] {
    border-color: var(--button-border);
}
.border-\\[--color-brand\\] {
    border-color: var(--color-brand);
}
.border-\\[--content-attention\\] {
    border-color: var(--content-attention);
}
.border-\\[--default\\] {
    border-color: var(--default);
}
.border-\\[--input-field-border\\] {
    border-color: var(--input-field-border);
}
.border-\\[--reversed\\] {
    border-color: var(--reversed);
}
.border-\\[--secondary-text-color\\] {
    border-color: var(--secondary-text-color);
}
.border-\\[--tab-border\\] {
    border-color: var(--tab-border);
}
.border-\\[--timeline-color\\] {
    border-color: var(--timeline-color);
}
.border-\\[--tm-color-gray-light-30\\] {
    border-color: var(--tm-color-gray-light-30);
}
.border-\\[--wrapper-border\\] {
    border-color: var(--wrapper-border);
}
.border-\\[var\\(--content-positive\\)\\] {
    border-color: var(--content-positive);
}
.border-attention {
    border-color: var(--content-attention);
}
.border-black {
    border-color: var(--jh-color-gray-1000);
}
.border-brand {
    border-color: var(--brand-primary);
}
.border-brand-content {
    border-color: var(--content-brand);
}
.border-container-page {
    border-color: var(--container-page);
}
.border-gray-100 {
    border-color: var(--jh-color-gray-100);
}
.border-gray-300 {
    border-color: var(--jh-color-gray-300);
}
.border-gray-400 {
    border-color: var(--jh-color-gray-400);
}
.border-gray-400-50 {
    border-color: var(--tm-color-gray-400-50);
}
.border-gray-light {
    border-color: var(--tm-color-gray-light);
}
.border-gray-medium-30 {
    border-color: var(--tm-color-gray-medium-30);
}
.border-negative {
    border-color: var(--content-negative);
}
.border-positive {
    border-color: var(--content-positive);
}
.border-transparent {
    border-color: transparent;
}
.border-white {
    border-color: var(--jh-color-gray-0);
}
.border-r-transparent {
    border-right-color: transparent;
}
.bg-\\[\\#00000080\\] {
    background-color: #00000080;
}
.bg-\\[\\#444444\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(68 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECF5FE\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(236 245 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff33\\] {
    background-color: #ffffff33;
}
.bg-\\[--active-item-overlay\\] {
    background-color: var(--active-item-overlay);
}
.bg-\\[--badge-background\\] {
    background-color: var(--badge-background);
}
.bg-\\[--color-brand\\] {
    background-color: var(--color-brand);
}
.bg-\\[--container-header\\] {
    background-color: var(--container-header);
}
.bg-\\[--jh-color-red-500\\] {
    background-color: var(--jh-color-red-500);
}
.bg-\\[--jha-background-color\\] {
    background-color: var(--jha-background-color);
}
.bg-\\[--scroll-indicator\\] {
    background-color: var(--scroll-indicator);
}
.bg-\\[--surface-1\\] {
    background-color: var(--surface-1);
}
.bg-\\[--tab-bg-disabled\\] {
    background-color: var(--tab-bg-disabled);
}
.bg-\\[--timeline-color\\] {
    background-color: var(--timeline-color);
}
.bg-\\[--tm-color-gray-medium-15\\] {
    background-color: var(--tm-color-gray-medium-15);
}
.bg-attention {
    background-color: var(--content-attention);
}
.bg-black {
    background-color: var(--jh-color-gray-1000);
}
.bg-brand {
    background-color: var(--brand-primary);
}
.bg-brand-15 {
    background-color: var(--brand-15);
}
.bg-brand-darker {
    background-color: var(--brand-primary-darker);
}
.bg-container-page {
    background-color: var(--container-page);
}
.bg-container-primary {
    background-color: var(--container-primary);
}
.bg-gray-300 {
    background-color: var(--jh-color-gray-300);
}
.bg-gray-400 {
    background-color: var(--jh-color-gray-400);
}
.bg-gray-light-30 {
    background-color: var(--tm-color-gray-light-30);
}
.bg-header {
    background-color: var(--container-header);
}
.bg-mint-150 {
    background-color: var(--jh-color-mint-150);
}
.bg-negative {
    background-color: var(--content-negative);
}
.bg-page {
    background-color: var(--container-page);
}
.bg-positive {
    background-color: var(--content-positive);
}
.bg-primary {
    background-color: var(--container-primary);
}
.bg-red-500 {
    background-color: var(--jh-color-red-500);
}
.bg-transparent {
    background-color: transparent;
}
.bg-white {
    background-color: var(--jh-color-gray-0);
}
.bg-opacity-50 {
    --tw-bg-opacity: 0.5;
}
.bg-opacity-75 {
    --tw-bg-opacity: 0.75;
}
.bg-cover {
    background-size: cover;
}
.bg-top {
    background-position: top;
}
.bg-no-repeat {
    background-repeat: no-repeat;
}
.fill-\\[\\#085CE5\\] {
    fill: #085CE5;
}
.object-contain {
    -o-object-fit: contain;
       object-fit: contain;
}
.p-0 {
    padding: 0px;
}
.p-0\\.5 {
    padding: 0.125rem;
}
.p-1 {
    padding: 0.25rem;
}
.p-2 {
    padding: 0.5rem;
}
.p-2\\.5 {
    padding: 0.625rem;
}
.p-3 {
    padding: 0.75rem;
}
.p-4 {
    padding: 1rem;
}
.p-5 {
    padding: 1.25rem;
}
.p-6 {
    padding: 1.5rem;
}
.p-\\[--navbar-padding\\] {
    padding: var(--navbar-padding);
}
.p-\\[2px\\] {
    padding: 2px;
}
.p-\\[30px\\] {
    padding: 30px;
}
.px-0\\.5 {
    padding-left: 0.125rem;
    padding-right: 0.125rem;
}
.px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
.px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
}
.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
.px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}
.px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
.px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
}
.py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
}
.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
.py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
.py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
}
.py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
}
.py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}
.py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
}
.py-\\[2px\\] {
    padding-top: 2px;
    padding-bottom: 2px;
}
.py-\\[4px\\] {
    padding-top: 4px;
    padding-bottom: 4px;
}
.py-px {
    padding-top: 1px;
    padding-bottom: 1px;
}
.pb-0 {
    padding-bottom: 0px;
}
.pb-1 {
    padding-bottom: 0.25rem;
}
.pb-2 {
    padding-bottom: 0.5rem;
}
.pb-2\\.5 {
    padding-bottom: 0.625rem;
}
.pb-24 {
    padding-bottom: 6rem;
}
.pb-3 {
    padding-bottom: 0.75rem;
}
.pb-4 {
    padding-bottom: 1rem;
}
.pb-5 {
    padding-bottom: 1.25rem;
}
.pb-6 {
    padding-bottom: 1.5rem;
}
.pb-7 {
    padding-bottom: 1.75rem;
}
.pb-\\[--sticky-header-height\\] {
    padding-bottom: var(--sticky-header-height);
}
.pb-\\[1\\.875rem\\] {
    padding-bottom: 1.875rem;
}
.pb-\\[25px\\] {
    padding-bottom: 25px;
}
.pl-0 {
    padding-left: 0px;
}
.pl-1 {
    padding-left: 0.25rem;
}
.pl-10 {
    padding-left: 2.5rem;
}
.pl-2 {
    padding-left: 0.5rem;
}
.pl-20 {
    padding-left: 5rem;
}
.pl-3 {
    padding-left: 0.75rem;
}
.pl-4 {
    padding-left: 1rem;
}
.pl-6 {
    padding-left: 1.5rem;
}
.pl-7 {
    padding-left: 1.75rem;
}
.pl-8 {
    padding-left: 2rem;
}
.pr-1 {
    padding-right: 0.25rem;
}
.pr-2 {
    padding-right: 0.5rem;
}
.pr-3 {
    padding-right: 0.75rem;
}
.pr-4 {
    padding-right: 1rem;
}
.pr-6 {
    padding-right: 1.5rem;
}
.pt-0 {
    padding-top: 0px;
}
.pt-1 {
    padding-top: 0.25rem;
}
.pt-10 {
    padding-top: 2.5rem;
}
.pt-12 {
    padding-top: 3rem;
}
.pt-2 {
    padding-top: 0.5rem;
}
.pt-2\\.5 {
    padding-top: 0.625rem;
}
.pt-3 {
    padding-top: 0.75rem;
}
.pt-3\\.5 {
    padding-top: 0.875rem;
}
.pt-4 {
    padding-top: 1rem;
}
.pt-6 {
    padding-top: 1.5rem;
}
.pt-7 {
    padding-top: 1.75rem;
}
.pt-8 {
    padding-top: 2rem;
}
.pt-\\[--safe-area-top\\] {
    padding-top: var(--safe-area-top);
}
.pt-\\[14px\\] {
    padding-top: 14px;
}
.text-left {
    text-align: left;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
.text-start {
    text-align: start;
}
.text-end {
    text-align: end;
}
.align-top {
    vertical-align: top;
}
.align-middle {
    vertical-align: middle;
}
.font-source {
    font-family: "Source Sans 3", ui-sans-serif, system-ui, sans-serif;
}
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}
.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}
.text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
}
.text-\\[10px\\] {
    font-size: 10px;
}
.text-\\[12\\.8px\\] {
    font-size: 12.8px;
}
.text-\\[13px\\] {
    font-size: 13px;
}
.text-base {
    font-size: 1rem;
    line-height: 1.5rem;
}
.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
}
.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}
.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}
.text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
}
.font-black {
    font-weight: 900;
}
.font-bold {
    font-weight: 700;
}
.font-light {
    font-weight: 300;
}
.font-medium {
    font-weight: 500;
}
.font-normal {
    font-weight: 400;
}
.font-semibold {
    font-weight: 600;
}
.font-thin {
    font-weight: 100;
}
.uppercase {
    text-transform: uppercase;
}
.lowercase {
    text-transform: lowercase;
}
.capitalize {
    text-transform: capitalize;
}
.italic {
    font-style: italic;
}
.leading-10 {
    line-height: 2.5rem;
}
.leading-3 {
    line-height: .75rem;
}
.leading-5 {
    line-height: 1.25rem;
}
.leading-6 {
    line-height: 1.5rem;
}
.leading-8 {
    line-height: 2rem;
}
.leading-9 {
    line-height: 2.25rem;
}
.leading-\\[13px\\] {
    line-height: 13px;
}
.leading-\\[150\\%\\] {
    line-height: 150%;
}
.leading-\\[2\\.4rem\\] {
    line-height: 2.4rem;
}
.leading-none {
    line-height: 1;
}
.leading-snug {
    line-height: 1.375;
}
.leading-tight {
    line-height: 1.25;
}
.tracking-wide {
    letter-spacing: 0.025em;
}
.text-\\[\\#D92D20\\] {
    --tw-text-opacity: 1;
    color: rgb(217 45 32 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E6E6E6\\] {
    --tw-text-opacity: 1;
    color: rgb(230 230 230 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFF99\\] {
    color: #FFFFFF99;
}
.text-\\[--badge-text\\] {
    color: var(--badge-text);
}
.text-\\[--content-secondary\\] {
    color: var(--content-secondary);
}
.text-\\[--disabled\\] {
    color: var(--disabled);
}
.text-\\[--header-text-color\\] {
    color: var(--header-text-color);
}
.text-\\[--jh-color-gray-900\\] {
    color: var(--jh-color-gray-900);
}
.text-\\[--primary-text-color\\] {
    color: var(--primary-text-color);
}
.text-\\[--secondary-text-color\\] {
    color: var(--secondary-text-color);
}
.text-\\[--tab-text-disabled\\] {
    color: var(--tab-text-disabled);
}
.text-\\[--tab-text\\] {
    color: var(--tab-text);
}
.text-\\[color\\:--content-negative\\] {
    color: var(--content-negative);
}
.text-\\[color\\:var\\(--brand-color\\)\\] {
    color: var(--brand-color);
}
.text-\\[var\\(--jh-color-red-500\\)\\] {
    color: var(--jh-color-red-500);
}
.text-action {
    color: var(--content-action);
}
.text-attention {
    color: var(--content-attention);
}
.text-brand {
    color: var(--brand-primary);
}
.text-gray-0 {
    color: var(--jh-color-gray-0);
}
.text-gray-100 {
    color: var(--jh-color-gray-100);
}
.text-gray-300 {
    color: var(--jh-color-gray-300);
}
.text-gray-500 {
    color: var(--jh-color-gray-500);
}
.text-gray-600 {
    color: var(--jh-color-gray-600);
}
.text-green-600 {
    color: var(--jh-color-green-600);
}
.text-header {
    color: var(--header-text-color);
}
.text-light {
    color: var(--content-light);
}
.text-negative {
    color: var(--content-negative);
}
.text-orange-500 {
    color: var(--jh-color-orange-500);
}
.text-positive {
    color: var(--content-positive);
}
.text-primary {
    color: var(--primary-text-color);
}
.text-red-500 {
    color: var(--jh-color-red-500);
}
.text-red-600 {
    color: var(--jh-color-red-600);
}
.text-secondary {
    color: var(--secondary-text-color);
}
.text-tertiary {
    color: var(--tertiary-text-color);
}
.text-white {
    color: var(--jh-color-gray-0);
}
.underline {
    text-decoration-line: underline;
}
.no-underline {
    text-decoration-line: none;
}
.underline-offset-2 {
    text-underline-offset: 2px;
}
.opacity-0 {
    opacity: 0;
}
.opacity-100 {
    opacity: 1;
}
.opacity-20 {
    opacity: 0.2;
}
.opacity-25 {
    opacity: 0.25;
}
.opacity-50 {
    opacity: 0.5;
}
.shadow {
    --tw-shadow: var(--content-shadow);
    --tw-shadow-colored: var(--content-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.outline {
    outline-style: solid;
}
.blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
    --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-filter {
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[grid-template-columns\\] {
    transition-property: grid-template-columns;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[max-height\\] {
    transition-property: max-height;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-opacity {
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.duration-200 {
    transition-duration: 200ms;
}
.duration-500 {
    transition-duration: 500ms;
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\@container {
    container-type: inline-size;
}
:host {
    display: block;
}
:root {
    --safe-area-top: env(safe-area-inset-top);
    --lumo-font-family: 'Roboto', sans-serif;
}
body {
    background: var(--container-primary, var(--brand-primary));
    font-family: 'Roboto', sans-serif;
    margin: 0;
}
html,
body,
app-component,
main,
jhd-layout,
navigation-menu,
#navigation-container,
#navigation-background {
    overflow: hidden;
    height: 100vh; /* set fallback for browsers that don't support dvh units */
    height: 100dvh;
}
.brand-color {
    color: var(--brand-color);
}
.bg-brand-color {
    background-color: var(--brand-color);
}
.card-footer {
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.15);
    background: var(--container-primary);
    padding: 10px 0 10px 0;
    z-index: 2;
}
.edited,
.edited-true {
    background: var(--content-highlight);
}
omega-progress {
    margin: auto;
    border-width: 2px;
    border-style: solid;
    border-color: var(--omega-progress-color, var(--primary-text-color));
    border-right-color: transparent !important;
    top: 50%;
    left: 50%;
}
vaadin-notification-card {
    --lumo-space-wide-l: 1em;
}
html[theme='dark'] vaadin-multi-select-combo-box-overlay::part(overlay),
html[theme='dark'] vaadin-select-overlay::part(overlay),
html[theme='dark'] vaadin-date-picker-overlay::part(overlay) {
    background-image: none;
    background-color: var(--border-color);
}
/* Ensure Roboto font is used in select overlay items */
vaadin-select-overlay vaadin-select-item::part(content) {
    font-family: 'Roboto', sans-serif;
}
html[theme='dark'] vaadin-dialog-overlay::part(overlay),
html[theme='dark'] vaadin-date-picker-overlay::part(overlay) {
    box-shadow: var(--content-shadow);
    background-color: var(--container-header);
}
vaadin-date-picker-overlay,
vaadin-select-overlay,
vaadin-multi-select-combo-box-overlay {
    z-index: 2000;
}
html[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar {
    color: var(--jh-color-gray-0);
}
html[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar::part(month-header) {
    color: var(--tm-color-gray-light);
}
html[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar::part(weekday) {
    color: var(--tm-color-gray-medium);
}
html[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar[disabled] {
    --lumo-disabled-text-color: var(--tm-color-gray-light-15);
}
html[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar::part(disabled) {
    color: var(--tm-color-gray-light-15) !important;
}
@media (max-width: 600px) {
    .card-footer {
        border-radius: 0;
        padding: 0;
    }
}
.feature-disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
}
.new-indicator,
.unread-indicator {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #0164cc;
    margin-right: 5px;
}
/* PWA custom classes */
.pwa-table-wrapper {
    background-color: var(--container-primary);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 12px;
}
.input-container {
    background-color: var(--input-field-background);
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid var(--input-field-border);
    padding: 0.5rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    width: -moz-fit-content;
    width: fit-content;
    color: var(--input-field-text);
    font-weight: 500;
}
.input-container--disabled {
    background-color: var(--input-field-background);
    color: var(--input-field-disabled);
    cursor: not-allowed;
}
/* PWA component rules */
tm-form-row:not(:last-child),
tm-form-row-message-center:not(:last-child),
tm-form-frequency:not(:last-child) > tm-form-row {
    border-bottom-color: var(--border-color);
    border-bottom-style: solid;
    border-bottom-width: 1px;
}
tm-form-row:last-child,
tm-form-row-message-center:last-child,
tm-form-frequency:last-child > tm-form-row {
    border-bottom-style: unset;
    border-bottom-width: unset;
}
tm-form-frequency {
    --disabled: var(--primary-30);
}
tm-form-frequency[theme='dark'] {
    --disabled: var(--tm-color-gray-light-30);
}
tm-form-frequency .action-icon svg {
    width: 100%;
    height: auto;
}
tm-form-frequency .action-icon--disabled path {
    fill: var(--disabled);
}
/* override vaadin defaults */
vaadin-grid {
    font-family: var(--default-font-family);
}
vaadin-notification-card:not([theme='error']),
vaadin-notification-card:not([theme='warning']) {
    margin-top: 70px;
}
vaadin-notification-card[role='alert'] + vaadin-notification-card[role='alert'] {
    margin-top: 10px;
}
vaadin-notification-card .notification-content > div {
    overflow: hidden;
}
vaadin-tooltip-overlay::part(overlay) {
    border: 1px solid var(--jh-color-gray-500);
}
vaadin-context-menu-overlay.overrideDefault::part(overlay) {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
vaadin-context-menu-overlay.overrideDefault::part(content) {
    padding: 0;
    -webkit-mask-image: none;
            mask-image: none;
}
@media (max-width: 600px), (max-height: 600px) {
    vaadin-context-menu-overlay::part(overlay) {
        max-height: 50vh;
        width: 100vw;
    }
    vaadin-context-menu-overlay::part(content) {
        padding: 30px var(--lumo-space-m);
        max-height: inherit;
        box-sizing: border-box;
    }
}
#mitekDisplayContainer {
    z-index: 99998;
    background-color: gray;
}
.integrator {
    border: none;
}
#mitekHintMessage {
    background: rgba(0, 0, 0, 0.6);
    top: unset;
    bottom: 0;
    border: 1px solid white;
    color: white;
    padding: 4px 16px;
    border-radius: 8px;
    font-size: 0.95rem !important;
    font-weight: normal;
    text-wrap: nowrap;
    transform: translate(-50%, -20%);
    width: unset;
}
.leaving {
    animation: 0.2s fadeOut ease-in-out;
}
.entering {
    animation: 0.2s fadeIn linear;
}
@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
.first-of-type\\:rounded-l-lg:first-of-type {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
}
.first-of-type\\:border-r-0:first-of-type {
    border-right-width: 0px;
}
.first-of-type\\:pl-3:first-of-type {
    padding-left: 0.75rem;
}
.last-of-type\\:mr-0:last-of-type {
    margin-right: 0px;
}
.last-of-type\\:rounded-r-lg:last-of-type {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
}
.last-of-type\\:border-l-0:last-of-type {
    border-left-width: 0px;
}
.last-of-type\\:pr-3:last-of-type {
    padding-right: 0.75rem;
}
.hover\\:border-\\[--color-brand\\]:hover {
    border-color: var(--color-brand);
}
.hover\\:bg-\\[\\#00000026\\]:hover {
    background-color: #00000026;
}
.hover\\:bg-gray-100:hover {
    background-color: var(--jh-color-gray-100);
}
.hover\\:bg-white:hover {
    background-color: var(--jh-color-gray-0);
}
.hover\\:text-black:hover {
    color: var(--jh-color-gray-1000);
}
.hover\\:underline:hover {
    text-decoration-line: underline;
}
.hover\\:shadow-lg:hover {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.focus\\:ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[--color-brand\\]:focus {
    --tw-ring-color: var(--color-brand);
}
@container (min-width: 28rem) {
    .\\@md\\:inline-block {
        display: inline-block;
    }
}
@media (min-width: 600px) {
    .sm\\:relative {
        position: relative;
    }
    .sm\\:top-\\[5vh\\] {
        top: 5vh;
    }
    .sm\\:my-\\[30px\\] {
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .sm\\:h-auto {
        height: auto;
    }
    .sm\\:h-full {
        height: 100%;
    }
    .sm\\:max-w-80 {
        max-width: 20rem;
    }
    .sm\\:place-content-start {
        place-content: start;
    }
    .sm\\:rounded-\\[10px\\] {
        border-radius: 10px;
    }
    .sm\\:py-0 {
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .sm\\:pb-0 {
        padding-bottom: 0px;
    }
}
@media (min-width: 601px) {
    .min-\\[601px\\]\\:pl-0 {
        padding-left: 0px;
    }
}
@media (min-width: 768px) {
    .md\\:pointer-events-auto {
        pointer-events: auto;
    }
    .md\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px;
    }
    .md\\:ml-2 {
        margin-left: 0.5rem;
    }
    .md\\:ml-64 {
        margin-left: 16rem;
    }
    .md\\:ml-\\[50px\\] {
        margin-left: 50px;
    }
    .md\\:mr-0 {
        margin-right: 0px;
    }
    .md\\:mr-2 {
        margin-right: 0.5rem;
    }
    .md\\:block {
        display: block;
    }
    .md\\:flex {
        display: flex;
    }
    .md\\:hidden {
        display: none;
    }
    .md\\:size-6 {
        width: 1.5rem;
        height: 1.5rem;
    }
    .md\\:w-64 {
        width: 16rem;
    }
    .md\\:w-\\[50px\\] {
        width: 50px;
    }
    .md\\:min-w-6 {
        min-width: 1.5rem;
    }
    .md\\:-translate-x-0 {
        --tw-translate-x: -0px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }
    .md\\:translate-x-0 {
        --tw-translate-x: 0px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }
    .md\\:flex-row {
        flex-direction: row;
    }
    .md\\:justify-center {
        justify-content: center;
    }
    .md\\:gap-14 {
        gap: 3.5rem;
    }
    .md\\:self-start {
        align-self: flex-start;
    }
    .md\\:bg-header {
        background-color: var(--container-header);
    }
    .md\\:bg-transparent {
        background-color: transparent;
    }
    .md\\:pl-0 {
        padding-left: 0px;
    }
    .md\\:text-base {
        font-size: 1rem;
        line-height: 1.5rem;
    }
    .md\\:opacity-0 {
        opacity: 0;
    }
}
@media (min-width: 992px) {
    .lg\\:flex {
        display: flex;
    }
    .lg\\:hidden {
        display: none;
    }
    .lg\\:w-\\[50\\%\\] {
        width: 50%;
    }
}
@media (orientation: portrait) {
    .portrait\\:bottom-3 {
        bottom: 0.75rem;
    }
    .portrait\\:text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
    .portrait\\:leading-none {
        line-height: 1;
    }
}
@media (orientation: landscape) {
    .landscape\\:bottom-1 {
        bottom: 0.25rem;
    }
    .landscape\\:-mt-3 {
        margin-top: -0.75rem;
    }
}
`, "",{"version":3,"sources":["webpack://./../omega/css/forms/form-group.css","webpack://./../omega/css/forms/buttons/button-approve.css","webpack://./../omega/css/forms/buttons/button-reject.css","webpack://./../omega/css/forms/buttons/button-primary.css","webpack://./../omega/css/forms/buttons/button-secondary.css","webpack://./../omega/css/forms/buttons/button-icon.css","webpack://./../omega/css/forms/buttons/button-with-errors.css","webpack://./../omega/css/forms/buttons/buttons.css","webpack://./../omega/css/forms/checkbox.css","webpack://./../omega/css/forms/inputs.css","webpack://./../omega/css/forms/select.css","webpack://./../omega/css/forms/date-range.css","webpack://./../omega/css/forms/amount-range.css","webpack://./../omega/css/forms/toggle.css","webpack://./../omega/css/forms/combobox.css","webpack://./../omega/css/forms/multiple-select.css","webpack://./../omega/css/forms/autocomplete.css","webpack://./../omega/css/forms/datepicker.css","webpack://./../omega/css/forms/address.css","webpack://./../omega/css/forms/table-filters.css","webpack://./../omega/css/forms/forms.css","webpack://./../omega/css/table/table-core.css","webpack://./../omega/css/table/table-filters.css","webpack://./../omega/css/table/table-control-bar.css","webpack://./../omega/css/table/table-headers.css","webpack://./../omega/css/table/table-body.css","webpack://./../omega/css/table/table-pagination.css","webpack://./../omega/css/table/table-datatypes.css","webpack://./../omega/css/table/table.css","webpack://./../omega/css/variables.css","webpack://./../omega/css/dialog.css","webpack://./../omega/css/account-lookup.css","webpack://./../omega/css/account-suggestions.css","webpack://./../omega/css/ach-company-lookup.css","webpack://./../omega/css/alert/alert.css","webpack://./../omega/css/forms/download-bar.css","webpack://./../omega/css/forms/drag-and-drop.css","webpack://./../omega/css/forms/icon-column.css","webpack://./../omega/css/layouts/file-format-designer.css","webpack://./../omega/css/index.css","webpack://./../presentation/styles/styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;ACHA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;ACdA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;AACf;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;ACdA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;AAEA;IACI,qBAAqB;IACrB,6BAA6B;AACjC;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;ACdA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;AAEA;IACI,6BAA6B;AACjC;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;AAEA;IACI,WAAW;AACf;ACjBA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;IACtB,cAAc;AAClB;AAEA;IACI,iBAAiB;AACrB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AAEA;;IAEI,yBAAyB;AAC7B;ACzBA;IACI,UAAU;IACV,gBAAgB;IAChB,UAAU;AACd;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,aAAa;AACjB;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;AClBA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,eAAe;AACnB;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;AAEA;IACI,kBAAkB;AACtB;ACpCA;IACI,kBAAkB;IAClB,UAAU;AACd;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AAEA;IACI,8BAA8B;AAClC;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;AAC5B;AAEA;;IAEI,aAAa;AACjB;AAEA;IACI,yCAAyC;AAC7C;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,mBAAmB;AACvB;AAEA;IACI,mBAAmB;AACvB;AAEA;IACI,cAAc;IACd,YAAY;AAChB;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB;;;;;;wBAMoB;IACpB,WAAW;IACX,wBAAwB;AAC5B;AC7EA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,YAAY;AAChB;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;AAEA;IACI,yBAAyB;IACzB,gDAAgD;AACpD;AAEA;;;IAGI,YAAY;AAChB;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;AAEA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;AAEA;IACI,cAAc;AAClB;AAEA;;IAEI,aAAa;AACjB;AAEA;IACI,YAAY;AAChB;AAEA;IACI,YAAY;AAChB;AAEA;;IAEI,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;AAC9B;AAEA;IACI,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;AAEA;IACI,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;ACrGA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,wBAAwB;IACxB,qBAAqB;IAErB,mBAAmB;IACnB,gBAAgB;IAChB,uEAAuE;IACvE,0BAA0B;IAC1B,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf;;oCAEgC;AACpC;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oCAAoC;IACpC,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;AACf;AAEA;IACI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;IACR,OAAO;IACP,aAAa;IACb,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,0BAA0B;IAC1B,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,cAAc;IACd,qBAAqB;AACzB;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,uBAAuB;AAC3B;AAEA;IACI,cAAc;IACd,eAAe;IACf,0CAA0C;IAC1C,2CAA2C;IAC3C,yCAAyC;IACzC,UAAU;IACV,oBAAoB;AACxB;ACvGA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;AAEA;IACI,WAAW;IACX,UAAU;IACV,4BAA4B;IAC5B,SAAS;AACb;AAEA;IACI,SAAS;IACT,aAAa;IACb,iBAAiB;AACrB;ACjBA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;AACf;AAEA;IACI,WAAW;IACX,UAAU;IACV,4BAA4B;AAChC;AAEA;IACI,SAAS;IACT,aAAa;IACb,iBAAiB;AACrB;AAEA;IACI,0BAA0B;AAC9B;ACpBA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;AAC9B;AAEA;IACI,eAAe;AACnB;AAEA;IACI,aAAa;AACjB;AAEA;;IAEI,uBAAuB;IACvB,aAAa;AACjB;AAEA;IACI,uBAAuB;AAC3B;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;AAEA;IACI,sCAAsC;AAC1C;AAEA;IACI,+BAA+B;AACnC;AC9CA;IACI,aAAa;AACjB;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;ACRA;IACI,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;AAC9B;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oCAAoC;IACpC,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,gBAAgB;IAChB;;oCAEgC;AACpC;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;AACf;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;AAEA;IACI,kCAAkC;AACtC;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD;;oCAEgC;AACpC;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,eAAe;AACnB;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,SAAS;IACT,0CAA0C;IAC1C,2CAA2C;IAC3C,yCAAyC;IACzC,uBAAuB;IACvB,0BAA0B;IAC1B,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AAEA;IACI,yBAAyB;IACzB,gDAAgD;AACpD;AAEA;IACI,8BAA8B;AAClC;AAEA;IACI,WAAW;AACf;AAEA;IACI,SAAS;IACT,oBAAoB;AACxB;AAEA;IACI,iBAAiB;AACrB;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;AAEA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,0CAA0C;IAC1C,oDAAoD;AACxD;ACzIA;IACI,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;AAC9B;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oCAAoC;IACpC,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,gBAAgB;IAChB;;oCAEgC;AACpC;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;AACf;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,cAAc;IACd,qBAAqB;AACzB;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;AAEA;IACI,kCAAkC;AACtC;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD;;oCAEgC;AACpC;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,eAAe;AACnB;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,SAAS;IACT,0CAA0C;IAC1C,2CAA2C;IAC3C,yCAAyC;IACzC,uBAAuB;IACvB,0BAA0B;IAC1B,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AAEA;IACI,yBAAyB;IACzB,gDAAgD;AACpD;AAEA;IACI,8BAA8B;AAClC;AAEA;IACI,WAAW;AACf;AAEA;IACI,SAAS;IACT,oBAAoB;AACxB;AAEA;IACI,qBAAqB;IACrB,yCAAyC;AAC7C;ACzIA;IACI,kBAAkB;IAClB,qBAAqB;;IAErB,kCAAkC;IAClC,qCAAqC;IACrC,sCAAsC;AAC1C;AAEA;IACI,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,mDAAmD;IACnD,sBAAsB;IACtB,kBAAkB;IAClB,2CAA2C;AAC/C;AAEA;;IAEI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,iBAAiB;AACrB;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;AACf;AAEA;IACI,aAAa;IACb,eAAe;AACnB;AAEA;IACI,mBAAmB;AACvB;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;AAEA;IACI,aAAa;AACjB;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,UAAU;AACd;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;AAEA;IACI,mBAAmB;AACvB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,uEAAuE;IACvE,6BAA6B;IAC7B,0BAA0B;AAC9B;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,UAAU;AACd;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,yCAAyC;IACzC,aAAa;IACb,YAAY;IACZ,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,6BAA6B;IAC7B,8CAA8C;IAC9C,kBAAkB;AACtB;AAEA;IACI,sCAAsC;IACtC,kBAAkB;AACtB;AAEA;IACI,kBAAkB;AACtB;AAEA;;;IAGI,sCAAsC;IACtC,kBAAkB;IAClB,sCAAsC;AAC1C;AAEA;IACI,uDAAuD;IACvD,2BAA2B;AAC/B;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uDAAuD;IACvD,WAAW;AACf;AAEA;IACI,aAAa;AACjB;AAEA;IACI,QAAQ;AACZ;AAEA;IACI,OAAO;AACX;AAEA;;IAEI,8BAA8B;AAClC;AAEA;IACI,aAAa;AACjB;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,gBAAgB;AACpB;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,eAAe;IACf,aAAa;AACjB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,YAAY;IACZ,UAAU;AACd;AAEA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,UAAU;IACV,UAAU;AACd;AAEA;IACI,sDAAsD;IACtD,YAAY;IACZ,UAAU;AACd;AAEA;IACI,sDAAsD;IACtD,UAAU;IACV,UAAU;AACd;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,6CAA6C;IAC7C,aAAa;IACb,YAAY;IACZ,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,6BAA6B;IAC7B,kDAAkD;IAClD,kBAAkB;IAClB,yBAAyB;AAC7B;AAEA;IACI,sCAAsC;IACtC,kBAAkB;AACtB;AAEA;IACI,kBAAkB;AACtB;AAEA;;;IAGI,sCAAsC;IACtC,kBAAkB;IAClB,sCAAsC;AAC1C;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb,QAAQ;IACR,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,sDAAsD;IACtD,UAAU;IACV,YAAY;AAChB;AAEA;IACI,sDAAsD;IACtD,UAAU;IACV,UAAU;AACd;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,uDAAuD;AAC3D;AChZA;IACI,YAAY;IACZ,kBAAkB;AACtB;AAEA;IACI,YAAY;AAChB;AAEA;IACI,WAAW;IACX,cAAc;AAClB;AAEA;IACI,WAAW;AACf;AChBA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,yBAAyB;AAC7B;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;AAEA;IACI,YAAY;IACZ,SAAS;AACb;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB;AAEA;IACI,WAAW;AACf;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AAEA;IACI,WAAW;AACf;AAEA;IACI;QACI,cAAc;IAClB;AACJ;ACvCA;IACI,qBAAqB;AACzB;AAEA;IACI,cAAc;AAClB;ACrBA;IACI,UAAU;IACV,SAAS;IACT,SAAS;AACb;AAEA;IACI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,cAAc;;IAEd,uBAAuB;AAC3B;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;AAEA;IACI,WAAW,EAAE,2CAA2C;IACxD,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AAEA;IACI,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,eAAe;AACnB;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;AAC7B;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AAEA;IACI,eAAe;AACnB;ACpEA;IACI,cAAc;IACd,YAAY;AAChB;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,YAAY;AAChB;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AAEA;IACI,YAAY;AAChB;ACzCA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AAEA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,oCAAoC;AACxC;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,MAAM;IACN,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;AACpB;AAEA;IACI,eAAe;AACnB;AAEA;IACI,SAAS,EAAE,0DAA0D;AACzE;AAEA;IACI,YAAY;AAChB;AChDA;;IAEI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AAEA;;IAEI,SAAS,EAAE,0EAA0E;AACzF;AAEA;IACI,eAAe;AACnB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;AACvB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;AACjB;ACrDA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,gCAAgC;AACpC;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AChBA;IACI,iBAAiB;AACrB;AAEA;IACI,aAAa;IACb,UAAU;IACV,SAAS;AACb;AAEA;IACI,aAAa;AACjB;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,gBAAgB;AACpB;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;AAEA;IACI,iBAAiB;AACrB;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;AAEA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;AAChC;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;AClFA;;IAEI,iBAAiB;AACrB;AAEA;;IAEI,kBAAkB;AACtB;AAEA;;IAEI,kBAAkB;AACtB;AAEA;;IAEI,kBAAkB;AACtB;AAEA;;IAEI,gBAAgB;AACpB;AAEA;;IAEI,kBAAkB;AACtB;AAEA;;IAEI,kBAAkB;AACtB;AAEA;IACI,cAAc;AAClB;AC7BA;IACI,gBAAgB;AACpB;AAEA;IACI,aAAa;IACb,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;AACtB;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,kBAAkB;AACtB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,eAAe;AACnB;AAEA;IACI,0BAA0B;AAC9B;AAEA;IACI,YAAY;IACZ,wBAAwB;AAC5B;AClDA;IACI,iBAAiB;IACjB,4DAA4D;IAC5D,4CAA4C;IAC5C,8DAA8D;IAC9D,oCAAoC;IACpC,oCAAoC;IACpC,+BAA+B;IAC/B,0BAA0B;IAC1B,sCAAsC;IACtC,sCAAsC;IACtC,sCAAsC;IACtC,sCAAsC;IACtC,mCAAmC;IACnC,wBAAwB;IACxB,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,mCAAmC;IACnC,mCAAmC;IACnC,wBAAwB;IACxB,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,iCAAiC;IACjC,sBAAsB;IACtB,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,uBAAuB;IACvB,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,gCAAgC;IAChC,gCAAgC;IAChC,qBAAqB;IACrB,iCAAiC;IACjC,iCAAiC;IACjC,iCAAiC;IACjC,YAAY;IACZ,qEAAqE;IACrE,uEAAuE;IACvE,4CAA4C;IAC5C,0CAA0C;IAC1C,0CAA0C;IAC1C,yCAAyC;IACzC,uCAAuC;IACvC,2CAA2C;IAC3C,+CAA+C;IAC/C,uCAAuC;IACvC,8DAA8D;IAC9D,2CAA2C;IAC3C,gDAAgD;IAChD,uDAAuD;IACvD,qDAAqD;IACrD,kDAAkD;IAClD,yDAAyD;IACzD,0DAA0D;IAC1D,mBAAmB;IACnB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,8BAA8B;IAC9B,yCAAyC;IACzC,mBAAmB;IACnB,0BAA0B;IAC1B,0BAA0B;IAC1B,wBAAwB;IACxB,wBAAwB;IACxB,0BAA0B;IAC1B,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,oCAAoC;IACpC,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;IACpC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,sCAAsC;IACtC,0CAA0C;IAC1C,YAAY;IACZ,4CAA4C;IAC5C,2CAA2C;IAC3C,iEAAiE;IACjE,+DAA+D;IAC/D,wDAAwD;IACxD,YAAY;IACZ,yCAAyC;IACzC,wDAAwD;IACxD,uDAAuD;IACvD,wDAAwD;IACxD,oDAAoD;IACpD,+DAA+D;IAC/D,uDAAuD;IACvD,WAAW;IACX,+DAA+hL;IAC/hL,gBAAgB;IAChB,gEAAgE;IAChE,kEAAkE;IAClE,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,8CAA8C;IAC9C,gBAAgB;IAChB,8CAA8C;IAC9C,sDAAsD;IACtD,iBAAiB;IACjB,qCAAqC;AACzC;ACxIA;IACI,8BAA8B;AAClC;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mCAAmC;AACvC;AAEA;IACI,SAAS;IACT,aAAa;IACb,SAAS;IACT,mDAAmD;IACnD,eAAe;AACnB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,gDAAgD;IAChD,gBAAgB;AACpB;AClCA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;IACf,iBAAiB;IACjB;;oCAEgC;AACpC;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;AACf;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;AACzB;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,eAAe;AACnB;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,2BAA2B;AAC/B;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AC/EA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;AAEA;IACI,cAAc;IACd,YAAY;AAChB;ACjBA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,mDAAmD;IACnD,kCAAkC;AACtC;AAEA;IACI,eAAe;IACf,UAAU;IACV,SAAS;IACT,kCAAkC;IAClC,gBAAgB;AACpB;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;IAClD,kCAAkC;IAClC,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;;IAEI,eAAe;AACnB;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,iBAAiB;AACrB;ACnFA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,sBAAsB;AAC1B;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,YAAY;IACZ,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;AAEA;IACI,UAAU;IACV,SAAS;AACb;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,eAAe;AACnB;AAEA;IACI,eAAe;IACf,aAAa;IACb,cAAc;IACd,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,2CAA2C;IAC3C,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,cAAc;AAClB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AAEA;IACI,eAAe;AACnB;AAEA;IACI,cAAc;AAClB;AC1HA;IACI,UAAU;IACV,MAAM;IACN,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;AACvB;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;IACV,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;AACpB;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,eAAe;AACnB;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;ACvHA;IACI,6BAA6B,EAAE,mCAAmC;IAClE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;AAEA;IACI,YAAY;AAChB;AAEA;;IAEI,sBAAsB;IACtB;;;4BAGwB;AAC5B;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;AAEA;IACI,8BAA8B;AAClC;AAEA;IACI,8BAA8B;AAClC;AAEA;IACI,8BAA8B;AAClC;AAEA;IACI;;mGAE+F;IAC/F,kCAAkC;AACtC;AAEA;IACI,uCAAuC;AAC3C;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,cAAc;AAClB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,4BAA4B;IAC5B,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;AACf;AAEA;IACI,4CAA4C;AAChD;AAEA;IACI,QAAQ;AACZ;AAEA;IACI,uBAAuB;AAC3B;AAEA;IACI,SAAS;AACb;AAEA;IACI,uBAAuB;AAC3B;AAEA;;IAEI,wBAAgB;YAAhB,gBAAgB;AACpB;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,eAAe;AACnB;AAEA;IACI,UAAU;AACd;AAEA;IACI,WAAW;AACf;AAEA;IACI,aAAa;AACjB;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAEhB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,aAAa;AACjB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,UAAU;AACd;AAEA;IACI,UAAU;AACd;AAEA;IACI,WAAW;AACf;ACnNA;IACI,kBAAkB;AACtB;AAEA;IACI,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;AAEA;IACI,YAAY;AAChB;ACrBA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,qDAAqD;IACrD,+DAA+D;AACnE;AAEA;IACI,cAAc;AAClB;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,SAAS;AACb;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;AAEA,SAAS;AACT;IACI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,gCAAgC;AACpC;AAEA;IACI,aAAa;AACjB;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;AAEA,YAAY;AACZ;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AAEA;IACI,aAAa;AACjB;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,aAAa;AACjB;AAEA;;;;IAII,UAAU;IACV,iCAAiC;IACjC,YAAY;AAChB;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,yDAAyD;IACzD,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB;;0BAEsB;IACtB,sCAAsC;AAC1C;AAEA;;IAEI,gEAAgE;AACpE;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,2BAA2B;IAC3B,oBAAoB;IACpB,YAAY;IACZ,gEAAgE;IAChE,qCAAqC;IACrC,aAAa;AACjB;AAEA;;IAEI,2DAA2D;AAC/D;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AAEA;IACI,qBAAqB;AACzB;AAEA,WAAW;AAEX;IACI,YAAY;AAChB;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,eAAe;AACnB;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IAEnB,yBAAyB;AAC7B;AAEA;IACI,UAAU;IAEV,mBAAmB;AACvB;AAEA;IACI,UAAU;IAEV,mBAAmB;AACvB;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,wBAAwB;IACxB,qBAAqB;IAErB,mBAAmB;IACnB,gBAAgB;IAChB,uEAAuE;IACvE,0BAA0B;IAC1B,kBAAkB;IAClB,gDAAgD;IAChD;;oCAEgC;AACpC;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;AACf;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AAEA;IACI,kBAAkB;AACtB;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,YAAY;AAChB;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;AAEA;IACI,aAAa;AACjB;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,wCAAwC;IACxC,4CAA4C;IAC5C,kBAAkB;IAClB,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,iDAAiD;IACjD,4DAA4D;AAChE;AAEA;IACI,UAAU;IACV,YAAY;IACZ,8CAA8C;IAC9C,4DAA4D;AAChE;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,SAAS;IACT,WAAW;AACf;AAEA;IACI,eAAe;IACf,WAAW,EAAE,2FAA2F;IACxG,SAAS;IACT,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,6BAA6B;AACjC;AAEA,qBAAqB;AACrB;IACI,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2DAA2D;AAC/D;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,4DAA4D;AAChE;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AAEA;IACI,cAAc;AAClB;AAEA;IACI,WAAW;IACX,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,2DAA2D;IAC3D,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC,4DAA4D;AAChE;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AAEA;IACI,eAAe;AACnB;AC1dA;IACI,wBAAwB;IACxB;;;;;6DAKoD;IACpD,gBAAgB;IAChB,kBAAkB;AACtB;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,2BAA2B,EAAE,aAAa;IAC1C,8BAA8B;AAClC;AAEA;IACI,qBAAqB;IACrB,qCAAqC;AACzC;AAEA;IACI,wBAAwB;AAC5B;AAEA;IACI;QACI,aAAa;QACb,SAAS;IACb;AACJ;AC9CA;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd,kEAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,oCAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,2DAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;IAAA;AAAoB;AAApB;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;IAApB;QAAA;IAAoB;AAAA;AACpB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,SAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,WAAmB;IAAnB;AAAmB;AAAnB;IAAA,cAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;OAAnB,sBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;OAAnB,qBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;SAAnB;AAAmB;AAAnB;IAAA,uBAAmB;SAAnB;AAAmB;AAAnB;IAAA,uBAAmB;SAAnB;AAAmB;AAAnB;IAAA,wBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;OAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA,+EAAmB;IAAnB,mGAAmB;IAAnB;AAAmB;AAAnB;IAAA,6EAAmB;IAAnB,iGAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kGAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wJAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAEnB;IACI,cAAc;AAClB;AAEA;IACI,yCAAyC;IACzC,wCAAwC;AAC5C;AAEA;IACI,0DAA0D;IAC1D,iCAAiC;IACjC,SAAS;AACb;AAEA;;;;;;;;IAQI,gBAAgB;IAChB,aAAa,EAAE,2DAA2D;IAC1E,cAAc;AAClB;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,4CAA4C;IAC5C,oCAAoC;IACpC,sBAAsB;IACtB,UAAU;AACd;AACA;;IAEI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,oEAAoE;IACpE,0CAA0C;IAC1C,QAAQ;IACR,SAAS;AACb;AAEA;IACI,wBAAwB;AAC5B;AAEA;;;IAGI,sBAAsB;IACtB,qCAAqC;AACzC;AAEA,uDAAuD;AACvD;IACI,iCAAiC;AACrC;AAEA;;IAEI,iCAAiC;IACjC,yCAAyC;AAC7C;AAEA;;;IAGI,aAAa;AACjB;AAEA;IACI,6BAA6B;AACjC;AAEA;IACI,iCAAiC;AACrC;AAEA;IACI,kCAAkC;AACtC;AAEA;IACI,yDAAyD;AAC7D;AAEA;IACI,+CAA+C;AACnD;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;AACA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;AACA;;IAEI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;AAEA,uBAAuB;AACvB;IACI,0CAA0C;IAC1C,4CAA4C;AAChD;AAEA;IACI,+CAA+C;IAC/C,0BAA0B;IAC1B,kDAAkD;IAClD,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,uBAAkB;IAAlB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;AACpB;AAEA;IACI,+CAA+C;IAC/C,kCAAkC;IAClC,mBAAmB;AACvB;AAEA,wBAAwB;AACxB;;;IAGI,wCAAwC;IACxC,0BAA0B;IAC1B,wBAAwB;AAC5B;AACA;;;IAGI,0BAA0B;IAC1B,0BAA0B;AAC9B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AAEA,6BAA6B;AAC7B;IACI,uCAAuC;AAC3C;AACA;;IAEI,gBAAgB;AACpB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,gBAAgB;AACpB;AAEA;IACI,0CAA0C;AAC9C;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;AACA;IACI,UAAU;IACV,wBAAgB;YAAhB,gBAAgB;AACpB;AAEA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,iCAAiC;QACjC,mBAAmB;QACnB,sBAAsB;IAC1B;AACJ;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;AAEA;IACI,YAAY;AAChB;AAEA;IACI,8BAA8B;IAC9B,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,YAAY;AAChB;AAEA;IACI,mCAAmC;AACvC;AAEA;IACI,6BAA6B;AACjC;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;AAnRA;IAAA,8BAoRA;IApRA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA,+BAoRA;IApRA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA,+EAoRA;IApRA,mGAoRA;IApRA;AAoRA;AApRA;IAAA,8BAoRA;IApRA;AAoRA;AApRA;IAAA,2GAoRA;IApRA,yGAoRA;IApRA;AAoRA;AApRA;IAAA;AAoRA;AApRA;IAAA;QAAA;IAoRA;AAAA;AApRA;IAAA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA,gBAoRA;QApRA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA,gBAoRA;QApRA;IAoRA;IApRA;QAAA;IAoRA;AAAA;AApRA;IAAA;QAAA;IAoRA;AAAA;AApRA;IAAA;QAAA;IAoRA;IApRA;QAAA,gBAoRA;QApRA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA,aAoRA;QApRA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA,sBAoRA;QApRA;IAoRA;IApRA;QAAA,qBAoRA;QApRA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA,eAoRA;QApRA;IAoRA;IApRA;QAAA;IAoRA;AAAA;AApRA;IAAA;QAAA;IAoRA;IApRA;QAAA;IAoRA;IApRA;QAAA;IAoRA;AAAA;AApRA;IAAA;QAAA;IAoRA;IApRA;QAAA,mBAoRA;QApRA;IAoRA;IApRA;QAAA;IAoRA;AAAA;AApRA;IAAA;QAAA;IAoRA;IApRA;QAAA;IAoRA;AAAA","sourcesContent":[".omega-form-group {\r\n    max-width: 550px;\r\n    padding: 20px 25px 25px;\r\n}\r\n",".omega-button.approve {\r\n    border-color: #238d45;\r\n    background-color: #167e38;\r\n    color: #fff;\r\n}\r\n\r\n.omega-button.approve:focus {\r\n    border-color: #1a6533;\r\n    box-shadow: 0 0 8px #2caa55;\r\n}\r\n\r\n.omega-button.approve:hover:not([disabled]) {\r\n    border-color: #1a6533;\r\n    background-color: #228141;\r\n}\r\n",".omega-button.reject {\r\n    border-color: #b41212;\r\n    background-color: #c51818;\r\n    color: #fff;\r\n}\r\n\r\n.omega-button.reject:focus {\r\n    border-color: #981718;\r\n    box-shadow: 0 0 8px #ee3a3b;\r\n}\r\n\r\n.omega-button.reject:hover:not([disabled]) {\r\n    border-color: #970809;\r\n    background-color: #d00c0d;\r\n}\r\n",".omega-button.primary {\r\n    border: 1px #2d6da3;\r\n    background-color: #0070b7;\r\n    color: #fff;\r\n}\r\n\r\n.omega-button.primary:focus {\r\n    border-color: #204d73;\r\n    box-shadow: 0 0 8px 0 #337ab7;\r\n}\r\n\r\n.omega-button.primary:hover:not([disabled]) {\r\n    border-color: #204d73;\r\n    background-color: #285f8f;\r\n}\r\n",".omega-button.secondary {\r\n    border: 1px solid #337ab7;\r\n    background-color: #fff;\r\n    color: #337ab7;\r\n}\r\n\r\n.omega-button.secondary:focus {\r\n    box-shadow: 0 0 6px 0 #66afe9;\r\n}\r\n\r\n.omega-button.secondary:hover:not([disabled]) {\r\n    border-color: #204d73;\r\n    color: #204d73;\r\n}\r\n\r\n.omega-button.secondary:disabled {\r\n    color: #888;\r\n}\r\n",".omega-button.icon {\r\n    padding: 10px 8px;\r\n    border: 1px solid transparent;\r\n    background-color: #fff;\r\n    color: #0070b7;\r\n}\r\n\r\n.omega-button.icon i {\r\n    line-height: 16px;\r\n}\r\n\r\n.omega-button.icon i + .omega-button-label {\r\n    margin-left: 0.5ex;\r\n}\r\n\r\n.omega-button.icon:not(.labelled) {\r\n    min-width: 1px;\r\n    padding: 10px 12px;\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n}\r\n\r\n.omega-button.icon:focus,\r\n.omega-button.icon:hover:not(:disabled) {\r\n    background-color: #e6f0fa;\r\n}\r\n",".omega-button:disabled.has-errors {\r\n    padding: 0;\r\n    background: none;\r\n    opacity: 1;\r\n}\r\n\r\n.omega-button.has-errors > .omega-button-label {\r\n    display: inline-block;\r\n    padding: 10px 20px;\r\n    margin: 0;\r\n    background-color: #337ab7;\r\n    font-size: 1em;\r\n    line-height: 16px;\r\n    opacity: 0.65;\r\n}\r\n\r\n.omega-button.has-errors > i {\r\n    display: inline-block;\r\n    width: 35px;\r\n    padding: 10px 0;\r\n    margin: 0;\r\n    background-color: #337ab7;\r\n    font-size: 1em;\r\n    line-height: 16px;\r\n    text-align: center;\r\n}\r\n","@import url('./button-approve.css');\r\n@import url('./button-reject.css');\r\n@import url('./button-primary.css');\r\n@import url('./button-secondary.css');\r\n@import url('./button-icon.css');\r\n@import url('./button-with-errors.css');\r\n\r\n.omega-button {\r\n    min-width: 90px;\r\n    padding: 10px 20px;\r\n    margin: 8px;\r\n    border: 1px solid #ebebeb;\r\n    border-radius: 3px;\r\n    font-size: 1em;\r\n    font-weight: 400;\r\n    line-height: 16px;\r\n    outline: none;\r\n}\r\n\r\n.omega-button[disabled] {\r\n    opacity: 0.65;\r\n}\r\n\r\n.omega-button:enabled {\r\n    cursor: pointer;\r\n}\r\n\r\n.omega-button.small {\r\n    min-width: 0;\r\n    padding: 10px;\r\n    margin: 10px 2px;\r\n    line-height: 8px;\r\n}\r\n\r\n.omega-button-label {\r\n    text-align: center;\r\n}\r\n",".omega-checkbox {\r\n    position: absolute;\r\n    opacity: 0;\r\n}\r\n\r\n.omega-checkbox-label {\r\n    position: relative;\r\n    padding: 3px;\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n    vertical-align: bottom;\r\n}\r\n\r\n.omega-checkbox-label:hover {\r\n    background: rgb(228, 222, 222);\r\n}\r\n\r\n.omega-checkbox-label::before {\r\n    display: inline-block;\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-right: 10px;\r\n    margin-left: 5px;\r\n    border: 1px solid rgb(216, 210, 210);\r\n    background: white;\r\n    border-radius: 3px;\r\n    content: '';\r\n    vertical-align: text-top;\r\n}\r\n\r\n.omega-single-select-override .omega-checkbox-label::before,\r\n.omega-single-select-override .omega-checkbox-label::after {\r\n    display: none;\r\n}\r\n\r\n.omega-checkbox:focus + .omega-checkbox-label::before {\r\n    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.omega-single-select-override .omega-checkbox:focus + .omega-checkbox-label::before {\r\n    box-shadow: none;\r\n}\r\n\r\n.omega-checkbox:checked + .omega-checkbox-label::before {\r\n    background: #4389cb;\r\n}\r\n\r\n.omega-single-select-override .omega-checkbox:checked + .omega-checkbox-label {\r\n    background: #ece8e5;\r\n}\r\n\r\n.omega-checkbox:disabled + .omega-checkbox-label {\r\n    color: #b8b8b8;\r\n    cursor: auto;\r\n}\r\n\r\n.omega-checkbox:disabled + .omega-checkbox-label::before {\r\n    background: #ddd;\r\n    box-shadow: none;\r\n}\r\n\r\n.omega-checkbox:checked + .omega-checkbox-label::after {\r\n    position: absolute;\r\n    top: 15px;\r\n    left: 10px;\r\n    width: 2px;\r\n    height: 2px;\r\n    background: white;\r\n    box-shadow:\r\n        2px 0 0 white,\r\n        4px 0 0 white,\r\n        4px -2px 0 white,\r\n        4px -4px 0 white,\r\n        4px -6px 0 white,\r\n        4px -8px 0 white;\r\n    content: '';\r\n    transform: rotate(45deg);\r\n}\r\n",".omega-form-field {\r\n    position: relative;\r\n    display: flex;\r\n    max-width: 800px;\r\n    flex-flow: row wrap;\r\n    margin: 15px 0;\r\n}\r\n\r\n.omega-form-label-box {\r\n    min-width: 200px;\r\n}\r\n\r\n.omega-form-label-box > label::after {\r\n    content: ':';\r\n}\r\n\r\n.omega-form-input-box {\r\n    position: relative;\r\n    display: block;\r\n    min-width: 250px;\r\n    flex: 3 1;\r\n}\r\n\r\n.omega-form-field input:not([type='checkbox']):not([type='radio']) {\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 3px 12px;\r\n    border: 1px solid #ccc;\r\n    background: #fff;\r\n    border-radius: 3px;\r\n    font-size: 13px;\r\n    line-height: 18px;\r\n}\r\n\r\n.omega-form-field input:focus {\r\n    border: 1px solid #66afe9;\r\n    box-shadow: 0 2px 4px 0 rgba(102, 175, 233, 0.6);\r\n}\r\n\r\n.omega-form-field input:disabled,\r\n.omega-form-field select:disabled,\r\n.omega-form-field button:disabled {\r\n    opacity: 0.6;\r\n}\r\n\r\n.omega-form-field [aria-invalid='true'] {\r\n    border-color: #cc1010;\r\n    background-color: rgba(204, 16, 16, 0.03);\r\n}\r\n\r\n.omega-form-field .omega-multiple-select[aria-invalid='true'] .omega-multiple-select-button {\r\n    border: 1px solid #cc1010;\r\n    background-color: rgba(204, 16, 16, 0.03);\r\n}\r\n\r\n.omega-required-field-indicator {\r\n    color: #ee3a3b;\r\n}\r\n\r\n.omega-form-input-box .has-annotation,\r\n.omega-form-input-box .has-lookup {\r\n    display: flex;\r\n}\r\n\r\n.omega-form-input-box .has-lookup input {\r\n    width: 265px;\r\n}\r\n\r\n.omega-form-input-box .has-annotation input {\r\n    width: 240px;\r\n}\r\n\r\n.omega-form-input-box .has-lookup input,\r\n.omega-form-input-box .has-annotation input {\r\n    border-right: none;\r\n    border-bottom-right-radius: 0;\r\n    border-top-right-radius: 0;\r\n}\r\n\r\n.omega-form-input-annotation {\r\n    width: 60px;\r\n    margin: 0;\r\n    border: 1px solid #ccc;\r\n    background-color: #eee;\r\n    border-radius: 0 3px 3px 0;\r\n    font-size: 13px;\r\n    font-weight: 400px;\r\n    line-height: 30px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n\r\n.omega-form-search-button {\r\n    width: 35px;\r\n    margin: 0;\r\n    border: 1px solid #ccc;\r\n    background-color: #eee;\r\n    border-radius: 0 3px 3px 0;\r\n    font-size: 13px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n",".omega-select {\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 6px 10px;\r\n    margin-bottom: 3px;\r\n    border: 1px solid rgb(199, 199, 199);\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    -ms-appearance: none;\r\n    -o-appearance: none;\r\n    appearance: none;\r\n    background: var(--omega-dropdown-arrow) right 4px center no-repeat #fff;\r\n    background-size: 12px 12px;\r\n    border-radius: 5px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    font-size: 14px;\r\n    transition:\r\n        border-color ease-in-out 0.15s,\r\n        box-shadow ease-in-out 0.15s;\r\n}\r\n\r\n.omega-select-wrapper[role='listbox'] {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 6px 10px;\r\n    margin: 0 auto;\r\n    border: 1px solid rgb(199, 199, 199);\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    cursor: pointer;\r\n}\r\n\r\n.omega-select-wrapper::after {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 1rem;\r\n    width: 0;\r\n    height: 0;\r\n    margin-top: -2px;\r\n    border-width: 6px 6px 0;\r\n    border-style: solid;\r\n    border-color: #4b4742 transparent;\r\n    content: '';\r\n}\r\n\r\n.omega-select-wrapper[aria-disabled='true'] {\r\n    opacity: 0.65;\r\n}\r\n\r\n.omega-select-wrapper .omega-select-drop-list {\r\n    position: absolute;\r\n    z-index: 3;\r\n    top: 100%;\r\n    right: 0;\r\n    left: 0;\r\n    display: none;\r\n    max-height: 195px;\r\n    padding: 0;\r\n    margin-top: 0;\r\n    background: #fff;\r\n    border-radius: 0 0 3px 3px;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);\r\n    list-style: none;\r\n    overflow-y: scroll;\r\n    pointer-events: none;\r\n}\r\n\r\n.omega-select-wrapper .omega-select-drop-list li {\r\n    display: block;\r\n    height: 28px;\r\n    padding: 5px;\r\n    border-radius: 0 0 3px 3px;\r\n    color: #181818;\r\n    text-decoration: none;\r\n}\r\n\r\n.omega-select-wrapper span {\r\n    display: block;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.omega-select-wrapper .omega-select-drop-list li[aria-selected='true'] {\r\n    background-color: #ece8e5;\r\n}\r\n\r\n.omega-select-wrapper .omega-select-drop-list li:hover {\r\n    background-color: #ece8e5;\r\n}\r\n\r\n.omega-select-wrapper.active::after {\r\n    border-width: 0 6px 6px;\r\n}\r\n\r\n.omega-select-wrapper.active .omega-select-drop-list {\r\n    display: block;\r\n    margin-top: 1px;\r\n    border-right: 1px solid rgb(214, 209, 209);\r\n    border-bottom: 1px solid rgb(214, 209, 209);\r\n    border-left: 1px solid rgb(214, 209, 209);\r\n    opacity: 1;\r\n    pointer-events: auto;\r\n}\r\n",".omega-form-field .omega-date-range-from-to {\r\n    display: flex;\r\n    align-items: baseline;\r\n    clear: both;\r\n}\r\n\r\n.omega-form-field .omega-date-range-from-to input {\r\n    width: auto;\r\n    flex: 10 1;\r\n    align-content: space-between;\r\n    margin: 0;\r\n}\r\n\r\n.omega-form-field .omega-date-range-to-label {\r\n    flex: 2 1;\r\n    margin: 0 5px;\r\n    text-align: right;\r\n}\r\n",".omega-form-field .omega-amount-range-from-to {\r\n    display: flex;\r\n    align-items: baseline;\r\n    clear: both;\r\n}\r\n\r\n.omega-form-field .omega-amount-range-from-to input {\r\n    width: auto;\r\n    flex: 10 1;\r\n    align-content: space-between;\r\n}\r\n\r\n.omega-form-field .omega-amount-range-to-label {\r\n    flex: 2 1;\r\n    margin: 0 5px;\r\n    text-align: right;\r\n}\r\n\r\n.omega-amount-range .omega-select {\r\n    text-transform: capitalize;\r\n}\r\n",".omega-toggle {\r\n    width: 50px;\r\n    height: 28px;\r\n    background-color: #ccc;\r\n    border-radius: 14px;\r\n}\r\n\r\n.omega-toggle-indicator {\r\n    display: block;\r\n    width: 24px;\r\n    height: 24px;\r\n    background-color: white;\r\n    border-radius: 12px;\r\n    transform: translate(2px, 2px);\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.omega-toggle:not(:disabled):hover {\r\n    cursor: pointer;\r\n}\r\n\r\n.omega-toggle:focus {\r\n    outline: none;\r\n}\r\n\r\n.omega-toggle-checkbox:focus + .omega-toggle,\r\n.omega-toggle:focus {\r\n    box-shadow: 0 1px 4px 0;\r\n    outline: none;\r\n}\r\n\r\n.omega-toggle-checkbox:focus + .omega-toggle > .omega-toggle-indicator {\r\n    box-shadow: 0 1px 4px 0;\r\n}\r\n\r\n.omega-toggle-checkbox:disabled + .omega-toggle {\r\n    opacity: 0.6;\r\n    pointer-events: none;\r\n}\r\n\r\n.omega-toggle-checkbox:checked + .omega-toggle {\r\n    background-color: var(--omega-primary);\r\n}\r\n\r\n.omega-toggle-checkbox:checked + .omega-toggle > .omega-toggle-indicator {\r\n    transform: translate(24px, 2px);\r\n}\r\n",".omega-form-input-box [aria-expanded='false'] [role='listbox'] {\r\n    display: none;\r\n}\r\n\r\n.omega-form-input-box [role='option'] {\r\n    display: block;\r\n    overflow: auto;\r\n    cursor: pointer;\r\n}\r\n",".omega-multiple-select[aria-expanded='true'] {\r\n    position: relative;\r\n    height: 32px;\r\n    background-color: white;\r\n    border-radius: 3px 3px 0 0;\r\n}\r\n\r\n.omega-multiple-select-button {\r\n    text-overflow: ellipsis;\r\n    position: relative;\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 6px 10px;\r\n    margin: 0 auto;\r\n    border: 1px solid rgb(199, 199, 199);\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    text-align: left;\r\n    transition:\r\n        border-color ease-in-out 0.15s,\r\n        box-shadow ease-in-out 0.15s;\r\n}\r\n\r\n.omega-multiple-select-button::after {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 1rem;\r\n    width: 0;\r\n    height: 0;\r\n    margin-top: -2px;\r\n    border-width: 6px 6px 0;\r\n    border-style: solid;\r\n    border-color: #4b4742 transparent;\r\n    content: '';\r\n}\r\n\r\n.omega-multiple-select[aria-expanded='true'] .omega-multiple-select-button {\r\n    display: none;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.omega-multiple-select[aria-expanded='false'] > :not(.omega-multiple-select-button) {\r\n    display: none;\r\n}\r\n\r\n.omega-multiple-select-search-wrapper {\r\n    position: relative;\r\n    top: 0;\r\n    width: 100%;\r\n}\r\n\r\n.omega-multiple-select-select-all-label.omega-checkbox-label {\r\n    border-bottom: 1px solid gainsboro;\r\n}\r\n\r\n.omega-multiple-select-no-results {\r\n    height: 32px;\r\n    line-height: 32px;\r\n    text-align: center;\r\n}\r\n\r\n.omega-multiple-select-search {\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 6px 10px;\r\n    border: 1px solid #ccc;\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    transition:\r\n        border-color ease-in-out 0.15s,\r\n        box-shadow ease-in-out 0.15s;\r\n}\r\n\r\n.omega-multiple-select-search-icon {\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 12px;\r\n    color: #888;\r\n    font-size: 14px;\r\n}\r\n\r\n.omega-multiple-select-list[role='listbox'] {\r\n    position: absolute;\r\n    z-index: 3;\r\n    top: 33px;\r\n    left: 0;\r\n    width: 100%;\r\n    max-height: 192px;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n    border-right: 1px solid rgb(214, 209, 209);\r\n    border-bottom: 1px solid rgb(214, 209, 209);\r\n    border-left: 1px solid rgb(214, 209, 209);\r\n    background-color: white;\r\n    border-radius: 0 0 3px 3px;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);\r\n    list-style: none;\r\n    opacity: 0.99;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.omega-multiple-select-list-option:focus {\r\n    border: 1px solid #66afe9;\r\n    box-shadow: 0 2px 4px 0 rgba(102, 175, 233, 0.6);\r\n}\r\n\r\n.omega-form-input-box .omega-multiple-select [aria-selected='true'] {\r\n    background: rgb(228, 222, 222);\r\n}\r\n\r\n.omega-multiple-select .omega-checkbox-label {\r\n    width: 100%;\r\n}\r\n\r\n.omega-multiple-select-list label {\r\n    margin: 0;\r\n    padding: 5px 0 5px 0;\r\n}\r\n\r\n.omega-single-select-override .omega-multiple-select-list label {\r\n    padding-left: 5px;\r\n}\r\n\r\n.omega-multiple-select-required {\r\n    border: 1px solid red;\r\n    background-color: rgba(204, 16, 16, 0.03);\r\n}\r\n\r\n.omega-multiple-select-error {\r\n    border: 1px solid #c10f00;\r\n    background-color: rgba(204, 16, 16, 0.03);\r\n    box-shadow: 0 0 0 1px rgb(193, 15, 0, 0.2);\r\n    transition: all 200ms cubic-bezier(0, 0, 0.29, 0.75);\r\n}\r\n",".omega-autocomplete[aria-expanded='true'] {\r\n    position: relative;\r\n    height: 32px;\r\n    background-color: white;\r\n    border-radius: 3px 3px 0 0;\r\n}\r\n\r\n.omega-autocomplete-button {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 6px 10px;\r\n    margin: 0 auto;\r\n    border: 1px solid rgb(199, 199, 199);\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    text-align: left;\r\n    transition:\r\n        border-color ease-in-out 0.15s,\r\n        box-shadow ease-in-out 0.15s;\r\n}\r\n\r\n.omega-autocomplete-button::after {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 1rem;\r\n    width: 0;\r\n    height: 0;\r\n    margin-top: -2px;\r\n    border-width: 6px 6px 0;\r\n    border-style: solid;\r\n    border-color: #4b4742 transparent;\r\n    content: '';\r\n}\r\n\r\n.omega-autocomplete li {\r\n    display: block;\r\n    height: 28px;\r\n    padding: 5px;\r\n    border-radius: 0 0 3px 3px;\r\n    color: #181818;\r\n    text-decoration: none;\r\n}\r\n\r\n.omega-autocomplete li:hover {\r\n    background-color: #ece8e5;\r\n}\r\n\r\n.omega-autocomplete[aria-expanded='true'] .omega-autocomplete-button {\r\n    display: none;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.omega-autocomplete[aria-expanded='false'] > :not(.omega-autocomplete-button) {\r\n    display: none;\r\n}\r\n\r\n.omega-autocomplete-search-wrapper {\r\n    position: relative;\r\n    top: 0;\r\n    width: 100%;\r\n}\r\n\r\n.omega-autocomplete-select-all-label.omega-checkbox-label {\r\n    border-bottom: 1px solid gainsboro;\r\n}\r\n\r\n.omega-autocomplete-no-results {\r\n    text-align: center;\r\n}\r\n\r\n.omega-autocomplete-search {\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 6px 10px;\r\n    border: 1px solid #ccc;\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    transition:\r\n        border-color ease-in-out 0.15s,\r\n        box-shadow ease-in-out 0.15s;\r\n}\r\n\r\n.omega-autocomplete-search-icon {\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 12px;\r\n    color: #888;\r\n    font-size: 14px;\r\n}\r\n\r\n.omega-autocomplete-list[role='listbox'] {\r\n    position: absolute;\r\n    z-index: 3;\r\n    top: 33px;\r\n    left: 0;\r\n    width: 100%;\r\n    min-width: 200px;\r\n    max-height: 192px;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n    border-right: 1px solid rgb(214, 209, 209);\r\n    border-bottom: 1px solid rgb(214, 209, 209);\r\n    border-left: 1px solid rgb(214, 209, 209);\r\n    background-color: white;\r\n    border-radius: 0 0 3px 3px;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);\r\n    list-style: none;\r\n    opacity: 0.99;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.omega-autocomplete-list-option:focus {\r\n    border: 1px solid #66afe9;\r\n    box-shadow: 0 2px 4px 0 rgba(102, 175, 233, 0.6);\r\n}\r\n\r\n.omega-form-input-box .omega-autocomplete [aria-selected='true'] {\r\n    background: rgb(228, 222, 222);\r\n}\r\n\r\n.omega-autocomplete .omega-checkbox-label {\r\n    width: 100%;\r\n}\r\n\r\n.omega-autocomplete-list label {\r\n    margin: 0;\r\n    padding: 5px 0 5px 0;\r\n}\r\n\r\n.omega-autocomplete-required {\r\n    border: 1px solid red;\r\n    background-color: rgba(204, 16, 16, 0.03);\r\n}\r\n",".omega-datepicker {\n    position: absolute;\n    display: inline-block;\n\n    --datepicker-day-button-size: 30px;\n    --datepicker-month-button-width: 75px;\n    --datepicker-month-button-height: 45px;\n}\n\n.omega-datepicker.is-open {\n    z-index: 3;\n    width: 280px;\n    padding: 0px 10px 10px 10px;\n    border: 1px solid var(--omega-input-default-border);\n    background-color: #fff;\n    border-radius: 3px;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n}\n\n[aria-expanded='false'] .omega-datepicker-calendar,\n.omega-datepicker-calendar[aria-expanded='false'] {\n    display: none;\n}\n\n.omega-datepicker-descriptor {\n    position: absolute;\n    top: 0;\n    left: 10px;\n    line-height: 32px;\n}\n\n.omega-datepicker-input {\n    height: 32px;\n    padding: 6px 10px;\n    border: 1px solid #ccc;\n    background-color: #fff;\n    border-radius: 3px;\n    min-width: 120px;\n}\n\n.omega-datepicker .omega-datepicker-main-input {\n    cursor: pointer;\n    width: 280px;\n    position: relative;\n    margin: 0 auto;\n}\n\n.omega-datepicker .omega-datepicker-main-input::after {\n    position: absolute;\n    top: 50%;\n    right: 5px;\n    width: 0;\n    height: 0;\n    margin-top: -2px;\n    border-width: 6px 6px 0;\n    border-style: solid;\n    border-color: #4b4742 transparent;\n    content: '';\n}\n\n.omega-datepicker .omega-datepicker-main-input[disabled='true'] {\n    opacity: 0.65;\n    cursor: default;\n}\n\n.omega-datepicker .omega-datepicker-main-input-type {\n    white-space: nowrap;\n}\n\n.omega-datepicker .omega-datepicker-main-input-display {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n}\n\n.omega-datepicker .omega-datepicker-main-input-value {\n    margin-right: 10px;\n    color: rgb(109, 107, 107);\n    white-space: nowrap;\n}\n\n.omega-datepicker.is-open .omega-datepicker-toggle-button {\n    display: none;\n    background-color: #fff;\n}\n\n.omega-datepicker.is-open .omega-datepicker-main-input {\n    display: none;\n}\n\n.omega-form-field .omega-datepicker:not(.is-open) input {\n    width: 280px;\n    padding-right: 24px;\n    text-align: center;\n}\n\n.omega-form-field .omega-datepicker.is-open input {\n    margin: 5px;\n    padding: 0 10px;\n    font-size: 12px;\n    text-align: left;\n    /* temp: better way to align and size inputs */\n    width: 95%;\n}\n\n.omega-datepicker-hint-text {\n    display: block;\n    text-align: center;\n    visibility: hidden;\n}\n\n.omega-datepicker.is-open .omega-datepicker-hint-text {\n    visibility: visible;\n}\n\n.omega-datepicker-calendar-header {\n    font-weight: 600;\n}\n\n.omega-datepicker-calendar-label {\n    display: block;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 16px;\n    text-align: center;\n}\n\n.omega-datepicker-calendar-label:hover {\n    color: var(--omega-primary);\n    cursor: pointer;\n}\n\n.omega-datepicker th {\n    color: rgb(179, 179, 179);\n    font-size: 11px;\n    font-weight: 400;\n    text-align: center;\n}\n\n.omega-datepicker-calendar {\n    position: relative;\n    height: 100px;\n}\n\n.omega-datepicker-month-selection {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.omega-datepicker-last-month-button,\n.omega-datepicker-next-month-button {\n    width: 20px;\n    height: 20px;\n    padding: 5px;\n    border: none;\n    appearance: none;\n    background: var(--omega-dropdown-arrow) right 4px center no-repeat #fff;\n    background-color: transparent;\n    background-size: 12px 12px;\n}\n\n.omega-datepicker-last-month-button {\n    margin-right: 10px;\n    transform: rotate(90deg);\n}\n\n.omega-datepicker-next-month-button {\n    transform: rotate(-90deg);\n}\n\n.omega-datepicker td {\n    padding: 0;\n}\n\n.omega-datepicker-day {\n    width: 30px;\n    width: var(--datepicker-day-button-size);\n    height: var(--datepicker-day-button-size);\n    margin: 0 4px;\n    border: none;\n    appearance: none;\n    background-color: transparent;\n    line-height: var(--datepicker-day-button-size);\n    text-align: center;\n}\n\n.omega-datepicker-day:hover {\n    border: 1px solid var(--omega-primary);\n    border-radius: 5px;\n}\n\n.omega-datepicker-day-cell {\n    position: relative;\n}\n\n.omega-datepicker-day-cell.is-selected button,\n.omega-datepicker-day-cell.is-selection-start button,\n.omega-datepicker-day-cell.is-selection-end button {\n    background-color: var(--omega-primary);\n    border-radius: 7px;\n    color: var(--omega-primary-foreground);\n}\n\n.omega-datepicker-day-cell.is-selection-middle {\n    background-color: var(--omega-calendar-selection-color);\n    color: var(--omega-primary);\n}\n\n.omega-datepicker-day-cell.is-selection-start::before,\n.omega-datepicker-day-cell.is-selection-end::before {\n    position: absolute;\n    z-index: -1;\n    right: 0;\n    display: block;\n    width: 20px;\n    height: 30px;\n    background-color: var(--omega-calendar-selection-color);\n    content: '';\n}\n\n.omega-datepicker-day-cell.is-selection-start.is-selection-end::before {\n    display: none;\n}\n\n.omega-datepicker-day-cell.is-selection-start::before {\n    right: 0;\n}\n\n.omega-datepicker-day-cell.is-selection-end::before {\n    left: 0;\n}\n\n.omega-datepicker-last-month,\n.omega-datepicker-next-month {\n    color: var(--omega-grayed-out);\n}\n\n.omega-datepicker:not(.is-open) .omega-datepicker-list {\n    display: none;\n}\n\n.omega-datepicker-list {\n    padding: 0;\n    margin: 0 -10px -10px;\n    list-style: none;\n}\n\n.omega-datepicker-list > li {\n    padding: 5px 10px 5px 10px;\n    border-top: 1px solid #eaeaea;\n}\n\n.omega-datepicker-calendar input {\n    width: 280px;\n    padding: 0 10px;\n    font-size: 12px;\n    text-align: right;\n}\n\n.omega-datepicker-range-input-group {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 5px;\n}\n\n.omega-datepicker-calendar .omega-datepicker-range-input-group input {\n    width: calc(50% - 3px);\n    border-radius: 4px;\n    text-align: left;\n}\n\n.omega-datepicker-calendar:not(.is-range) .omega-datepicker-range-input-group {\n    display: none;\n}\n\n.omega-datepicker-calendar.is-range .omega-datepicker-calendar-input {\n    display: none;\n}\n\n.omega-datepicker-option {\n    cursor: pointer;\n    outline: none;\n}\n\n.omega-datepicker-option.is-active {\n    font-weight: 600;\n}\n\n.omega-datepicker-option.has-padding {\n    padding-bottom: 285px;\n}\n\n.omega-datepicker .omega-datepicker-specific-date-container {\n    position: absolute;\n    top: 50px;\n    height: 100px;\n}\n\n.omega-datepicker .omega-datepicker-date-range-container {\n    position: absolute;\n    top: 75px;\n    height: 100px;\n}\n\n.omega-datepicker .omega-datepicker-calendar-table {\n    position: absolute;\n    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);\n    z-index: -10;\n    opacity: 0;\n}\n\n.omega-datepicker .omega-datepicker-calendar-table.is-open {\n    overflow-y: hidden;\n    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);\n    z-index: 5;\n    opacity: 1;\n}\n\n.omega-datepicker .omega-datepicker-month-list {\n    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);\n    z-index: -10;\n    opacity: 0;\n}\n\n.omega-datepicker .omega-datepicker-month-list.is-open {\n    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);\n    z-index: 5;\n    opacity: 1;\n}\n\n.omega-datepicker-month {\n    width: 40px;\n    width: var(--datepicker-month-button-width);\n    height: var(--datepicker-month-button-height);\n    margin: 0 4px;\n    border: none;\n    appearance: none;\n    background-color: transparent;\n    line-height: var(--datepicker-month-button-height);\n    text-align: center;\n    text-transform: uppercase;\n}\n\n.omega-datepicker-month:hover {\n    border: 1px solid var(--omega-primary);\n    border-radius: 5px;\n}\n\n.omega-datepicker-month-cell {\n    position: relative;\n}\n\n.omega-datepicker-month-cell.is-selected button,\n.omega-datepicker-month-cell.is-selection-start button,\n.omega-datepicker-month-cell.is-selection-end button {\n    background-color: var(--omega-primary);\n    border-radius: 7px;\n    color: var(--omega-primary-foreground);\n}\n\n.omega-datepicker-year-list {\n    position: absolute;\n    overflow-y: scroll;\n    list-style-type: none;\n    top: 80px;\n    height: 205px;\n    right: 0;\n    left: 0;\n    overflow-x: hidden;\n    padding: 0;\n    margin: 0;\n    background: white;\n    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);\n    opacity: 0;\n    z-index: -10;\n}\n\n.omega-datepicker-year-list.is-open {\n    transition: all 0.4s cubic-bezier(0, 0.88, 0.39, 0.67);\n    opacity: 1;\n    z-index: 5;\n}\n\n.omega-datepicker-year-list-item {\n    cursor: pointer;\n    text-align: center;\n    font-size: medium;\n    padding: 5px 0px;\n}\n\n.omega-datepicker-year-list-item.is-selected {\n    font-weight: 600;\n    font-size: x-large;\n}\n\n.omega-datepicker-year-list-item:hover {\n    background-color: var(--omega-calendar-selection-color);\n}\n",".omega-form-field input.address-street {\r\n    width: 300px;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.omega-form-field input.address-city {\r\n    width: 140px;\r\n}\r\n\r\n.omega-form-field input.address-state {\r\n    width: 50px;\r\n    margin: 0 10px;\r\n}\r\n\r\n.omega-form-field input.address-zip {\r\n    width: 90px;\r\n}\r\n",".omega-table-filters {\r\n    position: sticky;\r\n    top: 45px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    padding: 10px;\r\n    border-top: 1px #ccc;\r\n    background-color: #f1f8fd;\r\n}\r\n\r\n.omega-table-filter-wrapper {\r\n    display: flex;\r\n    flex: 500px 20 1;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.omega-table-filter {\r\n    width: 300px;\r\n    margin: 0;\r\n}\r\n\r\n.omega-table-button-wrapper {\r\n    display: flex;\r\n    flex: 110px 1 1;\r\n    flex-flow: column wrap;\r\n    align-self: center;\r\n    padding-top: 18px;\r\n    margin: 10px;\r\n    direction: rtl;\r\n}\r\n\r\n.omega-table-button-wrapper omega-button-legacy button {\r\n    width: 100%;\r\n}\r\n\r\n.omega-table-filters .omega-form-field {\r\n    flex-flow: column;\r\n    margin: 10px;\r\n}\r\n\r\n.omega-table-filters .omega-form-field label {\r\n    color: #656a81;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n}\r\n\r\n.omega-table-filters .omega-form-field label::after {\r\n    content: '';\r\n}\r\n\r\n@media only screen and (max-width: 900px) {\r\n    .omega-table-button-wrapper {\r\n        padding-top: 0;\r\n    }\r\n}\r\n","@import url('./form-group.css');\n@import url('./buttons/buttons.css');\n@import url('./checkbox.css');\n@import url('./inputs.css');\n@import url('./select.css');\n@import url('./date-range.css');\n@import url('./amount-range.css');\n@import url('./toggle.css');\n@import url('./combobox.css');\n@import url('./multiple-select.css');\n@import url('./autocomplete.css');\n@import url('./datepicker.css');\n@import url('./address.css');\n@import url('./table-filters.css');\n\n.omega-field-parts {\n    display: inline-block;\n}\n\n.omega-form-field .omega-form-field {\n    margin: 10px 0;\n}\n",".omega-table-form {\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0;\r\n}\r\n\r\nomega-table-legacy details {\r\n    display: none;\r\n}\r\n\r\nomega-table-legacy {\r\n    position: relative;\r\n    display: block;\r\n\r\n    /* padding: 0 0 31px; */\r\n}\r\n\r\nomega-table-legacy .sticky-header {\r\n    position: sticky;\r\n    top: -1px;\r\n    height: 31px;\r\n    padding: 5px;\r\n    margin: 0 -1px -31px;\r\n    background-color: white;\r\n    font-weight: bold;\r\n    text-align: left;\r\n}\r\n\r\nomega-table-legacy .omega-table-title {\r\n    z-index: -1; /* to slide behind the sticky control bar */\r\n    top: 45px;\r\n    padding: 10px 20px;\r\n    margin: 0;\r\n    background-color: white;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n}\r\n\r\nomega-table-legacy table {\r\n    width: 100%;\r\n    margin: 0;\r\n    border-collapse: collapse;\r\n    font-size: 13px;\r\n}\r\n\r\nomega-table-legacy .table-footer {\r\n    position: sticky;\r\n    top: 0;\r\n    bottom: -1px;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 60px;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 10px 15px;\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n.omega-table-empty-state {\r\n    display: flex;\r\n    height: 50vh;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.omega-table-empty-state span {\r\n    font-size: 18px;\r\n}\r\n","omega-filter-control {\r\n    display: block;\r\n    padding: 5px;\r\n}\r\n\r\n.advanced-filters {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n.advanced-filters input {\r\n    display: block;\r\n}\r\n\r\n.advanced-filters li input {\r\n    display: inline-block;\r\n}\r\n\r\n.omega-table details {\r\n    margin: 10px;\r\n}\r\n\r\n.omega-table summary h3 {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n}\r\n\r\n.date-filter input {\r\n    display: inline-block;\r\n    clear: none;\r\n}\r\n\r\n.advanced-filters .radio-list {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n.advanced-filters .radio-list li {\r\n    padding: 5px;\r\n}\r\n",".omega-table-controls {\r\n    display: flex;\r\n    min-height: 45px;\r\n    align-items: center;\r\n    padding: 0 18px;\r\n}\r\n\r\n.omega-table-filters.omega-table-controls-panel {\r\n    z-index: 3;\r\n    max-height: 0;\r\n    padding: 0 10px;\r\n    transition: max-height 0.1s ease-out;\r\n}\r\n\r\n.omega-table-filters-hidden {\r\n    overflow: hidden;\r\n}\r\n\r\n.omega-table-controls span {\r\n    padding-left: 5px;\r\n    color: #318ec6;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n\r\n.omega-table .omega-table-controls {\r\n    position: sticky;\r\n    z-index: 1;\r\n    top: 0;\r\n    width: 100%;\r\n    padding: 5px 0 5px 18px;\r\n    border: none;\r\n    border-top: 1px solid #e6e6e6;\r\n    border-bottom: 1px solid #e6e6e6;\r\n    background-color: #f9f9f9;\r\n    transition: 0.4s;\r\n}\r\n\r\n.omega-table-controls-filter-btn {\r\n    cursor: pointer;\r\n}\r\n\r\n.omega-table.omega-table-has-caption .omega-table-controls {\r\n    top: 20px; /* To leave room for the slide-from-behind sticky header */\r\n}\r\n\r\n.omega-table .quick-filter {\r\n    width: 400px;\r\n}\r\n",".omega-table-table th,\r\n.omega-table-table thead td {\r\n    position: sticky;\r\n    z-index: 1;\r\n    height: 45px;\r\n    padding: 0 10px;\r\n    border-width: 0;\r\n    border-style: solid;\r\n    font-size: 14px;\r\n    background-color: #e6e6e6;\r\n    box-shadow: inset 0 -1px 0 #ccc;\r\n    color: #464646;\r\n    font-weight: 400;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n}\r\n\r\n.omega-table.omega-table-has-caption th,\r\n.omega-table.omega-table-has-caption thead td {\r\n    top: 64px; /* to make space for the sticky control bar and slide from behind header */\r\n}\r\n\r\n.omega-table th.sortable {\r\n    cursor: pointer;\r\n}\r\n\r\n.omega-table th.sortable[aria-sort='ascending']::after {\r\n    content: '\\f0de';\r\n}\r\n\r\n.omega-table th.sortable[aria-sort='descending']::after {\r\n    content: '\\f0dd';\r\n}\r\n\r\n.omega-table th.sortable::after {\r\n    display: inline-block;\r\n    width: 1em;\r\n    height: 1em;\r\n    margin-left: 2px;\r\n    background-size: 1em 1em;\r\n    content: '\\f0dc';\r\n    font-family: FontAwesome;\r\n    opacity: 0.5;\r\n    vertical-align: top;\r\n}\r\n\r\n.omega-table-sort-button {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 100%;\r\n    cursor: pointer;\r\n    opacity: 0.01;\r\n}\r\n",".omega-table-table tr:nth-of-type(2n) {\r\n    background-color: #fafbfc;\r\n    border-top: 1px solid #e6eaee;\r\n    border-bottom: 1px solid #e6eaee;\r\n}\r\n\r\nomega-table-legacy .select-column {\r\n    width: 30px;\r\n    text-align: center;\r\n}\r\n\r\n.omega-table-table td {\r\n    padding: 15px 10px;\r\n    line-height: 16px;\r\n    font-size: 13px;\r\n    color: #3c3c3c;\r\n}\r\n",".pagination-message {\r\n    font-weight: bold;\r\n}\r\n\r\n.pagination-nav {\r\n    display: flex;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.pagination-controls {\r\n    display: flex;\r\n}\r\n\r\n.pagination-nav ol {\r\n    display: inline-block;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.pagination-nav li {\r\n    display: inline-block;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n.omega-table .pagination-nav a {\r\n    display: block;\r\n    min-width: 20px;\r\n    padding: 0 10px;\r\n    border: 1px solid #ddd;\r\n    border-right-width: 0;\r\n    background-color: white;\r\n    color: #337ab7;\r\n    cursor: pointer;\r\n    line-height: 30px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n}\r\n\r\n.pagination-nav a:hover {\r\n    border-color: #ddd;\r\n    background-color: #eee;\r\n    color: #22527b;\r\n}\r\n\r\n.pagination-nav li {\r\n    font-weight: bold;\r\n}\r\n\r\n.pagination-nav .omega-disabled {\r\n    font-weight: normal;\r\n    opacity: 0.5;\r\n}\r\n\r\n.omega-table .pagination-nav [aria-disabled='true'] {\r\n    color: inherit;\r\n    cursor: default;\r\n    pointer-events: none;\r\n}\r\n\r\n.omega-table .pagination-nav [aria-current='page'] {\r\n    background-color: #337ab7;\r\n    color: #fff;\r\n    cursor: default;\r\n    pointer-events: none;\r\n}\r\n\r\n.pagination-nav li:first-child a {\r\n    border-bottom-left-radius: 3px;\r\n    border-top-left-radius: 5px;\r\n}\r\n\r\n.pagination-nav li:last-child a {\r\n    border-right-width: 1px;\r\n    border-bottom-right-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n}\r\n\r\n.table-footer select {\r\n    height: 30px;\r\n    margin: 0 10px;\r\n}\r\n",".omega-table th.numeric,\r\n.omega-table td.numeric {\r\n    text-align: right;\r\n}\r\n\r\n.omega-table th.date,\r\n.omega-table td.date {\r\n    text-align: center;\r\n}\r\n\r\n.omega-table th.time,\r\n.omega-table td.time {\r\n    text-align: center;\r\n}\r\n\r\n.omega-table th.dateTime,\r\n.omega-table td.dateTime {\r\n    text-align: center;\r\n}\r\n\r\n.omega-table th.userIdentification,\r\n.omega-table td.userIdentification {\r\n    text-align: left;\r\n}\r\n\r\n.omega-table th.userType,\r\n.omega-table td.userType {\r\n    text-align: center;\r\n}\r\n\r\n.omega-table th.enum,\r\n.omega-table td.enum {\r\n    text-align: center;\r\n}\r\n\r\n.omega-table .negative {\r\n    color: #c51012;\r\n}\r\n","@import url('./table-core.css');\r\n@import url('./table-filters.css');\r\n@import url('./table-control-bar.css');\r\n@import url('./table-headers.css');\r\n@import url('./table-body.css');\r\n@import url('./table-pagination.css');\r\n@import url('./table-datatypes.css');\r\n\r\n.omega-table table {\r\n    overflow-x: auto;\r\n}\r\n\r\n.omega-table .radio-list {\r\n    display: flex;\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n.omega-table .radio-list li > * {\r\n    display: inline-block;\r\n}\r\n\r\n.omega-table :not(form).ng-invalid {\r\n    border: 1px solid #cc1010;\r\n    background-color: rgba(204, 16, 16, 0.03);\r\n    border-radius: 3px;\r\n}\r\n\r\n.omega-table :not(form).ng-pristine {\r\n    border: 1px solid rgb(199, 199, 199);\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n}\r\n\r\n.omega-table .error-indicator {\r\n    display: none;\r\n}\r\n\r\n.omega-table tr.has-errors .error-indicator {\r\n    display: inline;\r\n}\r\n\r\n.omega-table a {\r\n    text-decoration: underline;\r\n}\r\n\r\n.omega-is-loading {\r\n    opacity: 0.7;\r\n    transition: opacity 0.3s;\r\n}\r\n",":root {\r\n    /* theme colors */\r\n    --omega-primary-darken-100: var(--brand-color-dark, #0e5daa);\r\n    --omega-primary: var(--brand-color, #0065cf);\r\n    --omega-primary-lighten-100: var(--brand-color-light, #508cdd);\r\n    --omega-primary-lighten-200: #8ab3e8;\r\n    --omega-primary-lighten-300: #c4d8f4;\r\n    --omega-primary--focus: #ddebfb;\r\n    --omega-secondary: #515c66;\r\n    --omega-secondary-lighten-100: #7c858c;\r\n    --omega-secondary-lighten-200: #a8adb2;\r\n    --omega-secondary-lighten-300: #d3d6d9;\r\n    --omega-secondary-lighten-400: #edf0f3;\r\n    --omega-success-darken-100: #348640;\r\n    --omega-success: #22883f;\r\n    --omega-success-lighten-100: #6ec174;\r\n    --omega-success-lighten-200: #a0d5a2;\r\n    --omega-success-lighten-300: #cfebd1;\r\n    --omega-warning-darken-200: #b36200;\r\n    --omega-warning-darken-100: #d47b25;\r\n    --omega-warning: #ed943e;\r\n    --omega-warning-lighten-100: #f1af72;\r\n    --omega-warning-lighten-200: #f7c8a3;\r\n    --omega-warning-lighten-300: #fae4d0;\r\n    --omega-error-darken-100: #9d0e0e;\r\n    --omega-error: #c00000;\r\n    --omega-error-lighten-100: #d65b4a;\r\n    --omega-error-lighten-200: #ecada4;\r\n    --omega-error-lighten-300: #f7d7d2;\r\n    --omega-accent: #6758f3;\r\n    --omega-accent-lighten-100: #8b81f7;\r\n    --omega-accent-lighten-200: #b2acfa;\r\n    --omega-accent-lighten-300: #dad6fd;\r\n    --omega-info-darken-200: #4f4f4f;\r\n    --omega-info-darken-100: #696969;\r\n    --omega-info: #828282;\r\n    --omega-info-lighten-100: #a2a2a2;\r\n    --omega-info-lighten-200: #c1c1c1;\r\n    --omega-info-lighten-300: #e0e0e0;\r\n    /* buttons */\r\n    --omega-button-primary-box-shadow: var(--brand-color-darker, #337ab7);\r\n    --omega-button-secondary-box-shadow: var(--brand-color-darker, #337ab7);\r\n    --omega-button-secondary-darken-100: #f2f6fa;\r\n    --omega-button-approve-box-shadow: #55bb72;\r\n    --omega-button-success-box-shadow: #55bb72;\r\n    --omega-button-reject-box-shadow: #ee3a3b;\r\n    --omega-button-icon-border: transparent;\r\n    --omega-button-icon-box-shadow: transparent;\r\n    --omega-button-icon-color: var(--omega-primary);\r\n    --omega-button-icon-darken-100: #bfd8f3;\r\n    --omega-button-icon-hover: var(--brand-color-lighter, #d9e8f8);\r\n    --omega-button-disabled-background: #828282;\r\n    --omega-button-disabled-secondary-color: #6d7883;\r\n    --omega-button-disabled-secondary-border-color: #87929d;\r\n    --omega-button-disabled-secondary-box-shadow: #b9b9b9;\r\n    --omega-button-exclamation-triangle-color: #ffc121;\r\n    --omega-button-exclamation-triangle-danger-color: #ee3a3b;\r\n    --omega-button-exclamation-triangle-warning-color: #f06f19;\r\n    /* element colors */\r\n    --omega-page-background: #ededed;\r\n    --omega-primary-foreground: #fff;\r\n    --omega-table-row-color: #f5f5f5;\r\n    --omega-divider-color: #dddddd;\r\n    --omega-calendar-selection-color: #cddeeb;\r\n    --omega-white: #fff;\r\n    --omega-white-100: #f5f5f5;\r\n    --omega-white-150: #e9e9e9;\r\n    --omega-light-grey: #ccc;\r\n    --omega-grayed-out: #999;\r\n    --omega-dark-grey: #4c4d4e;\r\n    /* font family */\r\n    --omega-font: Roboto, sans-serif;\r\n    /* font colors */\r\n    --omega-text-default: #3e3f42;\r\n    --omega-text-secondary: #6b6c6f;\r\n    --omega-text-tertiary: #949494;\r\n    --omega-text-success: #34aa44;\r\n    --omega-text-header: #545454;\r\n    --omega-text-error: #b30606;\r\n    --omega-text-time-sensitive: #0ba6aa;\r\n    --omega-text-help: #696969;\r\n    --omega-text-inverted: #fcfcfc;\r\n    /* font sizes */\r\n    --omega-h1: 24px;\r\n    --omega-h2: 20px;\r\n    --omega-h3: 18px;\r\n    --omega-h4: 16px;\r\n    --omega-h5: 14px;\r\n    --omega-label: 14px;\r\n    --omega-p: 13px;\r\n    --omega-input: 13px;\r\n    --omega-small: 12px;\r\n    --omega-hint: 11px;\r\n    /* font weights */\r\n    --omega-bold: 700;\r\n    --omega-semi-bold: 500;\r\n    --omega-medium: 400;\r\n    --omega-regular: 300;\r\n    --omega-light: 100;\r\n    /* inputs */\r\n    --omega-input-success-border: #34aa44;\r\n    --omega-input-error-border: #bf0000;\r\n    --omega-input-active-border: #15b1eb;\r\n    --omega-input-default-border: #dfe1e8;\r\n    --omega-input-hover-border: #c8d8de;\r\n    --omega-input-border-radius: 3px;\r\n    --omega-input-disabled-border: #e6e8ec;\r\n    --omega-input-disabled-background: #f9f9f9;\r\n    /* accents */\r\n    --omega-dialog-overlay: rgba(9, 17, 9, 0.75);\r\n    --omega-dialog-shadow: 0px 0px 8px 0px #333;\r\n    --omega-default-shadow: 0px 0px 5px 3px rgba(150, 150, 150, 0.75);\r\n    --omega-primary-shadow: 0px 0px 3px 2px rgba(84, 102, 206, 0.5);\r\n    --omega-menu-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.25);\r\n    /* borders */\r\n    --omega-default-border: 1px solid #dddddd;\r\n    --omega-primary-border: 1px solid rgba(0, 101, 207, 0.5);\r\n    --omega-success-border: 1px solid rgba(2, 161, 46, 0.5);\r\n    --omega-warning-border: 1px solid rgba(255, 101, 1, 0.5);\r\n    --omega-error-border: 1px solid rgba(191, 0, 0, 0.5);\r\n    --omega-time-sensitive-border: 1px solid rgba(0, 180, 185, 0.5);\r\n    --omega-help-border: 1px solid rgba(105, 105, 105, 0.5);\r\n    /* images */\r\n    --omega-dropdown-arrow: url(data:image/png;base64,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);\r\n    /* transitions */\r\n    --omega-zoom-in: all 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045);\r\n    --omega-zoom-out: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n    /* margins */\r\n    --omega-input-margin: 8px;\r\n    /* omega-label */\r\n    --omega-label-color: var(--omega-text-default);\r\n    /* omega-field */\r\n    --omega-field-color: var(--omega-text-default);\r\n    --omega-field-font-weight: var(--omega-text-semi-bold);\r\n    /* omega-dialog */\r\n    --omega-dialog-header-font-size: 16px;\r\n}\r\n","dialog::backdrop {\r\n    background: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.omega-dialog {\r\n    position: absolute;\r\n    top: 5%;\r\n    min-width: 600px;\r\n    max-width: 900px;\r\n    padding: 0;\r\n    border: none;\r\n    border-radius: 3px;\r\n    box-shadow: 0 3px 6px 0;\r\n    color: var(--omega-base-font-color);\r\n}\r\n\r\n.omega-dialog-title {\r\n    flex: 1 1;\r\n    padding: 15px;\r\n    margin: 0;\r\n    border-bottom: 1px solid var(--omega-divider-color);\r\n    font-size: 18px;\r\n}\r\n\r\n.omega-dialog-body {\r\n    padding: 15px;\r\n}\r\n\r\n.omega-dialog omega-button-bar {\r\n    display: block;\r\n    width: 100%;\r\n    flex: 1 1;\r\n    border-top: 1px solid var(--omega-divider-color);\r\n    text-align: left;\r\n}\r\n",".omega-lookup-filter {\r\n    width: 100%;\r\n    height: 32px;\r\n    padding: 6px 10px;\r\n    border: 1px solid #ccc;\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    font-size: 13px;\r\n    line-height: 20px;\r\n    transition:\r\n        border-color ease-in-out 0.15s,\r\n        box-shadow ease-in-out 0.15s;\r\n}\r\n\r\n.omega-lookup-filter-container {\r\n    position: relative;\r\n}\r\n\r\n.omega-lookup-filter-icon {\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 12px;\r\n    color: #aaa;\r\n}\r\n\r\n.omega-lookup-list {\r\n    overflow: auto;\r\n    max-height: calc(100vh - 220px);\r\n    padding: 0;\r\n    margin: 10px 0;\r\n    background: none;\r\n    list-style: none;\r\n}\r\n\r\n.omega-lookup-list > li {\r\n    position: relative;\r\n    overflow: auto;\r\n    padding: 15px;\r\n    margin: 5px;\r\n    border: 2px solid #eee;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.omega-account-lookup-account-name {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    color: var(--omega-brand-color);\r\n    font-size: 18px;\r\n    text-decoration: none;\r\n}\r\n\r\n.omega-account-lookup-account-type {\r\n    padding-right: 10px;\r\n    border-right: 1px solid #999;\r\n    color: #9b9b9b;\r\n    font-size: 13px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.omega-account-lookup-account-number {\r\n    padding-left: 5px;\r\n    margin: 0;\r\n    font-size: 13px;\r\n}\r\n\r\n.omega-account-lookup-account-balance {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 20px;\r\n    font-size: 20px;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.omega-lookup-list-count {\r\n    padding: 0 5px;\r\n    font-size: 13px;\r\n    font-weight: bold;\r\n}\r\n","[role='listbox'] .omega-account-name {\r\n    display: block;\r\n    max-width: 200px;\r\n    padding-right: 15px;\r\n    float: left;\r\n    font-weight: bold;\r\n}\r\n\r\n[role='listbox'] .omega-account-number {\r\n    display: block;\r\n    clear: both;\r\n    float: left;\r\n}\r\n\r\n[role='listbox'] .omega-account-balance {\r\n    display: block;\r\n    float: right;\r\n}\r\n",".omega-ach-company-lookup-list > li {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n\r\n.group-1 {\r\n    max-width: 300px;\r\n    margin-right: 50px;\r\n}\r\n\r\n.group-2 {\r\n    min-width: 200px;\r\n    height: auto;\r\n    margin: auto 0;\r\n}\r\n\r\n.omega-lookup-ach-company-name {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    color: var(--omega-primary);\r\n    font-size: 18px;\r\n}\r\n\r\n.omega-lookup-ach-company-id {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    color: var(--omega-text-secondary);\r\n    font-size: 18px;\r\n    text-align: right;\r\n}\r\n\r\n.omega-lookup-ach-company-description {\r\n    display: inline-block;\r\n    padding: 0 10px 0 0;\r\n    margin: 0 10px 8px 0;\r\n    border-right: 1px solid var(--omega-text-secondary);\r\n    color: var(--omega-text-secondary);\r\n}\r\n\r\n.omega-lookup-ach-company-sec-code-list {\r\n    display: inline;\r\n    padding: 0;\r\n    margin: 0;\r\n    color: var(--omega-text-secondary);\r\n    list-style: none;\r\n}\r\n\r\n.omega-lookup-ach-company-account-type-list {\r\n    display: inline;\r\n    padding: 0 0 0 10px;\r\n    margin: 0 0 0 10px;\r\n    border-left: 1px solid var(--omega-text-secondary);\r\n    color: var(--omega-text-secondary);\r\n    list-style: none;\r\n    text-align: right;\r\n}\r\n\r\n.omega-lookup-ach-company-sec-code-list > li,\r\n.omega-lookup-ach-company-account-type-list > li {\r\n    display: inline;\r\n}\r\n\r\n.omega-lookup-ach-company-sec-code-list > li {\r\n    padding: 3px 5px;\r\n    margin: 0 0 0 10px;\r\n    background-color: #ddd;\r\n    border-radius: 10px;\r\n}\r\n\r\n.omega-lookup-ach-company-account-type-list > li:not(:last-child)::after {\r\n    content: ', ';\r\n}\r\n\r\n.omega-lookup-ach-company-discretionary-data {\r\n    display: inline-block;\r\n    color: var(--omega-text-secondary);\r\n}\r\n\r\n.omega-lookup-ach-company-batch-balance-requirements {\r\n    display: inline;\r\n    color: var(--omega-text-secondary);\r\n    text-align: right;\r\n}\r\n",".omega-alert {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 10px;\r\n    margin: 10px 0;\r\n    border: 1px solid black;\r\n    border-left-width: 5px;\r\n}\r\n\r\n.omega-alert-close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    display: none;\r\n    border: none;\r\n    appearance: none;\r\n    background: none;\r\n    font-weight: bold;\r\n}\r\n\r\n.omega-alert-icon {\r\n    display: block;\r\n    width: 50px;\r\n    font-size: 24px;\r\n}\r\n\r\n.omega-alert p {\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.omega-alert-info {\r\n    border-color: #337ab7;\r\n}\r\n\r\n.omega-alert-info .omega-alert-icon {\r\n    color: #337ab7;\r\n}\r\n\r\n.omega-alert-success {\r\n    border-color: #2caa55;\r\n}\r\n\r\n.omega-alert-success .omega-alert-icon {\r\n    color: #2caa55;\r\n}\r\n\r\n.omega-alert-warning {\r\n    border-color: #ff6501;\r\n}\r\n\r\n.omega-alert-warning .omega-alert-icon {\r\n    color: #ff6501;\r\n}\r\n\r\n.omega-alert-error {\r\n    border-color: #ec3a3b;\r\n}\r\n\r\n.omega-alert-error .omega-alert-icon {\r\n    color: #ec3a3b;\r\n}\r\n\r\n.omega-alert-header {\r\n    font-size: 18px;\r\n}\r\n\r\n.omega-alert-aggressive {\r\n    position: fixed;\r\n    z-index: 1100;\r\n    top: calc(35%);\r\n    left: calc(50% - 87.5px);\r\n    width: 400px;\r\n    height: 175px;\r\n    padding: 15px;\r\n    background-color: white;\r\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.18);\r\n    color: #3c3c3c;\r\n    font-size: 13px;\r\n    text-align: center;\r\n}\r\n\r\n.omega-alert-aggressive-success {\r\n    border: 1px solid #2caa55;\r\n}\r\n\r\n.omega-alert-aggressive-error {\r\n    border: 1px solid #ec3a3b;\r\n}\r\n\r\n.omega-alert-aggressive-success-text {\r\n    color: #2caa55;\r\n}\r\n\r\n.omega-alert-aggressive-error-text {\r\n    color: #ec3a3b;\r\n}\r\n\r\n.omega-alert-aggressive-success-icon {\r\n    color: #2caa55;\r\n}\r\n\r\n.omega-alert-aggressive-warning-icon {\r\n    color: #ff6501;\r\n}\r\n\r\n.omega-alert-aggressive-error-icon {\r\n    color: #ec3a3b;\r\n}\r\n\r\n.close-aggressive-alert-button {\r\n    margin-top: -15px;\r\n    margin-left: 369px;\r\n}\r\n\r\n.omega-close-alert-button {\r\n    color: darkgrey;\r\n}\r\n\r\ni.fa.fa-times.omega-close-alert-button {\r\n    font-size: 1em;\r\n}\r\n",".omega-download-bar {\r\n    z-index: 2;\r\n    top: 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    background-color: #fff;\r\n    align-items: center;\r\n}\r\n\r\n.omega-download-bar-button-group {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.download-bar-item {\r\n    display: inline-block;\r\n    font-size: 16px;\r\n    height: 55px;\r\n}\r\n\r\n.download-bar-item button {\r\n    width: 44px;\r\n    height: 44px;\r\n}\r\n\r\n.omega-download-bar-menu {\r\n    position: relative;\r\n}\r\n\r\n.omega-download-dropdown {\r\n    position: absolute;\r\n    top: 46px;\r\n    z-index: 5;\r\n    min-width: 50px;\r\n    padding: 0;\r\n    border: 1px solid #e9e9e9;\r\n    background: #fff;\r\n    border-radius: 3px;\r\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);\r\n    list-style: none;\r\n}\r\n\r\n.omega-download-dropdown li {\r\n    min-width: 50px;\r\n    padding: 10px 25px;\r\n    text-align: center;\r\n    color: #0070b7;\r\n    cursor: pointer;\r\n}\r\n\r\n.omega-download-dropdown li:hover {\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.omega-download-dropdown a {\r\n    text-decoration: none;\r\n}\r\n\r\n.omega-download-bar-actions {\r\n    display: inline;\r\n}\r\n\r\n.omega-download-bar-actions i {\r\n    position: absolute;\r\n    margin-top: 18px;\r\n    margin-left: 182px;\r\n    color: darkgrey;\r\n}\r\n\r\n.omega-download-save-button {\r\n    height: 25px;\r\n    margin-right: 5px;\r\n    border: 1px solid #337ab7;\r\n    background-color: #337ab7;\r\n    border-radius: 3px;\r\n    color: #fff;\r\n}\r\n\r\n.omega-download-cancel-button {\r\n    height: 25px;\r\n    margin-right: 28px;\r\n    border: 1px solid #d3d3d3;\r\n    background-color: white;\r\n    border-radius: 3px;\r\n    color: dimgrey;\r\n}\r\n\r\n.omega-save-report {\r\n    overflow: hidden;\r\n    width: 200px;\r\n    height: 25px;\r\n    padding: 8px;\r\n    margin-right: 5px;\r\n    border: 1px solid #337ab7;\r\n    border-radius: 3px;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.omega-download-bar.open.dropdown-menu.omega-dropdown {\r\n    margin-left: 190px;\r\n}\r\n\r\nbutton[disabled].omega-download-save-button {\r\n    cursor: not-allowed;\r\n    opacity: 65%;\r\n}\r\n\r\n.omega-download-bar-page-title {\r\n    padding-left: 10px;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    color: rgb(129, 127, 127);\r\n}\r\n\r\n.omega-download-bar-report-title {\r\n    padding-left: 18px;\r\n    font-size: 17px;\r\n    font-weight: 600;\r\n}\r\n",".omega_container_droppable {\n    position: relative !important; /* was being overridden to static */\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n    background: #f2f2f2;\n    border-radius: 4px;\n    border: 1px solid #e0e0e0;\n    margin: 20px 0;\n    padding: 5px;\n    min-height: 60px;\n}\n\n.omega_tile_draggable {\n    position: relative;\n    display: block;\n    margin: 5px;\n    width: 225px;\n    height: 45px;\n    padding: 5px;\n    background-color: #fcfcfc;\n    border: 1px solid #d6d6d6;\n    border-radius: 4px;\n    cursor: move;\n}\n\n.omega_tile_fixed_position {\n    width: 275px;\n}\n\n.omega_tile_draggable:before,\n.omega_tile_draggable:after {\n    box-sizing: border-box;\n    transition:\n        background-color 400ms ease-out,\n        border-color 400ms ease-out,\n        color 400ms ease-out;\n}\n\n.omega_tile_draggable.active {\n    background: #eee;\n    border: 1px dashed #a6a6a6;\n}\n\n.omega_tile_draggable[data-type='payment information']:not(.active) {\n    border-left: 6px solid #19c466;\n}\n\n.omega_tile_draggable[data-type='beneficiary information']:not(.active) {\n    border-left: 6px solid #00bde9;\n}\n\n.omega_tile_draggable[data-type='domestic intermediary']:not(.active) {\n    border-left: 6px solid #a5a5a5;\n}\n\n.omega_tile_draggable[data-type='filler']:not(.active) {\n    background:\n        linear-gradient(#fff, #fff) padding-box,\n        repeating-linear-gradient(45deg, #ffffff, #ffffff 2px, #ffffff 2px, #6e6e6e 4px) border-box;\n    border-left: 6px solid transparent;\n}\n\n.omega_tile_draggable.omega_tile_default {\n    border-left: 6px solid rgb(104, 93, 93);\n}\n\n.omega_tile_draggable.dragging {\n    background: #e6eaee;\n    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.7);\n    opacity: 0.925;\n}\n\n.omega_tile_draggable.dragging .tile_order {\n    display: none;\n}\n\n.omega_tile_draggable.active .tile_order {\n    display: none;\n}\n\n.tile_position_count_input {\n    position: absolute;\n    top: 0;\n    left: 218px;\n    width: 50px;\n    height: 43px;\n    border: none;\n    border-left: 1px solid #d6d6d6;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    font-size: 14px;\n    font-weight: 600;\n    padding-left: 10px;\n}\n\n.tile_position_button {\n    padding: 0;\n    border: none;\n    background: none;\n    padding: 5px;\n    margin: 5px;\n    position: absolute;\n    right: 3px;\n}\n\n.tile_position_button::after {\n    position: absolute;\n    width: 0;\n    right: 1px;\n    top: 3px;\n    height: 0;\n    border-style: solid;\n    border-color: #4b4742 transparent;\n    content: '';\n}\n\n.tile_position_button[disabled='true']::after {\n    border-color: rgb(189, 183, 183) transparent;\n}\n\n.tile_position_button.add_button {\n    top: 3px;\n}\n\n.tile_position_button.add_button::after {\n    border-width: 0 4px 4px;\n}\n\n.tile_position_button.subtract_button {\n    top: 22px;\n}\n\n.tile_position_button.subtract_button::after {\n    border-width: 4px 4px 0;\n}\n\n.tile_position_count_input::-webkit-inner-spin-button,\n.tile_position_count_input::-webkit-outer-spin-button {\n    appearance: none;\n}\n\n.tile_order {\n    position: absolute;\n    top: 8px;\n    font-weight: 300;\n    font-size: 12px;\n}\n\n.omega_tile_delimited .tile_order {\n    right: 5px;\n}\n\n.omega_tile_fixed_position .tile_order {\n    right: 60px;\n}\n\n.omega_tile_draggable[data-active='false'] .tile_order {\n    display: none;\n}\n\n.tile_title {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 3px 0 0 3px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.tile_title span {\n    font-weight: 400;\n}\n\n.tile_subtitle {\n    width: 200px;\n    font-size: 11px;\n    margin: 0 0 0 3px;\n    color: grey;\n    text-transform: uppercase;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.tile_remove_button {\n    position: absolute;\n    top: 25px;\n    right: 0;\n    font-weight: 300;\n    font-size: 12px;\n    color: rgb(146, 141, 141);\n    font-size: 13px;\n    border: none;\n    display: none;\n}\n\n.omega_tile_draggable .tile_remove_button.show {\n    display: block;\n}\n\n.omega_tile_draggable.dragging .tile_remove_button {\n    opacity: 0;\n}\n\n.omega_tile_draggable.active .tile_remove_button {\n    opacity: 0;\n}\n\n.omega_tile_fixed_position .tile_remove_button {\n    right: 55px;\n}\n",".omega-icon-column {\r\n    text-align: center;\r\n}\r\n\r\n.omega-icon-column i {\r\n    cursor: pointer;\r\n    font-size: 20px;\r\n    min-width: 44px;\r\n}\r\n\r\n.omega-popover {\r\n    min-width: 400px;\r\n}\r\n\r\n.omega-popover-template-label {\r\n    min-width: 100px;\r\n    float: left;\r\n}\r\n\r\n.omega-popover-template-data {\r\n    float: right;\r\n}\r\n",".omega-file-format-container {\n    background: #f1f0f0;\n    padding: 1px 0 1px 0;\n    border-radius: 4px;\n    margin-bottom: 60px;\n}\n\n.omega-file-format-container label {\n    font-weight: 400;\n}\n\n.omega-file-format-input-row {\n    margin: 15px 0;\n}\n\n.omega-file-format-input {\n    display: block;\n}\n\n.omega-file-format-input-invalid {\n    border: 1px solid #c10f00 !important;\n    background-color: rgba(204, 16, 16, 0.03) !important;\n    box-shadow: 0 0 0 1px rgb(193, 15, 0, 0.2) !important;\n    transition: all 200ms cubic-bezier(0, 0, 0.29, 0.75) !important;\n}\n\n.omega-input-invalid-text {\n    color: #c10f00;\n}\n\n.omega-file-format-input-wrapper {\n    height: 60px;\n    width: 225px;\n    margin: 15px 5px;\n    align-items: center;\n}\n\n.omega-file-format-container section {\n    background: white;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    margin: 10px;\n    padding: 10px;\n}\n\n.omega-file-format-title-section {\n    min-height: 72px;\n}\n\n.omega-file-format-title-section h2 {\n    margin: 0;\n}\n\n.omega-file-format-section-header p {\n    display: inline-block;\n    font-size: 16px;\n    text-transform: capitalize;\n    font-weight: 400;\n}\n\n.omega-file-format-navigation {\n    position: relative;\n    bottom: -10px;\n    display: flex;\n}\n\n.omega-file-format-navigation label {\n    padding: 5px;\n    margin: 3px;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 125px;\n}\n\n/* TABS */\n.omega-tabs {\n    display: flex;\n}\n\n.omega-tab {\n    text-align: center;\n    font-weight: 600;\n    padding: 5px;\n    margin: 1px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #0070b7;\n}\n\n.omega-tab .page-tab {\n    max-width: 100px;\n}\n\n.omega-tab.active-tab {\n    border-bottom: 2px solid #0070b7;\n}\n\n.omega-tab-content {\n    display: none;\n}\n\n.omega-tab-content.show-tab-content {\n    display: block;\n    border-top: 1px solid #d4d2d2;\n}\n\n/* TOOLTIP */\n.omega-file-format-icon {\n    font-size: 16px;\n    color: #929090;\n    margin-left: 5px;\n    margin-top: 8px;\n}\n\n.omega-tooltip {\n    position: relative;\n    white-space: nowrap;\n    height: 32px;\n    min-width: 25px;\n}\n\n.omega-tooltip:after {\n    text-align: left;\n    white-space: normal;\n}\n\n.omega-tooltip:focus {\n    outline: none;\n}\n\n.omega-tooltip::before,\n.omega-tooltip::after {\n    left: 50%;\n    opacity: 0;\n    position: absolute;\n    z-index: -100;\n}\n\n.omega-tooltip:hover::before,\n.omega-tooltip:focus::before,\n.omega-tooltip:hover::after,\n.omega-tooltip:focus::after {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n    z-index: 100;\n}\n\n.omega-tooltip::before {\n    border-style: solid;\n    border-width: 1em 0.75em 0 0.75em;\n    border-color: #3e474f transparent transparent transparent;\n    bottom: 140%;\n    content: '';\n    margin-left: -0.5em;\n    transition:\n        all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26),\n        opacity 0.65s 0.5s;\n    transform: scale(0.6) translateY(-90%);\n}\n\n.omega-tooltip:hover::before,\n.omega-tooltip:focus::before {\n    transition: all 0.65s cubic-bezier(0.84, -0.18, 0.65, 1.13) 0.2s;\n}\n\n.omega-tooltip::after {\n    background: #3e474f;\n    border-radius: 0.25em;\n    bottom: 180%;\n    color: #edeff0;\n    content: attr(data-message);\n    margin-left: -8.75em;\n    padding: 1em;\n    transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26) 0.2s;\n    transform: scale(0.6) translateY(50%);\n    width: 17.5em;\n}\n\n.omega-tooltip:hover::after,\n.omega-tooltip:focus::after {\n    transition: all 0.65s cubic-bezier(0.84, -0.18, 0.31, 1.26);\n}\n\n.omega-file-format-name-section {\n    display: flex;\n    flex-wrap: wrap;\n    min-height: 100px;\n    align-items: center;\n}\n\n.omega-file-format-name-section span {\n    margin-left: 30px;\n    margin-top: 20px;\n}\n\n.omega-file-format-options-row {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n\n.omega-file-format-input {\n    width: 85% !important;\n}\n\n/* RADIOS */\n\n.omega-radio-group {\n    width: 225px;\n}\n\n.omega-radio-wrapper {\n    display: inline-block;\n}\n\n.omega-radio-wrapper * {\n    cursor: pointer;\n}\n\n.omega-radio-wrapper [type='radio']:checked,\n.omega-radio-wrapper [type='radio']:not(:checked) {\n    position: absolute;\n    left: -9999px;\n}\n\n.omega-radio-wrapper [type='radio']:checked + label,\n.omega-radio-wrapper [type='radio']:not(:checked) + label {\n    position: relative;\n    padding-left: 28px;\n    cursor: pointer;\n    line-height: 20px;\n    display: inline-block;\n    color: #666;\n}\n\n.omega-radio-wrapper [type='radio']:checked + label:before,\n.omega-radio-wrapper [type='radio']:not(:checked) + label:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #ddd;\n    border-radius: 100%;\n    background: #fff;\n}\n\n.omega-radio-wrapper [type='radio']:checked + label:after,\n.omega-radio-wrapper [type='radio']:not(:checked) + label:after {\n    content: '';\n    width: 12px;\n    height: 12px;\n    background: var(--omega-primary);\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    border-radius: 100%;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n}\n\n.omega-radio-wrapper [type='radio']:not(:checked) + label:after {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n}\n\n.omega-radio-wrapper [type='radio']:checked + label:after {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n\n.omega-file-format-select {\n    position: relative;\n    width: 100%;\n    height: 32px;\n    padding: 6px 10px;\n    margin-bottom: 3px;\n    border: 1px solid rgb(199, 199, 199);\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    -ms-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    background: var(--omega-dropdown-arrow) right 4px center no-repeat #fff;\n    background-size: 12px 12px;\n    border-radius: 3px;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    transition:\n        border-color ease-in-out 0.15s,\n        box-shadow ease-in-out 0.15s;\n}\n\n.omega-file-format-select::after {\n    position: absolute;\n    top: 50%;\n    right: 1rem;\n    width: 0;\n    height: 0;\n    margin-top: -2px;\n    border-width: 6px 6px 0;\n    border-style: solid;\n    border-color: #4b4742 transparent;\n    content: '';\n}\n\n.omega-file-format-column-order-section-header {\n    display: flex;\n    justify-content: space-between;\n}\n.omega-file-format-column-order-section-title {\n    font-size: 16px;\n}\n\n.omega-file-format-column-glossary {\n    position: relative;\n}\n\n.omega-file-format-column-glossary button {\n    font-size: 14px;\n    color: var(--omega-primary);\n    border: none;\n    background: none;\n    padding: 0;\n}\n\n#glossary-divider {\n    border-right: 1px solid rgb(197, 190, 190);\n    margin: 0 5px;\n    height: 20px;\n}\n\n/* LEGEND */\n.omega-file-format-legend {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    height: 25px;\n}\n\n.omega-file-format-legend:focus {\n    outline: none;\n}\n\n.omega-file-format-legend-detail {\n    position: absolute;\n    bottom: -15px;\n    right: -115px;\n    width: 200px;\n    background: #fff;\n    border: 1px solid rgba(0, 101, 207, 0.5);\n    box-shadow: 0 0 10px 0 rgba(57, 57, 57, 0.5);\n    border-radius: 4px;\n    padding: 5px 11px 15px 11px;\n    opacity: 0;\n    z-index: -10;\n    transform: translate(-50%, -50%) rotateX(-180deg);\n    transition: all 0.25s cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n\n.omega-file-format-legend-detail.show {\n    opacity: 1;\n    z-index: 100;\n    transform: translate(-50%, -50%) rotateX(0deg);\n    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.omega-file-format-legend-detail-header {\n    display: flex;\n    justify-content: flex-end;\n    color: rgb(168, 157, 157);\n    font-size: 14px;\n    margin-bottom: 3px;\n}\n\n.swatch {\n    position: relative;\n    display: inline-block;\n    height: 11px;\n    width: 11px;\n    border-radius: 50%;\n}\n\n.payment-information-swatch {\n    background-color: #19c466;\n}\n\n.beneficiary-information-swatch {\n    background-color: #00bde9;\n}\n\n.domestic-intermediary-swatch {\n    background-color: #a5a5a5;\n}\n\n.omega-file-format-legend .domestic-intermediary-swatch {\n    top: 12px;\n    right: 22px;\n}\n\n.omega-action-bar {\n    position: fixed;\n    left: 200px; /* only for the demo bc of nav sidebar - should remove this from here and stick in example*/\n    bottom: 0;\n    height: 55px;\n    width: 100%;\n    background: white;\n    border-top: 1px solid #e0e0e0;\n}\n\n/* GLOSSARY (MODAL) */\n.omega-modal {\n    position: fixed;\n    box-shadow: 0px 0px 8px 0px #333;\n    text-align: left;\n    background: #fff;\n    padding: 5px 20px;\n}\n\n.omega-modal-background {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: rgba(9, 17, 9, 0.75);\n    opacity: 0;\n    z-index: -1;\n    height: 100%;\n    width: 100%;\n    transition: all 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n\n.omega-modal-background.show {\n    display: block;\n    opacity: 1;\n    z-index: 10;\n    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n.omega-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.omega-modal-header-title {\n    width: 100%;\n    text-align: center;\n    font-size: 16px;\n    color: #5a5b5a;\n    font-weight: 600;\n}\n\n.omega-modal-header omega-button {\n    flex-shrink: 2;\n}\n\n#omega-file-format-glossary {\n    z-index: -1;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(0);\n    transition: all 0.5s cubic-bezier(0.6, -0.28, 0.735, 0.045);\n    height: 400px;\n    width: 525px;\n    border-radius: 4px;\n}\n\n#omega-file-format-glossary.show {\n    z-index: 11;\n    transform: translate(-50%, -50%) scale(1);\n    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n\n#omega-file-format-glossary ul {\n    list-style: none;\n    padding: 0 10px;\n}\n\n#omega-file-format-glossary li {\n    margin-top: 5px;\n}\n","@import url('./forms/forms.css');\r\n@import url('./table/table.css');\r\n@import url('./variables.css');\r\n@import url('./dialog.css');\r\n@import url('./account-lookup.css');\r\n@import url('./account-suggestions.css');\r\n@import url('./ach-company-lookup.css');\r\n@import url('./alert/alert.css');\r\n@import url('./forms/download-bar.css');\r\n@import url('./forms/drag-and-drop.css');\r\n@import url('./forms/icon-column.css');\r\n@import url('./layouts/file-format-designer.css');\r\n\r\n@font-face {\r\n    font-family: FontAwesome;\r\n    src:\r\n        url(fonts/fontawesome-webfont.eot) format('embedded-opentype'),\r\n        url(fonts/fontawesome-webfont.woff2) format('woff2'),\r\n        url(fonts/fontawesome-webfont.woff) format('woff'),\r\n        url(fonts/fontawesome-webfont.ttf) format('truetype'),\r\n        url(fonts/fontawesome-webfont.svg) format('svg');\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}\r\n\r\n.visually-hidden {\r\n    position: absolute !important;\r\n    overflow: hidden;\r\n    width: 1px;\r\n    height: 1px;\r\n    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */\r\n    clip: rect(1px, 1px, 1px, 1px);\r\n}\r\n\r\n.experimental {\r\n    display: inline-block;\r\n    outline: 2px dashed maroon !important;\r\n}\r\n\r\n.experimental .experimental {\r\n    outline: none !important;\r\n}\r\n\r\n@media print {\r\n    .omega-filter-print {\r\n        display: none;\r\n        height: 0;\r\n    }\r\n}\r\n","@import url('@treasury/omega/css/index.css');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:host {\n    display: block;\n}\n\n:root {\n    --safe-area-top: env(safe-area-inset-top);\n    --lumo-font-family: 'Roboto', sans-serif;\n}\n\nbody {\n    background: var(--container-primary, var(--brand-primary));\n    font-family: 'Roboto', sans-serif;\n    margin: 0;\n}\n\nhtml,\nbody,\napp-component,\nmain,\njhd-layout,\nnavigation-menu,\n#navigation-container,\n#navigation-background {\n    overflow: hidden;\n    height: 100vh; /* set fallback for browsers that don't support dvh units */\n    height: 100dvh;\n}\n\n.brand-color {\n    color: var(--brand-color);\n}\n.bg-brand-color {\n    background-color: var(--brand-color);\n}\n.card-footer {\n    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.15);\n    background: var(--container-primary);\n    padding: 10px 0 10px 0;\n    z-index: 2;\n}\n.edited,\n.edited-true {\n    background: var(--content-highlight);\n}\nomega-progress {\n    margin: auto;\n    border-width: 2px;\n    border-style: solid;\n    border-color: var(--omega-progress-color, var(--primary-text-color));\n    border-right-color: transparent !important;\n    top: 50%;\n    left: 50%;\n}\n\nvaadin-notification-card {\n    --lumo-space-wide-l: 1em;\n}\n\nhtml[theme='dark'] vaadin-multi-select-combo-box-overlay::part(overlay),\nhtml[theme='dark'] vaadin-select-overlay::part(overlay),\nhtml[theme='dark'] vaadin-date-picker-overlay::part(overlay) {\n    background-image: none;\n    background-color: var(--border-color);\n}\n\n/* Ensure Roboto font is used in select overlay items */\nvaadin-select-overlay vaadin-select-item::part(content) {\n    font-family: 'Roboto', sans-serif;\n}\n\nhtml[theme='dark'] vaadin-dialog-overlay::part(overlay),\nhtml[theme='dark'] vaadin-date-picker-overlay::part(overlay) {\n    box-shadow: var(--content-shadow);\n    background-color: var(--container-header);\n}\n\nvaadin-date-picker-overlay,\nvaadin-select-overlay,\nvaadin-multi-select-combo-box-overlay {\n    z-index: 2000;\n}\n\nhtml[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar {\n    color: var(--jh-color-gray-0);\n}\n\nhtml[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar::part(month-header) {\n    color: var(--tm-color-gray-light);\n}\n\nhtml[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar::part(weekday) {\n    color: var(--tm-color-gray-medium);\n}\n\nhtml[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar[disabled] {\n    --lumo-disabled-text-color: var(--tm-color-gray-light-15);\n}\n\nhtml[theme='dark'] vaadin-date-picker-overlay vaadin-month-calendar::part(disabled) {\n    color: var(--tm-color-gray-light-15) !important;\n}\n\n@media (max-width: 600px) {\n    .card-footer {\n        border-radius: 0;\n        padding: 0;\n    }\n}\n.feature-disabled {\n    opacity: 0.5;\n    pointer-events: none;\n    cursor: not-allowed;\n}\n.new-indicator,\n.unread-indicator {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: #0164cc;\n    margin-right: 5px;\n}\n\n/* PWA custom classes */\n.pwa-table-wrapper {\n    background-color: var(--container-primary);\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 12px;\n}\n\n.input-container {\n    background-color: var(--input-field-background);\n    border-radius: 4px 4px 0 0;\n    border-bottom: 1px solid var(--input-field-border);\n    padding: 0.5rem;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    width: fit-content;\n    color: var(--input-field-text);\n    font-weight: 500;\n}\n\n.input-container--disabled {\n    background-color: var(--input-field-background);\n    color: var(--input-field-disabled);\n    cursor: not-allowed;\n}\n\n/* PWA component rules */\ntm-form-row:not(:last-child),\ntm-form-row-message-center:not(:last-child),\ntm-form-frequency:not(:last-child) > tm-form-row {\n    border-bottom-color: var(--border-color);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\ntm-form-row:last-child,\ntm-form-row-message-center:last-child,\ntm-form-frequency:last-child > tm-form-row {\n    border-bottom-style: unset;\n    border-bottom-width: unset;\n}\ntm-form-frequency {\n    --disabled: var(--primary-30);\n}\ntm-form-frequency[theme='dark'] {\n    --disabled: var(--tm-color-gray-light-30);\n}\ntm-form-frequency .action-icon svg {\n    width: 100%;\n    height: auto;\n}\ntm-form-frequency .action-icon--disabled path {\n    fill: var(--disabled);\n}\n\n/* override vaadin defaults */\nvaadin-grid {\n    font-family: var(--default-font-family);\n}\nvaadin-notification-card:not([theme='error']),\nvaadin-notification-card:not([theme='warning']) {\n    margin-top: 70px;\n}\n\nvaadin-notification-card[role='alert'] + vaadin-notification-card[role='alert'] {\n    margin-top: 10px;\n}\n\nvaadin-notification-card .notification-content > div {\n    overflow: hidden;\n}\n\nvaadin-tooltip-overlay::part(overlay) {\n    border: 1px solid var(--jh-color-gray-500);\n}\n\nvaadin-context-menu-overlay.overrideDefault::part(overlay) {\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\nvaadin-context-menu-overlay.overrideDefault::part(content) {\n    padding: 0;\n    mask-image: none;\n}\n\n@media (max-width: 600px), (max-height: 600px) {\n    vaadin-context-menu-overlay::part(overlay) {\n        max-height: 50vh;\n        width: 100vw;\n    }\n    vaadin-context-menu-overlay::part(content) {\n        padding: 30px var(--lumo-space-m);\n        max-height: inherit;\n        box-sizing: border-box;\n    }\n}\n\n#mitekDisplayContainer {\n    z-index: 99998;\n    background-color: gray;\n}\n\n.integrator {\n    border: none;\n}\n\n#mitekHintMessage {\n    background: rgba(0, 0, 0, 0.6);\n    top: unset;\n    bottom: 0;\n    border: 1px solid white;\n    color: white;\n    padding: 4px 16px;\n    border-radius: 8px;\n    font-size: 0.95rem !important;\n    font-weight: normal;\n    text-wrap: nowrap;\n    transform: translate(-50%, -20%);\n    width: unset;\n}\n\n.leaving {\n    animation: 0.2s fadeOut ease-in-out;\n}\n\n.entering {\n    animation: 0.2s fadeIn linear;\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1;\n    }\n\n    to {\n        opacity: 0;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
